const kartheekapuranamData = [

    { 
      CatID: [
        {
          title: "#అథ ప్రథమాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "శ్లో|| వాగీశాద్యాస్సుమనసః సర్వార్థానాముపక్రమే|",
        },
        {
          title: "యన్నత్వా కృతకృత్యాస్స్యుః తం నమామి గజాననమ్||",
        },
        {
          title: "",
        },
        {
          title:<span class='highlight'>  ఋషయ ఊచుః :</span>,
        },
        {
          title: "",
        },
        {
          title: "శ్లో|| వశిష్ఠేన విదేహాయ కథితం బ్రూహినో మునే|",
        },
        {
          title: "శ్రోతుకామావయంత్వత్తః కార్తీకవ్రతముత్తమమ్||",
        },
        {
          title: "",
        },
        {
          title:
            "నైమిశారణ్యమందు సత్రయాగ దీక్షితులయిన శౌనకాది మహామునులు ఒకప్పుడు జనకునకు వశిష్ఠ మహాముని చేత చెప్పబడిన కార్తీక మహత్యమును సవిస్తారముగా మేము మీవలన వినగోరితిమి అని సూతుని అడిగిరి.",
        },
        {
          title: "",
        },
        {
          title:
            "సూతుడు ఇట్లు చెప్పెను. శౌనకాది సమస్తమునీశ్వరులారా! వినుడు. ఈ కార్తీకమహత్యమును వశిష్ఠమహాముని జనకమహారాజుకు చెప్పెను. పూర్వము నారదునకు బ్రహ్మయు, పార్వతికి శివుడు, లక్ష్మీదేవికి విష్ణువు చెప్పినారు. దీనివలన సమస్త సంపత్తులు ప్రాప్తించును. దీనిని విన్నవారు జననమరణ రూప సంసార బంధనమును త్రెంచుకుని మోక్షము పొందుదురు.",
        },
        {
          title: "",
        },
        {
          title:
            "ఒకానొకప్పుడు దైవవశముచేత సిద్ధాశ్రమమునకు పోవుచు వశిష్ఠమహాముని జనకమహారాజు గృహమునకు జేరెను. అంత జనకమహారాజు వచ్చిన వశిష్ఠుని చూచి సింహాసనమునుండి త్వరగా దిగి సాష్టాంగ దండ ప్రణామముజేసెను. సంతోష పులకాంకితుడై అర్ఘ్యపాద్యాదులచేత పూజించి మునిపాదోదకమును తన శిరస్సున చల్లుకొనెను. బంగారపు ఆసనమునిచ్చి వికసించిన తామరపువ్వుల వంటి కన్నులు గలవాడును, సమస్త జంతువులయందును దయగలవాడును, బాలసూర్యసమాన కాంతిగలవాడును, సమస్త సుగుణ సంపన్నుడును అగు మునికి భక్తి భావముతో ఇట్లని విన్నవించెను.",
        },
        {
          title: "",
        },
        {
          title:
            "బ్రాహ్మణోత్తమా! మీదర్శనము వలన ధన్యుడనైతిని. నేను చేయదగిన పుణ్యమింకేమియు లేదు. ఇప్పుడు మా పితరులందరును తృప్తినొందినారు. మహాత్ములయొక్క దర్శనము సంసారులకు దుర్లభము, కనుక ఇప్పుడు మీరాక నాకు శుభములకు కారణమైనది.",
        },
        {
          title: "",
        },
        {
          title:
            "సూతుడిట్లు చెప్పెను. తరువాత వశిష్ఠమహర్షి వికసించిన ముఖముగలవాడై దయతో గూడినవాడై సంతోషించి చిరునవ్వుతో ఇట్లని పలికెను. రాజోత్తమా! నీకు క్షేమమగుగాక. నేను మా ఆశ్రమమునకు బోవుచున్నాను. రేపు మా ఇంటివద్ద యజ్ఞముజరుగును. దానికి ద్రవ్యమును ఈయగోరుదును.",
        },
        {
          title: "",
        },
        {
          title:
            "ఆరాజిట్లు పల్కెను. మునీశ్వరా! యజ్ఞమునకు చాలా ద్రవ్యమును ఇచ్చెదను. గాని వినువారి పాపములను పోగొట్టు ధర్మరహస్యములను నీవలన వినగోరితిని. నీకు తెలియని ధర్మరహస్యములు లేవు కాబట్టి అధికఫలమునిచ్చెడి సూక్ష్మధర్మములను నాకు చెప్పుము. మునీశ్వరా! ధర్మజ్ఞా కార్తీకమాసము సమస్త మాసములకంటెను, సమస్త ధర్మములకంటెను ఎట్లధికమైనదో దానిని వినగోరితిని నాకు చెప్పుము.",
        },
        {
          title: "",
        },
        {
          title:
            "వశిష్ఠుడిట్లు పల్కెను. రాజా! పూర్వ పుణ్యమువలన సత్వశుద్ధి గలుగును. సత్వశుద్ధి గలిగిన పుణ్యమార్గమందు అభిలాషగలుగును. లోకోపకారార్థమై నీవడిగిన మాట చాలా బాగున్నది. చెప్పెదను. వినుము. విన్నంతనే పాపములు నశించును. సత్త్వగుణము కలుగును. రాజా! సూర్యుడు తులారాశియందుండగా కార్తీకమాసములో చేసిన స్నానము, దానము, అర్చనము మొదలైనవి మంచి మనస్సుతో ఏవి చేసినను అవి అక్షయములగునని మునీశ్వరులు చెప్పిరి. కార్తీకవ్రతమును తులాసంక్రమణము సూర్యుడు తులారాశిలో ప్రవేశించుట మొదలుకొని గాని, కార్తీక శుక్ల ప్రతిపత్ మొదలుకొని గాని, ఆరంభించి నెలరోజులు చేయవలెను. ",
        },
        {
          title: "",
        },
        {
          title:
            "ఆరంభమందు ఓ దామోదరా! నేను కార్తీకవ్రతము ఆరంభించుచున్నాను. దానిని నిర్విఘ్నముగా పూర్తిజేయుము అని సంకల్పము చేసి కార్తీకస్నానమారంభించవలెను. కార్తీకమాసమునందు సూర్యోదయసమయమున కావేరీనదియందు స్నానమాచరించిన వారికి మహాఫలము కలుగగలదు. సూర్యుడు తులారాశిని ప్రవేశించినతోడనే మూడులోకములను పవిత్రముజేయుచు గంగ ద్రవరూపమును ధరించి సమస్త జలములయందును ప్రవేశించును. తులారాశియందు కార్తీకమున చెరువులందును, దిగుడుబావులందును, నూతులందును, చిన్నకాలువలందును హరి నివసించియుండును. కార్తీకమందు వ్రతము అన్ని వర్ణాలవారు చేయవచ్చును.",
        },
        {
          title: "",
        },
        {
          title:
            "బ్రాహ్మణుడు కార్తీకమాసమందు గంగకుపోయి నమస్కరించి హరిని ధ్యానించి కాళ్ళుచేతులు కడుగుకొని ఆచమనము చేసి శుద్ధుడై మంత్రములచేత భైరవానుజ్ఞను పొంది మొలలోతు జలమందు స్నానము చేయవలెను. తరువాత దేవర్షిపితృతర్పణ మాచరించి హరిభక్తితో అఘమర్షణ మంత్రమును పఠించుచు బొటనవ్రేలి కొనతో ఉదకమును ఆలోడనము చేసి తీరమునకు వచ్చి అచ్చట యక్ష్మతర్పణమును చేసి ధరించిన వస్త్రమును పిడిచికట్టుకొని ఉదకమును వదలి ఆచమనము చేసి శిరస్సును వదలి మిగిలిన శరీరమంతయు తడి వస్త్రముతో తుడుచుకొని నారాయణ ధ్యానమాచరింపుచు ధౌతవస్త్రమును ధరించవలెను. తరువాత గోపీచందనముతో ఊర్ధ్వపుండ్రములను ధరించి సంధ్యావందనముచేసి గాయత్రీజపము చేయవలెను. స్త్రీలు గౌరీజపము చేయవలెను. తరువాత ఔపాసనముగావించి బ్రహ్మయజ్ఞము చేసి తన తోటలోనుండి పుష్పములు తెచ్చి శంఖచక్రములను ధరించిన హరిని భక్తితో సాలగ్రమమందు షోడశోపచారములతో పూజించవలెను. తరువాత కార్తీక పురాణమును పఠించి లేక విని ఇంటికి వెళ్ళి భక్తితో దేవతార్చన చేసి వైశ్వేదేవమును నెరవేర్చి భోజనము చేసి ఆచమనముగావించి, తరువాత పురాణకాలక్షేపమును చేయవలయును. సాయంకాలముకాగానే ఇతర వ్యాపారములన్నింటినీ ఆపివేసి, విష్ణాలయమునందుగాని, శివాలయమునందుగాని, తన శక్తి కొలది దీపములుబెట్టి భక్ష్యభోజ్యాదులతో స్వామిని పూజించి వాక్శుద్ధితో విష్ణుస్తోత్రమును గాని, శివస్తోత్రమునుగాని పఠించి నమస్కారములాచరించవలయును. ఎవడు కార్తీకవ్రతము భక్తితో చేయుచున్నాడో వాడు పునరావృత్తివర్జితమైన వైకుంఠమును పొందుచున్నాడు. పూర్వజన్మార్జితములున్ను, ఈజన్మార్జితములున్ను అయిన సమస్త పాపములు కార్తీకవ్రతమాచరించిన ఎడల నశించును. బ్రాహ్మణుడుగాని, క్షత్రియుడుగాని, వైశ్యుడుగాని, శూద్రుడుగాని, ఋషీశ్వరుడుగాని, స్త్రీలుగాని భక్తి శ్రద్ధలతో కార్తీకవ్రతమును జేసిన యెడల వానికి పునరావృత్తిలేని వైకుంఠమునొందుదురు. ఎవ్వడు కార్తీకవ్రతమాచరించు వానిని జూచి సంతోషించునో వానియొక్క పగటికాలమందాచరించిన పాతకము నశించును. ఇందుకు సందేహము లేదు.",
        },
        {
          title: "",
        },
        {
          title:
            "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే ప్రథమాధ్యాయస్సమాప్త:",
        },

      ],
      // img: require('../imgs/Astotaram/Karthikamasam.png'),
      // image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "ప్రథమాధ్యాయము",
        },
    {

      CatID: [
        {
          title: "#అథ ద్వితీయాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "శ్లో|| శ్రుణురాజన్ ప్రవక్ష్యామి మహత్యము కార్తీకస్యచ|",
        },
        {
          title: "కర్మత్రయ కృతాత్పాపాత్ ముచ్యతే శ్రవణాదపి||",
        },
        {
          title: "",
        },
        {
          title: "ఓ రాజా! కార్తీకమహత్యమును వినుము. విన్నంతనే మనోవాక్కాయములవలన చేయబడిన పాపమంతయు నశించును. కార్తీకమాసమందు శివప్రీతిగా సోమవార వ్రతమాచరించువాడు కైలాసనివాసియగును. కార్తీకమాసమున సోమవారమందు స్నానముగాని, దానమును గాని, జపమును గాని చేసినయెడల అశ్వమేధయాగముల ఫలమును పొందును. ఇందుకు సందేహములేదు. కార్తీకమాసమందు ఉపవాసము, ఒకపూట భోజనము, రాత్రి భోజనము, ఛాయానక్తభోజనము, స్నానము, తిలదానము, ఈఆరున్నూ ఉపవాస సమానములగునని ఋషులు చెప్పిరి. శక్తిగలవాడు కేవల ఉపవాసము చేయవలెను. అందుకు శక్తిలేనివాడు రాత్రిభోజనమును చేయవలెను. అందుకు శక్తిలేనివాడు చాయానక్తము జేయవలెను. అందు శక్తి లేనివాడు బ్రాహ్మణులకు భోజనముపెట్టి వారితో పగలే భోజనము చేయవలెను.",
        },
        {
          title: "",
        },
        {
          title: "ఛాయానక్తమనగా సూర్యకాంతి తగ్గిన తరువాత రెట్టింపు కొలతకు తన నీడ రాగానే పగలే భుజించుట. సాయంకాలము 4 ½ గంటలకు భుజించుట చాయానక్తమగును. మానవులు పైన చెప్పిన ఆరింటిలో దేనినయినను ఆచరించినయెడల ఎనిమిది యుగములు నరకమందు కుంభీపాకనరకములోను, రౌరవనరకములోను బాధలనొందుదురు. కార్తీక సోమవారమందు విధవ యధావిధిగా ఉపవాసముచేసి శివుని పూజించినట్లయిన శివలోకమునుబొందును. స్త్రీలుగాని, పురుషులుగాని ఎవరు కార్తీకసోమవారమందు నక్షత్రములను జూచి రాత్రి భోజనము చేయుదురో వారి పాతకములు అగ్నియందుంచబడిన దూదివలె నశించును. కార్తీకసోమవారమందు శివలింగమునకు అభిషేకమును, పూజయుచేసి రాత్రి భుజించువాడు శివునకు ప్రియుడగును. ఈవిషయమునందొక కథగలదు. చెప్పెద వినుము. ఇది వినువారికిని, చెప్పువారికిని పాపనాశనమగును.",
        },
        {
          title: "",
        },
        {
          title: "కాశ్మీరదేశమందొక పురోహితుని కుమార్తె స్వాతంత్ర్యనిష్ఠురియనునొక స్త్రీగలదు. అతి చక్కని రూపముతో మంచి యౌవనముతో గూడియుండి తలదువ్వుకొని అలంకరించుకొని బహుగా మాట్లాడుచూ జారిణియై ఉండెడిది. ఈమె దుర్గుణములను జూచి తల్లిదండ్రులును, అత్తమామలును ఆమెను విడిచిరి. ఆమె భర్త సౌరాష్ట్ర దేశశ్థుడు. అతని పేరు మిత్రశర్మ. అతడు వేదవేదాంగ పారంగతుడును, సదాచారవంతుడును, సమస్త భూతములందు దయగలవాడును, అనేక తీర్థములు సేవించినవాడు, అబద్ధమాడనివాడను, నిరంతరము దయగలవాడును భర్త ఇట్టి ఉత్తమగుణములు గలవాడైనప్పటికి ఆదుర్మార్గపు భార్య ఇతనిని నిత్యము కొట్టుచుండెడిది. అట్లు నిత్యము ఆమెచేత దెబ్బలు తినుచును, గృహస్థధర్మమందుండు కోరికచేత భార్యను విడువలేక ఆమెతో కష్టపడుచుండెడివాడు.",
        },

        {
          title: "",
        },
        {
          title: "ఋగ్వేదము, యజుర్వేదము, సామవేదము, అధర్వణవేదము, అంగములనగా శిక్ష, వ్యాకరణము, ఛందస్సు, నిరుక్తము, జ్యోతిష్యము, కల్పము వీటిని సంపూర్ణముగా చదివినవాడు వేదవేదాంగ పారగుడనబడును. ఈమిత్రశర్మ భార్యకు కర్కశయనియు నామముగలదు. భర్యయైన మిత్రశర్మయు సంభోగవాంఛచేత ఆమెయందు రాగముతోనుండెను. అంతనొకనాడు ఆమె రంకుమొగుడు ద్రవ్యములను నగలను వస్త్రములును తృప్తిగా ఇచ్చి నిరంతరము నీభర్తవల్ల భంగము గలుగుచున్నది గాన నీభర్తను చంపుమని చెప్పగా ఆమె సమ్మతించి రాత్రి భర్త నిద్రించగానే తానులేచి పెద్ద రాతిని తెచ్చి భర్త శిరస్సును కొట్టెను. ఆ దెబ్బతో అతడు మృతినొందెను. తరువాత కర్కశస్వయముగా తన భర్త శవము వీపుమీద వేసుకొని తీసుకొనిపోయి పాడునూతిలో పడవేసెను. ఇట్లు భర్తను చంపి తరుణులును పరస్త్రీ సంగమాభిలాషులును, కామశాస్త్ర ప్రవీణులును, వర్ణ సంకరకారకులును, అయిన అనేకజాతి పురుషులతో ఆలింగన చుంబనాదులతో నిత్యము సంభోగముచేయుచుండెడిది. ఇంతేగాదు భర్తయందనురాగముతో గూడియున్న భార్యలను దుర్బోధలచేత ఇతరులతో సంభోగము చేయించుచు ఏకపత్నీ వ్రతపరాయణులను భంగపరచి వారితో సంభోగించుచు నిత్యము పరనిందచేయుచు పరద్వేషము కలదై దేవతాద్వేషి అయియుండెను.",
        },
        {
          title: "",
        },
        {
          title: "నిరంతరము దయాశూన్యయై ఆడంబరము చేతగాని, నవ్వుచేతగాని, కపటముచేతగాని, విష్ణు పాదారవిందమును ధ్యానించలేదు. హరికథను విననూలేదు. ఇట్లుండగానే ఆమెకు యౌవనము పోయి ముసలితనము వచ్చినది. తరువాత వ్రణ వ్యాధి కలిగినది. ఆ కురుపునకు పురుగులు జనించి తరువాత దుర్గంధముతో కూడినదయ్యెను. తరువాత జారులందరు రూపవంతులు మదయుక్తులైవచ్చి చూచి విగతాశులై వేశ్య ఇంటికి వచ్చుట మానివేసిరి. తరువాత పాపాధిక్యముచేత చాలా బాధనొంది ఆవ్రణవ్యాధితోడనే మృతినొందెను. తరువాత భయంకరులయిన యమదూతలు వచ్చి ఆకర్కశను పాశములచేత కట్టి యమునికడకు తీసుకొని పోయి యమునికి అప్పగించిరి.",
        },
        {
          title: "",
        },
        {
          title: "యముడు దానిని చూచి కోపముచేత కళ్ళెర్రజేసి దీనిని భయంకరమగు ముళ్ళతో గూడినదియు, ఇనుముతో చేయబడిన స్తంభమును కాల్చి మండుచుండగా ఆలింగనము చేయించుడని కఠినమైన శిక్షను విధించెను. అంత యమాజ్ఞ మీద భటులు ఆకర్కశను చేసిన పాపములను జెప్పుచు ఆవేడి స్తంభమును సంభోగించుమనిరి. ఆమె పాదములు రెండు పట్టుకొని గిరగిర త్రిప్పి రాతిమీద కొట్టిరి. రక్తమును కాచి త్రాగించిరి. సీసమును కాచి రెండుచెవులలోను పోసిరి. యమకింకరులు యమాజ్ఞ, చిత్రగుప్తాజ్ఞలచే అనేక నరక బాధలకు గురిచేసిరి. ఆకర్కశ ఇట్లు తన పితృ పతామహులతోను, తన బాంధవులతో తనకు పూర్వము పదితరములు తరువాత పదితరముల వారితో ఘోరములందు నరకములందు మహాబాధలుపొంది తరువాత భూమియందు జన్మించెను. భూమియందు పదిహేనుమార్లు కుక్కగ జన్మించినది. అందులో పదిహేనవ జన్మ కళింగదేశమందు బ్రాహ్మణుని ఇంటివద్ద కుక్కగా పుట్టి యింటింటికి తిరుగుచుండెను.",
        },
        {
          title: "",
        },
        {
          title: "ఇట్లుండగా ఒకప్పుడు ఆ బ్రాహ్మణుడు కార్తీకమాసమందు సోమవారము దినంబున పగలంతయి ఉపవాసముచేసి గృహమునందు శివలింగాభిషేక పూజాదులను జేసి నక్షత్రమండలమును జూచి గృహమునకు బోయి దేవ నివేదన చేసి పిమ్మట బలిదానము కొరకు బయటకువచ్చి భూమిమీద బలిని ఉంచి కాళ్ళు కడుగుకొని ఆచమనము చేసి తిరిగి యింటిలోనికి వెళ్ళెను. ఆకుక్క ఆనాడు పగలంతయి ఆహారము కొద్దియైనను దొరకనందున కృశించినదై కార్తీకసోమవారము రాత్రి విప్రుడువేసిన బలిని భక్షించెను. ఆబలిభోజనముచేత కుక్కకు పూర్వజాతిస్మృతిగలిగి బ్రాహ్మణోత్తమా! రక్షింపుము. రక్షింపుమని పలికెను. ఆమాటవిని బ్రాహ్మణుడు బయటకు వచ్చి ఆశ్చర్యముతో గూడినవాడై ఓ శునకమా! మాఇంటిలో ఏమేమిచేసితివి. రక్షింపుమనుచున్నావు అని యడిగెను. కుక్క ఇట్లనెను.",
        },
        {
          title: "",
        },
        {
          title: "బ్రాహ్మణోత్తమా! వినుము. నేను పూర్వజన్మమందు బ్రాహ్మణస్త్రీని. పాపములను చేయుదానను. వర్ణసంకరము చేసినదానను. అన్యపురుషులను మరగి నిజభర్తను చంపితిని. ఈవిధిపాపములు అనేకములు చేసి చచ్చియమలోకమునకు పోయి అచ్చట అనేక బాధలనొంది తిరిగి భూమికి వచ్చి 15మార్లు కుక్కగా జన్మించితిని. చివరికి ఇప్పుడు నాకీ జాతిస్మరణ కలిగినది. ఎట్లు కలిగినదో చెప్పుము. విని తరించెదను. ఆబ్రాహ్మణోత్తముడీమాట విని జ్ఞానదృష్టితో చూచి తెలిసికొని యిట్లనియె.",
        },
        {
          title: "",
        },
        {
          title: "ఓ శునకమా! ఈకార్తీక సోమవారమునాడు ప్రదోషసమయము వరకు భుజింపక ఇప్పుడు నేను ఉంచిన బలిని భక్షించితివి గనుక నీకు జాతిస్మృతి గలిగినది. ఆమాటవిని కుక్క బ్రాహ్మణోత్తమా! ఈకుక్కజాతి నుండి నాకెట్లు మోక్షముగలుగునో చెప్పుమని విప్రుని అడిగెను. ఆ కుక్క ఇట్లు ప్రార్థించగా పరోపకార బుద్ధితో కార్తీకసోమవారములందు తానుజేసిన పుణ్యములో ఒక సోమవార పుణ్యమును కుక్కకు ధారపోసెను. బ్రాహ్మణుడు సోమవార పుణ్యమును ఈయగానే కుక్క దేహమును విడిచి ప్రకాశించుచున్న శరీరముగలదై ప్రకాశించెడి వస్త్రములను మాల్యములను, ధరించి ఆభరణాలంకృతయై తన పితరులతోగూడ కైలాసానికిబోయి అచ్చట పార్వతీదేవివలె శివునితోగూడ ఆనందించుచుండెను. కాబట్టి కార్తీకమాసమందు సోమవారవ్రతము ఆచరించదగినది. ఎవరు కార్తీక సోమవార వ్రతమును జేయుదురో వారికి మోక్షము హస్తమందుండును. కాబట్టి ఓ జనకమహారాజా! పుణ్యప్రదమైన కార్తీకవ్రతమును నీవు చేయుము.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే ద్వితీయోధ్యాయస్సమాప్త:",
        },
      ],
      // img: require('../imgs/Astotaram/Karthikamasam.png'),
      // image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "ద్వితీయాధ్యాయము",
        },
    {
      CatID: [
        {
          title: "#అథ తృతీయోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "శ్లో|| కార్తీకేమాసి రాజేంద్ర స్నానదాన జపాదికం|",
        },
        {
          title: "లేశంవాకురుతేమర్త్యః తదక్షయ్య ఫలం స్మృతమ్||",
        },
        {
          title: "",
        },
        {
          title: "ఓ జనకమహారాజా! వినుము. కార్తీకమాసమందు స్నానము, దానము, జపము మొదలయిన పుణ్యములలో ఏదయినను స్వల్పమైనా చేసినయెడల ఆస్వల్పమే అనంతఫలప్రదమగును. స్త్రీలుగాని, పురుషులుగాని, అస్థిరమైన శరీరమును నమ్ముకుని శరీరకష్టమునకు భయపడి కార్తీకవ్రతమును జేయని యెడల నూరుమారులు కుక్కగా పుట్టుదురు. కార్తీక పున్నమిరోజున స్నానదానములు ఉపవాసమును జేయని మనుష్యుడు కోటిమారులు చండాలుడై జన్మించును. అట్లు చండాలుడై పుట్టి చివకు బ్రహ్మ రాక్షసుడైయుండును. ఈవిషయమందొక పూర్వకథ గలదు. చెప్పెదను వినుము.",
        },
        {
          title: "",
        },
        {
          title: "ఆ ఇతిహాసము తత్వనిష్ఠునిదైయున్నది. గనుక దానిని వినుము. ఆంధ్రదేశమందు తత్వనిష్ఠుడను ఒక బ్రాహ్మణుడు గలడు. అతడు సమస్త శాస్త్రములను చదివినవాడు, అబద్ధమాడనివాడు, ఇంద్రియములను జయించినవాడు, సమస్త ప్రాణులందు దయగలవాడు, తీర్థయాత్రలందాసక్తి గలవాడు. రాజా! ఆబ్రాహ్మణుడు ఒకప్పుడు తీర్థయాత్రకుబోవుచు గోదావరీ తీరమందు ఆకాశమునంటియున్నట్లుండు ఒక మర్రిచెట్టు మీద ముగ్గురు బ్రహ్మరాక్షసులనుజూచెను. ఆ బ్రహ్మరాక్షసులకు తలవెంట్రుకలు పైకి నిక్కియున్నవి. నోరు వికటముగానున్నది. శరీరము నల్లగానున్నది. ఉదరము కృశించియున్నది. నేత్రములు, గడ్డము, ముఖము ఎర్రగానున్నవి. దంతములు పొడుగుగానున్నవి. చేతిలో కత్తులపైన పుర్రెలు కలిగి సర్వజంతువులను భయపెట్టుచుండిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఆరాక్షసుల భయముచేత ఆవటవృక్షమునకు ఆరుక్రోశముల దూరము లోపల మనుష్యులు పక్షులు మృగములు సంచరించుటయే లేదు. ఆవట సమీపమందు పర్వతసమాన శరీరులగు ఆ బ్రహ్మరాక్షసులు నిత్యమును పశువులు, పక్షులు, మృగములు మొదలయిన జంతుజాలములయొక్క ప్రాణములకు భీతిని గొల్పు భయంకర శబ్దములను జేయుచుండెడివారు. అనేక కార్తీక వ్రతములాచరించిన ఆ తత్త్వనిష్ఠుడు దైవవశముచేత మార్గమున పోవుచు మర్రిచెట్టుమీదనున్న ముగ్గురు బ్రహ్మరాక్షసులను జూచెను.",
        },
        {
          title: "",
        },
        {
          title: "తత్త్వనిష్ఠుడు భయపడి శ్రీహరి పాదారవిందములను స్మరించుచు దేవేశా! నన్ను రక్షించుము. లోకేశా!నారాయణా!అవ్యయా!నామొర ఆలకించుము. సమస్త భయముల నశింపజేయు. దేవా! నాభయమును పోగొట్టుము. నాకు నీవే దిక్కు. నీవు తప్ప నన్ను రక్షింపసమర్థులెవ్వరును లేరు. ఈప్రకారము హరిని గూర్చి మొరబెట్టుచు వారి భయమున పరుగెత్తుచున్న బ్రాహ్మణుని జూచి బ్రహ్మ రాక్షసులు వానిని భక్షించు తలంపుతో అతనివెంబడి పరుగెత్తసాగిరి. ఇట్లు కొంతదూరము పోగానే వెనుకకు తిరిగిన ఆబ్రాహ్మణుని దర్శనము వలన బ్రహ్మ రాక్షసులకు జాతి స్మృతిగలిగినది.",
        },
        {
          title: "",
        },
        {
          title: "ఓ రాజా! తరువాత వారు ఆ బ్రహ్మణునిముందు భూమియందు దండప్రణామములాచరించి అంజలిపట్టి నమస్కరించి అనేక వాక్యములతో ఇట్లనిస్తుతించిరి. బ్రాహ్మణోత్తమా! మీదర్శనమువలన మేము పాపరహితులమైతిమి. మీరాక మాకు ఉపకారము కొరకయినది. అది న్యాయమే, మహాత్ములు జీవించుట యాత్ర చేయుట లోకమును ఉద్ధరించుటకొరకే ఉపకారము కొరకే అగునుగదా. బ్రాహ్మణుని మాటలను విని భయమును వదలి మంచి మనస్సుతో ఇట్లనియెను. మీరెవ్వరు. ఏకర్మచేత మీకిట్టి వికృతరూపములు గలిగినవి. లోకనిందితమైన ఏకర్మను మీరు పూర్వమందు చేసినారు. భయమును వదలి సర్వమును నాకు జెప్పుడు. తరువాత రాక్షసులు తాము చేసిన నింద్య కర్మలను వేరువేరుగా తలంచుకొని ఆబ్రాహ్మణునితో ఇట్లని విన్నవించిరి. మొదటి బ్రహ్మరాక్షసుడు ఇట్లు పల్కెను.",
        },
        {
          title: "",
        },
        {
          title: "అయ్యా నేను పూర్వజన్మమందు ద్రావిడదేశములో మందరమను గ్రామమునకు గ్రామాధికారిని. బ్రాహ్మణులలో నీచుడను. కఠినముగా మాటలాడువాడను. ఇతరులను వంచించు మాటలను మాట్లాడుటలో నేర్పరిని. నాకుటుంబలాభము కొరకు బ్రాహ్మణుల ధనమును చాలా అపహరించితిని. బంధువులకు గాని, బ్రాహ్మణులకు గాని ఒకనాడయినను అన్నమును బెట్టియెరుగను. బ్రాహ్మణులసొమ్ము స్నేహముచేత హరించుటచేత ఏడుతరములు కుటుంబము నశించును. దొంగతనముగా బ్రాహ్మణుల ధనమపహరించిన యెడల సూర్యచంద్ర నక్షత్రములుండు వరకు కుటుంబము నశించును. తరువాత మృతినొంది యమ బాధలను అనేకములనొందితిని. ఆదోషము చేతనే భూమియందు బ్రహ్మరాక్షసుడనై జన్మించితిని. కనుక బ్రాహ్మణోత్తమా! ఈ దోషము నశించు ఉపాయమును విచారించి చెప్పుము.",
        },
        {
          title: "",
        },
        {
          title: "అందులో రెండవవాడిట్లు చెప్పెను. అయ్యా నేను ఆంధ్రదేశమందుండువాడను. నేను నిత్యము తల్లిదండ్రులతో కలహించుచుండి వారిని దూషించుచుండువాడను. ఇదిగాక నేనును, నా భార్యాపిల్లలును, షడ్రసోపేతమైన అన్నమును భుజించుచు నాతల్లిదండ్రులకు మాత్రము చద్ది అన్నమును పెట్టుచుండువాడను, బంధువులకుగాని, బ్రాహ్మణులకుగాని, ఒకనాడయినను అన్నమును పెట్టినవాడనుకాను మరియు ధనమును విస్తారముగా ఆర్జించియుంటిని. పిమ్మట నేను చనిపోయి యమలోకమందు ఎనిమిదియుగముల వరకు యమబాధలనుబొంది బ్రహ్మరాక్షసుడనై భూమియందు జన్మించితిని. ఓ బ్రాహ్మణోత్తమా! నాకీపాపము తొలగు ఉపాయము జెప్పి నన్ను ఉద్ధరింపుము.",
        },
        {
          title: "",
        },
        {
          title: "తరువాత మూడవవాడు నమస్కరించి తనస్థితిని ఇట్లు చెప్పెను. అయ్యా! నేను ఆంధ్రదేశ నివాసిని. బ్రాహ్మణుడను. విష్ణాలయమందు స్వామికి అర్చకుడను. స్నాన సంధ్యావందనములను విడిచి స్వామి పూజను వదలి పరనిందలను జేయుచు విశేషముగా మాటలాడుచు కఠినుడనై దయాశూన్యుడనై తిరుగుచు దేవాలయమందు భక్తులు వెలిగించు దీపములలోని నెయ్యి, నూనెను అపహరించి వేశ్యాగృహమందు దీపములను పెట్టి ఆనేతిని వేశ్యకు ఇచ్చి దేవతా నివేదితాన్నమును అపహరించి దానితో సంభోగించుచుండువాడను. ఆ దోషముచేత నరకములందు అనేక యాతనలను అనుభవించి తరువాత భూమికి వచ్చి నానా జన్మలందు జన్మించి చివరికి బ్రహ్మ రాక్షసుడనై బుట్టి ఈ మర్రిమీద ఉంటిని, కనుక సమస్త భూతదయాపరా ఓ బ్రాహ్మణోత్తమా! నన్ను రక్షించు, నాకీ బ్రహ్మరాక్షస జన్మమును నశింపజేయుము.",
        },
        {
          title: "",
        },
        {
          title: "తత్త్వనిష్ఠుడిట్లు బ్రహ్మరాక్షసుల మాటలను విని ఆశ్చర్యమునొంది మీకు కొంచెమైనను భయములేదు. మీదుఃఖము పోగొట్టెను. నేను కార్తీక స్నానార్థము పోవుచున్నాను. నాతో మీరుకూడా రండి అని వారిని తీసుకొనిపోయి కావేరి నదిలో బ్రహ్మరాక్షసుల నిమిత్తము రాక్షసులచే గూడ స్నానము చేయించి వారికి బ్రహ్మరాక్షసత్వమును నశింపజేసెను.",
        },
        {
          title: "",
        },
        {
          title: "అముకానాం బ్రహ్మరాక్షసత్త్వ నివారణార్థం అస్యాం కావేర్యాం ప్రాతస్స్నానమహం కరిష్యే ఇట్లు సంకల్పము చేసి ఆబ్రాహ్మణుడు విధిగా స్నానము చేసి ఆ రాక్షసుల కొరకు ఆ ఫలమిచ్చెను. ఆ క్షణముననే ఆముగ్గురు దోషవిముక్తులై దివ్య రూపములను ధరించి వైకుంఠలోకమునకు బోయిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఓ జనకమహారాజా! వినుము. మోహము చేతగాని, అజ్ఞానముచేత గాని కార్తీకమాసంబున శుక్ర నక్షత్రముదయించినప్పుడు (తెల్లవారుఝామున) సూర్యోదయకాలమందు కావేరీనది యందు స్నానము చేసి పిమ్మట శ్రీ విష్ణుపూజను జేసిన వానికి పదివేల యజ్ఞములు చేసిన ఫలము కలుగును. ఇందుకు సందేహము లేదు. కార్తీకమాసమందు ఏదో ఒక ఉపాయము చేత కావేరీ స్నామును తప్పక చేయవలయును. కార్తీకమాసమందు దామోదరప్రీతిగా ప్రాతస్నానముజేయని వాడు పదిజన్మలందు చండాలుడై జన్మించి తరువాత ఊరపందిగా జన్మించును. కాబట్టి స్త్రీగాని, పురుషుడుగాని కార్తీకమాసమందు ప్రాతస్నానము తప్పక చేయవలెను. ఈ విషయమై ఆలోచన చేయపనిలేదు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే తృతీయోధ్యాయస్సమాప్త:",
        },
      ],
      // img: require('../imgs/Astotaram/Karthikamasam.png'),
      // image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "తృతీయోధ్యాయము",
      },
    {
      CatID: [
        {
          title: "#అథ చతుర్థధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "జనకుడిట్లడిగెను. వశిష్టమునీంద్రా! నీఒక్క వాక్సుధా రసమును పానము చేయుచున్న నాకు తృప్తి తీరలేదు. కాన తిరిగి కార్తీక వ్రత పుణ్యమును తెలుపుము. ఆకార్తీకమందు ఏ దానమును చెయ్యవలెనో దానిని గోరి వ్రతము ఆచరించవలయునో చెప్పుము అని వశిష్ఠుడు ఇట్లు పలికెను. పాపములను నశింప జేయునదియు, పుణ్యమును వృద్ధిబొందించునదియు అయిన కార్తీకవ్రతమును ఇంకా చెప్పెదను వినుము. కార్తీకమాసమునందు సాయంకాలమున శివాలయమందు దీపారాధన చేసినచో అనంత ఫలము కలుగును. కార్తీకమాసమందు శివాలయంలో గోపుర ద్వారమందును, శిఖరమందును ఈశ్వర లింగ సన్నిధియందును దీపారధన చేసిన యెడల సమస్తపాపములు నశించును. ఎవ్వడు కార్తీకమాసమునందు శివాలయంలో ఆవునేతితో గాని, నేతితోగాని, నువ్వునూనెతో గాని, విప్పనూనెతో గాని, నారింజనూనెతో గాని భక్తితో దీపసమర్పణము చేయునో వాడే ధన్యుడు. వాడు ధర్మజ్ఞుడు, ధర్మాత్ముడును అగును. పూర్వోక్తములయిన నూనెలు సంభవించినచో ఆముదముతోనయినా దీపమును సమర్పించిన యెడల పుణ్యవంతుడగును. కార్తీకమాసమందు శివాలయంలో మోహముచేతగాని, బడాయికి గాని భక్తితో గానీ దీపమిచ్చువాడు శివప్రియుడగును. సందేహములేదు.",
        },
        {
          title: "",
        },
        {
          title: "పూర్వకాలమందు పాంచాల దేశమందు కుబేరునితో సమానమైన ఒక రాజుగలడు. సంతానము లేక గోదావరీతీరమందు తపస్సు చేసెను. గోదావరీ స్నానార్థమై పైప్పమహాముని అచ్చటికి వచ్చి చూచి, రాజా! ఎందుకు తపస్సు చేయుచున్నావని యడిగెను. ఆమాట విని రాజు మునీశ్వరా నాకు సంతానము లేదు గాన సంతానము కొరకు తపస్సు చేయుచున్నానని చెప్పెను. బ్రాహ్మణుడు రాజుతో ఇట్లు పల్కెను. రాజా! భక్తితో బ్రాహ్మణులను, శివున్ని సంతోషపెట్టుము. అట్లయిన యెడల నీకు పుత్రసంతానము కలుగును. ఇట్లు పైప్పలముని చెప్పగ ఆ రాజు విని ఆనందసాగరమగ్నుడై నమస్కరించి ఇంటికి వెళ్ళి స్నానము చేసి అలంకృతుడై శివప్రీతిగా దీపదానములను జేసెను. పిమ్మట ఆ పుణ్యముచేతనే రాజుభార్య గర్భవతియై పదియవమాసమున రెండవ సూర్యుడువలె ప్రకాశించెడి ఒక పుత్రునిగనెను. ఆరాజు విని అధికానందమును బొంది కార్తీక మహత్యము సత్యమైనది ఈకార్తీకవ్రతము ధర్మార్ధ కామమోక్షములనిచ్చును. సమస్త భూతములకు కార్తీకమాసము శుభప్రదము అని వచించెను. తరువాత రాజు కుమారునకు శత్రుజిత్ అను నామకరణము చేసి బ్రాహ్మణులను గోభూధానాదులతో పూజించెను. తరువాత బాలుడు క్రమముగా వృద్ధినొంది యౌవనవంతుడై శూరుడై సుందరుడై వేశ్యాసంగలోలుడై అంతట తృప్తిలేక పరస్త్రీలయందు ఆసక్తి గలిగి ధనాదికమునిచ్చి వారిని లోబరచుకొని సంభోగించెడివాడు. ఇది తగదని చెప్పిన గురువులను, బ్రాహ్మణులను ధిక్కరించి జాతిని విడిచి జాతి సంకర కారకుడై దేవప్రతిమను నిందించుచు కఠినముగా మాట్లాడుచు నిరంతరము కత్తిని చేత ధరించి అడ్డము వచ్చినవారిని హింసించుచు అన్యాయ మార్గవర్తనుడై యుండెను.",
        },
        {
          title: "",
        },
        {
          title: "ఇట్లుండగా ఆ గ్రామమందొక బ్రాహ్మణోత్తముని భార్య బహు చక్కనిది సింహము యొక్క నడుము వంటి నడుముగలది. పెద్దకన్నులు గలది. పెద్దవైన పిరుదులును, కుచములును గలదియు, అరటి స్థంభములవంటి తొడలు గలదియు, చిలుకకువలె సుస్వరమైన వాక్కు గలదియు, మన్మధోద్రేకముగలదై యుండెను. ఆ రాజకుమారుడు అట్టి విప్రభార్యను జూచి దాని సౌందర్యమునకు సంతోషించి దానియందాసక్తిగలవాడాయెను. బ్రాహ్మణుని భార్యయు రాజకుమారునందాసక్తి గలదాయెను. తరువాత ఆ బ్రాహ్మణుని భార్య అర్ధరాత్రమందు భర్తను విడిచి రాజకుమారునియొద్దకుబోయి అతనితో రాత్రిశేషమంతయు సంభోగించి ఉదయానికి పూర్వమే తిరిగి ఇంటికి వచ్చెను. ఈ ప్రకారముగా అనేకదినములు జరిగినవి. ఆసంగతి బ్రాహ్మణుడు తెలుసుకొని నిందితమైన నడతగల భార్యను, దానిని మరిగిన రాజకుమారుని చంపుటకు గాను కత్తిని చేత ధరించి ఎప్పుడు చంపుటకు వీలుదొరుకునాయని కాలమును ప్రతీక్షించుచుండెను. ఇట్లు కొంతకాలము గడచిన తరువాత ఒకప్పుడు శివాలయాన కార్తీకపూర్ణిమ సోమవారమునాడు బ్రాహ్మణిక్తన చీరె అంచును చింపి వత్తిని చేసెను. రాజకుమారుడు ఆముదము తెచ్చెను. ఆవత్తితో జాచిన్నది దీపము వెలిగించి అరుగుమీద పెట్టెను. అచ్చటే వారిద్దరూ కామశాస్త్ర ప్రకారము సంభోగమును అత్యుత్సాహముతో చేసి సుఖించిరి. అంత బ్రాహ్మణుడు కత్తిని ధరించి వెళ్ళి మారువేషముతో జీర్ణ శివాలయమందు దూరి తలుపులు గట్టిగా బిగించి కత్తితో ముందుగా రాజకుమారుని పొడిచి తరువాత భార్యను నరికెను. అంతలో రాజకుమారుడు కొంచెము జ్ఞప్తి తెచ్చుకొని కత్తితో బ్రాహ్మణుణినరికెను.",
        },
        {
          title: "",
        },
        {
          title: "ఇట్లు పరస్పర వ్యాఘాతములచేత ఆజీర్ణదేవాలయమందు ముగ్గురు మృతినొందిరి. ఆ దినము కార్తీకపూర్ణిమ సోమవారము. దైవవశము చేత అట్టి పర్వమందుముగ్గురికి శివుని సన్నిధియందు మరణము గల్గినది. అంతలో పాశ హస్తులై యమకింకరులు వచ్చిరి. అంతలోనే రుద్రుని నేత్రాలతో భయమునిచ్చువారై శివకింకరులును వచ్చిరి. తరువాత శివదూతలు రాజకుమారుని, బ్రాహ్మణ భార్యను విమానముమీద నెక్కించిరి. యమదూతలు బ్రాహ్మణుని కాళ్ళు గట్టి తీసికొనపోవ ప్రయత్నించిరి. ఇట్లు తన భార్యకు రాజకుమారునకు కైలాసగమనమును, తనకు యమలోకగమనము జూచి బ్రాహ్మణుడు శివదూతలారా! ఈనాభార్య జారిణి. ఈరాజకుమారుడును జారుడుగదా. నేను బ్రాహ్మణుడను సదాచారవంతుడను గదా, ఇట్లుండ నాకీగతియేమి, వారికాగతియేమి అని యడిగెను. శివదూతలిట్లనిరి. బ్రాహ్మణోత్తమా! నీవన్నమాట సత్యమేగాని అందొక విశేషమున్నది చెప్పదము వినుము. ఈ నీభార్య పాపాత్మురాలును జారిణియు అయినప్పటికి కామమోహముచేత కార్తీకపూర్ణిమ సోమవారము నాడు శివాలయమునందు దీపారాధనకు గాను తన చీరెను చించి వత్తిని చేసి ఇచ్చినది గాన దీని పాపములన్నియు భస్మములయినవి. ఈ రాజకుమారుడును దీపార్థమై ఆముదమును దెచ్చి పాత్రలోనుంచి ఇచ్చినందున క్షీణపాపుడాయెను. కాబట్టి కామమోహము చేయనయినా శివాలయమందు దీపదానము చేసిన వాడు ధన్యుడు. సర్వయోగులందు అధికుడగును. కనుక దీపార్పణము చేత నీభార్యకు రాజకుమారునకు కైలాసమును, దీపదానము చేయనందుకు నీకు నరకము సిద్ధించినది. ఇది వరకు నీవెంత శుద్ధముగానున్నను వారితో సమానుడవుగా లేదు. ధర్మసూక్ష్మమిదియని చెప్పిరి.",
        },

        {
          title: "",
        },
        {
          title: "శివదూతలు ఈ ప్రకారముగా చెప్పిన మాటలను విని రాజకుమారుడు దయావంతుడై అయ్యో! ఈ బ్రాహ్మణుని భార్యతో రమించి ఈ బ్రాహ్మణునిచేత శివాలయమందు హతుడనైన నాకు కైలాసము. ఇతనికి నరకము గలుగుట చాలా దుఃఖకరముగా నున్నది. కాబట్టి నా దీపదాన పుణ్యమును కొంత ఈ బ్రాహ్మణునకు ఇచ్చెదను. ఏకకాలమందు మృతినొందిన మాముగ్గురికి సమానగతియే ఉండవలెను. ఇట్లని ఆలోచించి తన దీపదాన పుణ్యమును బ్రాహ్మణునకు కొంత ఇచ్చెను. ఆ పుణ్యము చేత బ్రాహ్మణుడు దివ్యమైన విమానమెక్కి కైలాసమునకు పోయెను. అజ్ఞానముతో చేయబడిన యొక దీపదానముచే ముగ్గురు కైలాసమునకుబోయిరి. కాబట్టి కార్తీకమాసమున ధర్మమును జేయవలెను. అట్లు చేయనివాడు రౌరవనరకమును బొందును. కార్తీకమాసమందు నిత్యము శివాలయమందుగాని, విష్ణాలయమునందుగాని దీపమాలను సమర్పించిన యెడల దీపదాన పుణ్యముతో జ్ఞానమును బొంది తద్వారా పునరావృత్తిరితమగు మోక్షమునొందును. సందేహములేదు. కార్తీకమాసమందు హరిసన్నిధిలో స్త్రీలుగాని, పురుషులుగాని తన శక్తికొలది దీపార్పణము చేసినయెడల సర్వపాపనాశనము కలుగును. కాబట్టి నీవును శివాలయమందు కార్తీకమాసమున దీపముల పంక్తి సమర్పించుము.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే చతుర్థోధ్యాయస్సమాప్త:",
        },
      ],
      // img: require('../imgs/Astotaram/Karthikamasam.png'),
      // image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "చతుర్ధాధ్యాయము",
        },
    {
      CatID: [
        {
          title: "#అథ పంచమాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "వశిష్ఠుడు తిరిగి ఇట్లు చెప్పెను. ఓ జనకమహారాజా! వినుము. కార్తీకమాసమందు పాపక్షయము కొరకు పుణ్యమును జేయవలయును. పుణ్యముచేత పాము నశించుటయేగాక పుణ్యమధికమగును. కార్తీకమందు హరిసన్నిధిలో భగవద్గీతా పారాయణమును చేయువాడు పాము కుబుసమువలెపాపములను విడుచును. ఈమాసమందు తులసీ దళములతోను, తెల్లనివి నల్లనివి అయిన అవిశపూలతో, కరవీర(గన్నేరు) పూలతో హరిని పూజించినయెడల వైకుంఠమునకు బోయి హరితో గూడా సుఖించును. భగవద్గీతయందు విభూతి విశ్వరూప సందర్శనాధ్యాయములను హరి సన్నిధిలో పారాయణ చేయువాడు వైకుంఠలోకమునకు అధిపతియగును. హరిసన్నిధిలో శ్లోకముగాని, శ్లోక పాదముగాని, పురాణము చెప్పిన వారును, విన్నవారును కర్మబంధ వినిర్ముక్తులగుదురు.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీకమాసమందు శుక్లపక్షమందు వనభోజనము చేయువారికి సమస్త పాపములు నశించును. ఇతర కాలములలో జపకాలమందు, హోమకాలమందు, పూజాకాలమందు, భోజనకాలమందు, తర్పణకాలమందు, చండాలురయొక్కయు, పాపాత్ములయొక్కయు, శూద్రులయొక్కయు, అశౌచవంతులయొక్కయు సంభాషణలను వినినచో దోషపరిహారము కొరకు కార్తీకమాసమునందు వనభోజనమాచరించవలయును. అనేక జాతి వృక్షములతో గూడిన వనమందు ఆమలక(ఉసిరిక) వృక్షమువద్ద సాలగ్రామము నుంచి గంధపుష్పాక్షతాదులతో పూజించి శక్తి కొలది బ్రాహ్మణులను పూజించి భోజనము చేయవలెను. ఇట్లు కార్తీకమాసమందు వనభోజనము చేసినయెడల ఆయాకలమునందు చేసిన సమస్త పాపములు నశించి విష్ణులోకమునందు సుఖముగా నుండును. కాబట్టి తప్పక ఈమాసమందు వనభోజనమాచరించ వలయును. కార్తీకమహత్యమును భక్తితో విని బ్రాహ్మణుని కుమారుడు నీచ జన్మనుండి విముక్తుడాయెను. ఆకథ చెప్తాను వినుము అని వశిష్ఠుడు జనకమహారాజుకు ఈ విధంగా చెప్పెను.",
        },
        {
          title: "",
        },
        {
          title: "కావేరీ తీరమందు దేవశర్మయను బ్రాహ్మణుడు వేదవేదాంగ పారంగతుడు గలడు. ఆ దేవశర్మకు దురాచారవంతుడగు ఒక కుమారుడు గలడు. అతని దుర్మార్గమును జూచి తండ్రి నాయనా! నీకు పాపములు నశించెడి ఒక మాటను చెప్పెదను. కార్తీకమాసమందు ప్రాతస్నానము చేయుము. సాయంకాలమునందు హరిసన్నిధిలో దీపములను సమర్పించుము. ఈ లాగున తండ్రిచెప్పిన మాటలను విని కుమారుడు కార్తీకమాస ధర్మమనగా యేమి ఇట్టి కార్యమునాచే ఎన్నటికీ చేయతగదు, ఆమాట విని తండ్రి ఓరి దుర్మార్గుడా! ఎంతమాట అంటివిరా, నీవు అరణ్యమందు చెట్టుతొర్రలో ఎలుకవై పుట్టి ఉండుమని శపించెను. తండ్రి శాపమును విని కుమారుడు పశ్చాత్తాప పడి శాప విముక్తి దురాచారుడనైన నాకు ఎట్లు కలుగును అని తండ్రిని అడిగెను. ఆ తండ్రి ఇట్లనెను. కుమారా! ఎప్పుడు నీవు కార్తీక మహత్యమును వినెదవో అప్పుడు నీకు మూషకత్వ విముక్తి గలుగునని చెప్పెను. తండ్రి ఇట్లు చెప్పి ఊరకున్నంతలో కుమారుడు గజారణ్యమందు ఎలుక అయ్యెను. చెట్టుతొర్రలో నివసించెను. అది అనేక జంతువులకు ఆధారమైనది.",
        },
        {
          title: "",
        },
        {
          title: "ఇట్లు కొంతకాలము గడచిన తరువాత ఒకప్పుడు విశ్వామిత్ర మునీశ్వరుడు శిష్యులతో సహా కార్తీకస్నానమాచరించి ఆ వృక్షముయొక్క మొదట కార్తీకమహత్యమును భక్తితో చెప్పుచుండెను. అంతలో దురాచారుడును, హింసకుడును అగు ఒక కిరాతుడును వేటనిమిత్తము అచ్చటికి వచ్చి బ్రాహ్మణులను జూచి పాపాత్ముడు గనుక దయాశూన్యుడై వారిని జంప నిశ్చయించెను. అంతలో విశ్వామిత్రాది ముని సందర్శనము వలన వానికి జ్ఞానము కలిగి సంతోషించి అయ్యా ఏమిటి ఈపనివల్ల ఏమిఫలము అనియడిగెను. కిరాతా! వినుము చెప్పెదను. నీబుద్ధి మంచిదైనది. ఇది కార్తీకధర్మము. ఈ ధర్మము మనుష్యులకు కీర్తి పెంపొందించును. కార్తీకమాసమందు మోహముచేతనైనను స్నానదానాదికమును జేసినవాడు పాపవిముక్తుడై వైకుంఠమును జేరును. ఈ మాసమందు భక్తిశ్రద్ధలతో కూడినవాడై స్నానదానాదివ్రతము ఆచరించువాడు జీవన్ముక్తుడగును. విశ్వామిత్రుడు ఇటుల కిరాతుని గురించి చెప్పిన కార్తీక ధర్మమును వృక్షము మీదనున్న ఎలుక విని అప్పుడే నీచదేహమును విడిచి విప్రుడయ్యెను. విశ్వామిత్రుడది చూచి ఆశ్చర్యమునొందెను. తరువాత బ్రాహ్మణ కుమారుడు తన వృత్తాంతమునంతను విశ్వామిత్రునికి దెల్పి అనుజ్ఞ తీసుకొని తన ఇంటికిబోయెను.",
        },

        {
          title: "",
        },
        {
          title: "కిరాతుడును మూషకదేహత్యాగమును బట్టి కార్తీకవ్రత ఫలమును, తరువాత మునివలన సకల ధర్మములను విని వైకుంఠము జేరెను. సుగతిని గోరువాడు కార్తీకమహత్యమును వినవలెను. విన్నంతనే పుణ్యవంతులై పరమపదము పొందెను. కాని విద్వాంసుడు తెలిసి కార్తీక ధర్మమును విని అభ్యసించవలెను. కాబట్టి తప్పక కార్తీకవ్రతము ఆచరించదగినది. ఇది నిజము. నాకు బ్రహ్మ చెప్పినాడు. రాజా! నీవును పురాణములందు బుద్ధినుంచుము. అట్లయిన యెడల పుణ్యగతిక బోవుదువు. ఈ విషయమై విచారణతో పనిలేదు. నిశ్చయము.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే పంచమోధ్యాయస్సమాప్త:",
        },
      ],
      // img: require('../imgs/Astotaram/Karthikamasam.png'),
      // image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "పంచమాధ్యాయము",
      },
    {
      CatID: [
        {
          title: "#అథ షష్ఠమాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "వశిష్ఠుడు మరల ఇట్లనెను. ఓ జనకమహారాజా! కార్తీకమాసమందు భక్తితో మాసమంతయు హరికి కస్తూరితోను, గంధముతోను, పంచామృతములతోను, స్నానము చేయించువాడు పదివేల అశ్వమేధయాగముల ఫలమును బొంది తుదకు పరమపదమును పొందును. సాయంకాలమున హరిసన్నిధిలో దీపదానము ఆచరించువారు విష్ణులోకమును బొందుదురు. ఈ మాసమందు దీపదానము జేసిన వారు జ్ఞానమును బొంది విష్ణులోకమును బొందుదురు. ప్రత్తిని చక్కగా ధూళిలేకుండా విడదీసి వత్తిని చేసి బియ్యపుపిండితో గాని, గోధుమపిండితో గాని పాత్రను జేసి గోఘృతమును బోసి వత్తిని తడిపి వెలిగించి వేదబ్రాహ్మణునికి పూజించి ఇవ్వవలెను. ఇట్లు మాసమంతయు చేసి అంతమందు వెండితో పాత్రను జేయించి బంగారముతో వత్తిని చేయించి బియ్యపు పిండిలో మధ్యగా ఉంచి పూజించి నివేదించి తరువాత బ్రాహ్మణ భోజనముగావించి తరువాత తాను స్వయముగా ఈ క్రింది మంత్రమును జెప్పుచు ఆ దీపమును దానము జేయవలెను.",
        },
        {
          title: "",
        },
        {
          title: "శ్లో|| సర్వజ్ఞానప్రదం దీపం సర్వ సంపచ్ఛుభావహం|",
        },
        {
          title: "దీపదానం ప్రదాస్యామి శాంతిరస్తు సదా మమ||",
        },
        {
          title: "",
        },
        {
          title: "దీపము సర్వజ్ఞానదాయకము. సమస్త సంపత్ప్రదాయకము. కనుక నేనిప్పుడు దీపదానమును జేయుచున్నాను. దీనివల్ల నాకు నిరంతరము శాంతి కలుగుగాక. ఈ ప్రకారముగా స్త్రీగాని, పురుషుడుగాని, కార్తీకమాసమందాచరించిన యెడల అనంతఫలమును బొందుదురు. దీపమును పెట్టిన వారు విద్యను శాస్త్రఫలమును, ఆయుస్సును, స్వర్గమును, సమస్త సంపత్తులను పొందుదురు. కార్తీక దీపదానమువలన మనోవాక్కాయములచేత చేయబడిన తెలిసి, తెలియక జేసిన పాపములు నశించును. ఈ విషయమందు పురాతనపు కథ యొకటి ఉన్నది వినుము.",
        },
        {
          title: "",
        },

        {
          title: "పూర్వకాలమున ద్రవిడ దేశమందు సుతబంధు విహీనయైనయొక స్త్రీ గలదు. ఆ స్త్రీ నిత్యము భిక్షాన్నము భుజించెడిది. ఎప్పుడు దూషితాన్నమును భుజించెడిది. చద్ది అన్నమునే తినెడిది. నిత్యము ధనము తీసుకొని పరులకు వంట, కుట్టుపని, నూరుట, రుబ్బుట మొదలయిన పనులను చేసెడిది. అమ్మకము, కొనుట చేయుచుండెడిది. ఇట్లు వచ్చిన ద్రవ్యముతో ధనవంతురాలైనది. ఆ స్త్రీ విష్ణు పాదారవిందములను ధ్యానించలేదు. హరికథను వినలేదు పుణ్యతీర్థములకు పోలేదు. ఏకాదశినాడు ఉపవాసము చేయలేదు. అనేక వ్యాపారముల చేత ద్రవ్యమును చాలా సంపాదించినది గాని తాను తినలేదు, పరులకు పెట్టలేదు. ఇట్లు అజ్ఞానముతో మునిగియున్న ఆమె ఇంటికి దైవయోగమువలన శ్రీరంగమునకుబోవు కోరికగల ఒక బ్రాహ్మణుడు వచ్చి ఆమె స్థితిని జూచి అయ్యో ఈ చిన్నది అన్యాయంగా నరకములపాలు కాగలదని దయగలిగి ఆమెతో ఇట్లనియె. ఛీ మూఢురాలా! ఇప్పుడు నామాటలను వినుము. విని చక్కగా ఆలోచించుము.",
        },
        {
          title: "",
        },
        {
          title: "ఈ దేహము సుఖదుఃఖములతో గూడినది. చర్మము, మాంసము, ఎముకలు వీటితో గూడినది. దుఃఖములకు నిలయము. భూమి, ఆకాశము, వాయువు, అగ్ని, జలము అను పంచభూతముల వలన కలిగినది. దేహము నశించగా పంచభూతములు చూరులందుపడిన వర్షబిందువుల వలె పడి తొలగిపోవును. ఈ దేహము నీటిమీది బుడగవలె నశించును. ఇది నిశ్చయము. నిత్యముగాని దేహమును నిత్యమని నమ్మితివి. ఇది అగ్నిలోపడిన మిడుతవలె నశించును. కాబట్టి మోహమును విడువుము. సత్యస్వరూపుడు భూతములందు దయగలవాడగు హరిని ధ్యానించుము. కామమనగా కోరిక, క్రోధమనగా కోపము, లోభమనగా ఆశ, మోహమనగా మమకార అహంకారాలు వీటిని విడువుము. ద్రవ్యము వదలుము. నిశ్చలమైన భక్తితో హరిపాదారవింద ధ్యానము చేయుము. కార్తీకమాసమందు ప్రాతస్నానమాచరించుము.",
        },
        {
          title: "",
        },
        {
          title: "విష్ణుప్రీతిగా దానము చేయుము. బ్రాహ్మణునకు దీపదానము చేయుము. అట్లుచేసిన యెడల అనేక జన్మముల పాపములు నశించును. సందేహమువలదు. ఇట్లు చెప్పి బ్రాహ్మణుడు తూర్పుగా వెళ్ళెను. తరువాత ఆమాటలు నమ్మి విచారించి ఆశ్చర్యమొంది చేసిన పాపకములకు వగచి కార్తీకవ్రతమును ఆరంభించెను. సూర్యోదయసమయాన శీతోదకస్నానము, హరిపూజ, దీపదానము, తరువాత పురాణశ్రవణము ఈప్రకారముగా కార్తీకమాసము నెల రోజులు చేసి బ్రాహ్మణభోజన సమారాధన చేసెను. నెలరోజులు శీతోదక స్నానము చేయుట చేత ఆ స్త్రీకి శీతజ్వరకు సంభవించి గర్భమందు రోగముజనించి రాత్రింబగళ్ళు పీడితురాలై బంధుహీనయై దుఃఖించి చివరకు మృతినొందినది. తరువాత విమానమెక్కి శాశ్వత స్వర్గసుఖములను పొందినది. కాబట్టి కార్తీకమాసమందు అన్నిటికంటె దీపదానము అధిక పుణ్యప్రదము. కార్తీక దీపదానము తెలిసి తెలియక చేసిన పాపములను నశింపజేయును. ఇట్లు పూర్వము శివుడు పలికెను. రాజా!ఈ రహస్యమును నీకు జెప్పితిని. దీనిని విన్నవారు జన్మ సంసారబంధనమును త్రెంచుకుని వైకుంఠము బొందుదురు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే షష్ఠామోధ్యాయస్సమాప్త:",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "షష్ఠమాధ్యాయము",
      },
    {
      CatID: [
        {
          title: "#అథ సప్తమాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "వశిష్ఠుడిట్లనెను. ఓ జనకమహారాజా! కార్తీక మహత్యమును ఇంకా చెప్పదను సావధాన మనస్కుడవై వినుము. ఈ మాసమందు ఎవడు పద్మములచేత పద్మములవంటి నేత్రములు గల హరిని పూజించునో వాని ఇంటిలో పద్మములందుండు లక్ష్మీదేవి నిత్యనివాసము చేయును. భక్తితో తులసీదళముతోను, జాజిపువ్వులతోను హరిని పూజించువాడు తిరిగి భూమియందు జన్మించడు. మారేడు దళములతో సర్వ వ్యాపకుడయిన హరిని పూజించినవాడు తిరిగి భూమియందు జన్మించడు. భక్తితో ఫలములను దానమిచ్చువాని పాపములు సూర్యోదయముకాగానే చీకట్లు ఎట్లునశించునో అట్లు నశించును. ఉసిరికాయలతో ఉసిరి చెట్టుక్రింద హరిని పూజించువానిని యముడు చూచుటకు కూడా సమర్థుడు కాడు. కార్తీకమాసమందు తులసీదళములతో సాలగ్రామమును పూజించువాడు ధన్యుడగును. ఇందుకు సందేహములేదు.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీకమాసమందు బ్రాహ్మణులతో గూడా వనభోజనము ఆచరించువానియొక్క కోటానుకోట్ల పాపాలు నశించును. బ్రాహ్మణులతో గూడా ఉసిరి చెట్టు దగ్గర సాలగ్రామమును పూజించువాడు వైకుంఠమునకు పోయి అచ్చట విష్ణువు వలె ఆనందించుచుండును. భక్తిచే హరియొక్క ఆలయమందు మామిడి చిగురులలో తోరణమును గట్టువాడు పరమపదము పొందును. హరికి అరటి స్తంభములతోగాని, పుష్పములతోగాని, మంటపమును నిర్మించి పూజించువాడు చిరకాలము వైకుంఠమందుండును. ఒక్కమారయినను హరిముందు దండప్రణామమాచరించువారు పాపవిముక్తులై అశ్వమేధయాగఫలము పొందుదురు. హరిముందు జపము, హోమము, దేవతార్చనము చేయువారు తమ పితరులతో కూడా వైకుంఠమునకు బోవుదురు. స్నానముచేసి తడిబట్టతో ఉన్నవానికి, చలితో వణుకువానికి వస్త్రదానము చేయువాడు పదివేల అశ్వమేధయాగములు చేసిన ఫలమును పొందును.",
        },
        {
          title: "",
        },
        {
          title: "విష్ణువు యొక్క ఆలయ శిఖరమందు ధ్వజారోహణము చేయువాని పాపములు గాలికి దుమ్ము ఎగిరిపోవునట్లు నశించును. నల్లనివిగాని, తెల్లనివిగాని అవిశపువ్వులతో హరిని పూజించిన యెడల పదివేల యజ్ఞములు చేసిన ఫలము గలుగును. బృందావనమునందు ఆవుపేడతో అలికి ఐదు రంగులతోను, శంఖ,పద్మ, స్వస్తికాది ముగ్గులు పెట్టిన స్త్రీ హరికి ప్రియురాలగును. విష్ణుసన్నిధిలో నందాదీపమును అర్పించిన పుణ్యముయొక్క గొప్పతనము జెప్పుట బ్రహ్మకు కూడ శక్యముగాదు. పర్వతిధులలో పెట్టిన దీపమునకు నందాదీపమని పేరు. ఈనందాదీపము నశించిన యెడల వ్రతభ్రష్టుడగును. తిలలతోను, ధాన్యముతోను, అవిశపువ్వులతోను, కలిపిన నందాదీపమును కార్తీకాసమందు హరికి సమర్పించవలయును. నందా అనగా ఏకాదశి, పూర్ణిమ మున్నగు పర్వతిథులందు జేయునది.",
        },
        {
          title: "",
        },
        {
          title: "శివునికి జిల్లేడు పువ్వులతో పూజించిన వారు చిరకాలము జీవించి తుదకు మోక్షము పొందుదురు. విష్ణాలయమంటపమును భక్తితో అలంకరించువారు హరి మందిరమునకు వెళ్ళుదురు. హరిని మల్లెపువ్వులతో పూజించువాని పాపములు సూర్యోదయానంతరము చీకటి నశించునట్లు నశించును. కార్తీకమాసమందు తులసీ గంధముతో సాలగ్రామమును పూజించువాడు పాపవిముక్తుడై విష్ణులోకమును బొందును. హరిసన్నిధిలో స్త్రీగాని, పురుషుడుగాని నాట్యముజేసినయెడల పూర్వజన్మ సంచితమైన పాతకములు గూడ నశించును. ఇతరులకు హరిపూజ కొరకు మనోవాక్కాయముల చేత సహాయము చేయువాడు స్వర్గమునుబొందును. భక్తితో గంధపుష్ప ధూపదీపాదులచేత హరిని పూజించువాడు వైకుంఠమునుబొందును. ఈ మాసమున హరిసన్నిధిలో జపమాచరించనివాడు భూమియందు ఏడు జన్మములందు నక్కగా జన్మించును. ఇందుకు సందేహము లేదు. సాయంకాలమందు హరిసన్నిధిలో పురాణ కాలక్షేపమునుజేయువారు వైకుంఠమును జేరుదురు. సాయంకాలమున ఆలయములందు స్తోత్రములను పఠించువాడు స్వర్గలోకమున కొంతకాలముండి తరువాత ధ్రువలోకము చేరి సుఖించును.",
        },

        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే సప్తమోధ్యాయస్సమాప్త:",
        },
        ],
  //  img: require('../imgs/Astotaram/Karthikamasam.png'),
  //  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "సప్తమాధ్యాయము",
      },
    {
      CatID: [
        {
          title: "#అథ అష్టమాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "వశిష్టుడు చెప్పిన దంతా విన్న జనకుడు ఇలా అడుగుతున్నాడు, మహానుభావా! మీరు చెప్పిన ధర్మాలన్నింటినీ శ్రద్ధగా వింటున్నాను. అందులో ధర్మం చాలా సూక్షంగా, పుణ్యం సులభంగా కనిపిస్తోంది. నదీస్నానం, దీపదానం, ఫలదానం, అన్నదానం, వస్త్రదానం వంటి విషయాలను గురించి చెప్పారు. ఇలాంటి స్వల్ప ధర్మాలతో మోక్షం లభిస్తుండగా వేదోక్తంగా యజ్ఞయాగాదులు చేసినగానీ పాపాలు పోవని మీలాంటి ముని శ్రేష్టులే చెబుతున్నారు. మరి మీరు ఇది సూక్ష్మంలో మోక్షంగా చెబుతుండటం నాకైతే చాలా ఆశ్చర్యాన్ని కలిగిస్తోంది. దుర్మార్గులు, వర్ణ సంకరులైనవారు రౌరవాది నరకాలకు పోకుండా తేలిగ్గా మోక్షాన్ని పొందుతున్నారు. ఇదంతా వజ్రపు కొండను గోటితో పెకిలించడం వంటిదే కాదా? దీని మర్మమేమిటి? నాకు సవివరంగా చెప్పండి అని ప్రార్థించాడు.",
        },
        {
          title: "",
        },
        {
          title: "అంతట వశిష్టుల వారు చిరునవ్వు నవ్వి, జనక మహారాజా! నీవు వేసిన ప్రశ్న సహేతుకమైనదే, నేను వేద వేదంగములను కూడా పఠించాను. వాటిల్లోనూ సూక్ష్మ మార్గాలున్నాయి. అవి సాత్విక, రాజస, తామసాలు అని పిలిచే మూడు రకాల ధర్మాలున్నాయి. సాత్వికమంటే దేశ కాల పాత్రలు మూడు సమాన సమయంలో సత్వ గుణం జనించి ఫలితాన్ని పరమేశ్వరుడికి అర్పిస్తాం. మనోవాక్కాయ కర్మలతో ఒనర్చే ధర్మం అధర్మంపై ఆదిక్యత పొందుతుంది. ఉదాహరణకు తామ్రవర్ణ నది సముద్రంలో కలిసిన తావులో స్వాతికర్తెలో ముత్యపు చిప్పలో వర్షపు బిందువు పడి ధగధగ మెరిసి, ముత్యమయ్యే విధంగా సాత్వికత వహించి, సాత్విక ధర్మం ఆచరిస్తూ గంగ,యమున, గోదావరి, కృష్ణ నదుల పుష్కరాలు మొదలు పుణ్యకాలాల్లో దేవాలయాల్లో వేదాలను పఠించి, సదాచారుడై, కటుంబీకుడైన బ్రాహ్మణుడికి ఎంత స్వల్ప దానం చేసినా లేక ఆ నదీ తీరంలో ఉన్న దేవాలయంలో జపతపాదులను చేయుట విశేష ఫలితాలనిస్తుంది.",
        },
        {
          title: "",
        },
        {
          title: "ఇక రాజస ధర్మం అంటే ఫలాపేక్ష కలిగి శాస్త్రోక్త విధులతో చేసే ధర్మం. ఆ ధర్మం పునర్జన్మ హేతుకమై కష్టసుఖాలను కలిగిస్తుంది. తామస ధర్మమనగా శాస్త్రోక్త విధులను విడిచి, దేశకాల పాత్రలు సమకూడని సమయంలో డాంబిక చరణార్థం చేసేది. ఆ ధర్మం ఫలాన్ని ఇవ్వదు. దేశకాల పాత్రము సమ కూడినపుడు తెలిసి గాని తెలియకగాని యే స్వల్ప ధర్మం చేసిననూ గొప్ప ఫలము నిచ్చును. అనగా పెద్ద కట్టెల గుట్ట చిన్న అగ్ని కణములతో భస్మమగునట్లు శ్రీమన్నానారాయుణుని నామము, తెలిసి గాని, తెలియక గాని ఉచ్చరించిన వారి సకల పాపములు పోయి ముక్తి నొందుదురు. దానికొక ఇతిహాసము కలదు అని ఇలా చెప్పసాగారు.",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> ఆజామీళుని కథ :</span>,
        },
        {
          title: "",
        },
        {
          title: "పూర్వ కాలంలో కన్యాకుబ్జం అనే నగరంలో నాలుగు వేదాలు చదివిన బ్రాహ్మడు ఒకడుండేవాడు. అతని పేరు సత్య వ్రతుడు. అతనికి సకల సద్గుణ రాశి అయిన భార్య ఉంది. ఆ దంపతులు అన్యోన్యత, ప్రేమ కలిగి అపూర్వ దంపతులు అనే పేరు తెచ్చుకున్నారు. వారికి చాలాకాలానికి లేకలేక ఒక కొడుకు పుట్టాడు. వారు ఆ పిల్లాడిని గారాబంగా పెంచి, అజామిళుకుడని పేరు పెట్టారు. అతను గారాబంగా పెరగడం వల్ల పెద్దలను నిర్లక్ష్యం చేస్తూ దుష్ట సహవాసాలు చేయసాగాడు. విద్యను అభ్యసించక, బ్రాహ్మణ ధర్మాలను పాటించక సంచరిచేవాడు. అలా కొంతకాలం తర్వాత యవ్వనవంతుడై కామాంధుడయ్యాడు. మంచిచెడ్డలు మరిచి, యజ్ఞోపవీతం తెంచి, మద్యంసేవించడం, ఒక ఎరుకల జాతి స్త్రీని వలచి, నిరంతరం ఆమెతోనే కామ క్రీడల్లో తేలియాడుచుండేవాడు. ఇంటికి రాకుండా, తల్లిదండ్రులను మరిచి, ఆమె ఇంట్లోనే భోజనం చేస్తూ ఉండేవాడు. అతి గారాబం వల్ల ఈ దుష్పరిణామాలు ఎదురయ్యాయి. చిన్నపిల్లల్ని చిన్నతనం నుంచి అదుపాజ్ఞల్లో పెట్టకపోవడం వల్ల ఈ దుస్థితి దాపురించింది. అజామీళుడు కులభ్రష్టుడు అయ్యాడు.",
        },
        {
          title: "",
        },
        {
          title: "కుల బహిష్కరణతో అతను మరింత కిరాతకుడిగా మారాడు. వేట వల్ల పక్షులను, జంతువులను చంపుతూ అదే వృత్తిలో జీవించసాగాడు. ఒక రోజున అజామీలుడు, అతని ప్రేయసి అడవిలో వేటాడుతూ తేనె పట్టు తీసేందుకు ఆమె చెట్టుపైకెక్కి ప్రమాదవశాత్తు కిందపడి మృతిచెందింది. అజామీళుడు ఆమెపైపడి కాసేపు ఏడ్చి, ఆ తర్వాత అడవిలోనే దహనం చేసి, ఇంటికి తిరిగి వెళ్లాడు. అప్పటికే ఆ ఎరుకల మహిళకు ఒక కుమార్తె ఉండడంతో, అజామీళుడు ఆమెను పెంచసాగాడు. ఆమెకాస్తా యుక్తవయసుకు వచ్చేసరికి అజామీళుడు కామంతో కళ్లు మూసుకుపోయి, ఆమెను చేపట్టాడు. ఆమెతో కామక్రీడల్లో తేలియాడుచుండేవాడు. వీరికి ఇద్దరు కొడుకులు పుట్టారు. ఆ ఇద్దరూ పురిటిలోనే చనిపోయారు. ఆ తర్వాత ఆమె మరలా గర్భందాల్చి ఓ కుమారుడిని కన్నది. వారిద్దరూ ఆ బాలుడికి నారాయణ అని పేరు పెట్టి పిలవసాగారు. ఒక్క క్షణమైనా ఆ బాలుడిని విడవకుండా, ఎక్కడకు వెళ్లినా తన వెంట తీసుకెళ్తూ నారాయణా అని ప్రేమతో సాకుచుండిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఇలా కొంతకాలం గడిచాక అజామీళుడి శరీరం పటుత్వం కోల్పోయింది. రోగస్తుడయ్యాడు. మంచం పట్టి కాటికి కాలుచాచాడు. ఒకరోజు భయంకరాకారాలతో, పాశాయుధాలతో యమభటులు ప్రత్యక్షమయ్యారు. వారిని చూసి అజామీళుడు భయపడి కుమారుడిపై ఉన్న వాత్సల్యంతో ప్రాణాలు విడువలేక నారాయణా నారాయణా అని పిలుస్తూ ప్రాణాలు విడిచాడు. అజామీళుడి నోట నారాయణ శబ్దం రాగానే యమభటులు గడగడా వణికారు. అదే వేళకు దివ్య మంగళకారులు, శంఖ,చక్ర గధాధరులూ అయిన శ్రీమహావిష్ణువు దూతలు విమానంలో అక్కడకు వచ్చి, ఓ యమ భటులారా! వీడు మావాడు. మేం వైకుంఠానికి తీసుకెళ్లడానికి వచ్చాం అని చెప్పి, అజామీళుడిని విమానమెక్కించి తీసుకుపోయారు. యమదూతలు వారితో అయ్యా వీడు పరమ దుర్మార్గుడు. వీడు నరకానికి వెళ్లడమే తగినది అని చెప్పగా విష్ణుదూతలు అతను చనిపోవడానికి ముందు నారాయణ పదాన్ని ఉచ్చరించడం వలన ఊటంకించి ఆ పాపాలన్నీ ఆ నామ జపంతో తొలగిపోయాయని, అతను ఇప్పుడు పునీతుడని చెప్పుకొచ్చారు.",
        },
        {
          title: "",
        },
        {
          title: "సంకీర్తనారాయణ శబ్దమాత్రం విముక్త్య దు:ఖా సుఖినోభవంతు అన్నట్లు అజామీళుడు విష్ణుసాన్నిధ్యాన్ని పొందాడని వశిష్టుడు జనకమహారాజుకు వివరించారు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే అష్టమాధ్యాయస్సమాప్త:",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "అష్టమాధ్యాయము",
      },
    {
      CatID: [
        {
          title: "#అథ నవమాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "ఓ యమదూతలారా! మేము విష్ణు దూతలము. వైకుంఠము నుండి వచ్చితిమి. మీ ప్రభువగు యమధర్మరాజు ఎటువంటి పాపాత్ములను తీసుకొని రమ్మని మిమ్ములను పంపెనుయని ప్రశ్నించిరి. అందుకు జవాబుగా యమదూతలు, విష్ణుదూతలారా! మానవుడు చేయు పాపపుణ్యాదులను సూర్యుడు, చంద్రుడు, భూదేవి, ఆకాశము, ధన౦జయాది వాయువులు, రాత్రి౦బవళ్లు సంధ్యకాలం సాక్షులుగా వుండి ప్రతి దినం మా ప్రభువు కడకు వచ్చి విన్నవించుచుందురు. మా ప్రభువుల వారీ కార్యకలాపములను చిత్రగుప్తునిచే చూపించి ఆ మనుజుని అవసానకాలమున మమ్ము పంపి వారిని రప్పించెదరు. పాపులెటువంటివారో వినుడు.",
        },
        {
          title: "",
        },
        {
          title: "వేదోక్త సదాచారములు విడిచి వేదశాస్త్రములు నిందించువారును, గోహత్య , బ్రహ్మహత్యాది మహాపాపములు చేసినవారు, పరస్త్రీలను కామించినవారును, పరాన్న భుక్కులు, తల్లిదండ్రులను, గురువులను, బంధువులను, కులవృతిని తిట్టి హింసి౦చువారును, జీవహింస చేయు వారును, దొంగ పద్దులతో వడ్డీలు పెంచి ప్రజలను పిడించు వారును, జారత్వం చొరత్వంచే భ్రష్టులగు వారును, ఇతరుల ఆస్తిని స్వాహా చేయు వారును, శిశుహత్య చేయువారును, శరణన్నవానిని కూడా వదలకుండా బాధించు వారును, చేసిన మేలు మరచిన కృతఘ్నులును, పెండ్లిండ్లు, శుభకార్యములు జరగనివ్వక అడ్డుతగిలే వారును పాపాత్ములు. వారు మరణించగానే తన కడకు తీసుకువచ్చి నరకమందు పడద్రోసి దండి౦పుడని మా యమధర్మరాజు గారి ఆజ్ఞ.",
        },
        {
          title: "",
        },
        {
          title: "అది అటులుండగా ఈ అజామిళుడు బ్రాహ్మణుడై పుట్టి దురచారములకులోనై కులభ్రష్టుడై జీవహింసలు చేసి, కామాంధుడై వావివరసలులేక, సంచరించిన పాపాత్ముడు. వీనిని విష్ణు లోకమునకు ఎట్లు తీసుకొని పోవుదురు? అని యడగగా విష్ణుదూతలు, ఓ యమకి౦కరులారా! మీరెంత అవివేకులు? మీకు ధర్మసూక్ష్మములు తెలియవు. ధర్మసూక్ష్మములు లెట్టివో చెప్పెదము వినుడు. సజ్జనులతో సహవాసము చేయువారును, జప దాన ధర్మములు చేయువారును, అన్నదానము, కన్యాదానము, గోదానము , సాలగ్రామ దానము చేయువారును, అనాధప్రేత సంస్కాములు చేయువారును, తులసి వనము పెంచువారును, తటాకములు త్రవ్వి౦చువరును, శివకేశవులను పూజి౦చువారును సదా హరి నామస్మరణ చేయువారును మరణ కాలమందు 'నారాయణా'యని శ్రీ హరిని గాని, 'శివ' అని శివుని గాని స్మరించువారును, తెలిసిగాని తెలియక గాని మరే రూపమునగాని హరి నామస్మరణ చెవినబడిన వారును పుణ్యాత్ములు. కాబట్టి అజామిళుడు ఎంత పాపత్ముడైనాను మరణకాలమున 'నారాయణా' అని స్మరించుచూ చనిపోయెను గాన, మేము వైకుంఠమునకు తీసుకొని పోవుదుము అని పలికిరి.",
        },
        {
          title: "",
        },
        {
          title: "అజామిళుడు విష్ణుదూతల సంభాషణలాలకించి ఆశ్చర్యమొంది ఓ విష్ణుదూతలారా! పుట్టిన నాటి నుండి నేటి వరకు శ్రీ మన్నారాయణ పూజగాని, వ్రతములుగాని, ధర్మములుగాని చేసి యెరుగను. నవమాసములు మోసి కనిపెంచిన తల్లిదండ్రులకు సహితము ప్రణమిల్లలేదు. వర్ణాశ్రమములు విడిచి కులభ్రష్టుడనై, నీచకుల కాంతలతో సంసారము చేసితిని. నా కుమారునియందున్న ప్రేమచో 'నారాయణా' యని నంత మాత్రమున, నన్ను ఘోర నరక బాధల నుండి రక్షించి వైకుంఠమునకు తీసుకొని పోవుచున్నారు. ఆహా! నేనెంత అదృష్టవంతుడను! నా పూర్వజన్మ సుకృతము, నా తల్లితండ్రుల పుణ్యఫలమే నన్ను రక్షించినది అని పలుకుచు సంతోషముగా విమానమెక్కి వైకుంఠమున కేగెను. కావున ఓ జనక చక్రవర్తీ! తెలిసిగాని, తెలియక గాని నిప్పును ముట్టిన నెట్టుల బొబ్బలెక్కి బాధ కలిగించునో, అటులనే శ్రీహరిని స్మరించిన యెడల సకల పాపములును నశించి మోక్షము నొందెదరు. ఇది ముమ్మాటికినీ నిజము.",
        },

        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణా౦తర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే నవమాధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "నవమాధ్యాయము",
      },
    {
      CatID: [
        {
          title: "#అథ దశమోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "జనకుడు తిరిగి ఇట్లు అడిగెను. ఓ మునీశ్వరా! ఈ అజామిళుడు పూర్వజన్మమందెవ్వడు? ఏమి పాపమును జేసెను? విష్ణుదూతలు చెప్పినమాటలను విని యమభటులు ఎందుకు యూరకుండిరి? యముని వద్దకుపోయి యమునితో ఏమని చెప్పిరి? వశిష్ఠుడు ఇట్లు చెప్పెను. యమదూతలు విష్ణుదూతలమాటలు విని శీఘ్రముగా యమునివద్దకుబోయి సర్వవృత్తాంతమును జెప్పిరి. అయ్యా! పాపాత్ముడును, దురాచారుడును, నిందితకర్మలను ఆచరించువాడునునగు అజామిళునికి తోడితెచ్చుటకు పోయినంతలో విష్ణుదూతలు వచ్చి మమ్ములను ధిక్కరించి అతనిని విడిపించిరి. మేము వారిని ధిక్కరించుటకు అశక్తులమై వచ్చితిమి అని చెప్పిరి. ఆమాటను విని కోపించి యముడు జ్ఞానదృష్టితో చూచి ఇట్లనియె. ఈఅజామిళుడు దుర్మార్గుడైనను అంత్యకాలమందు హరినామము చేయుటచేత పాపములు నశించి వైకుంఠప్రియుడాయెను. అందువలన అతనిని విష్ణుదూతలు స్వీకరించిరి. దుష్టాత్ములై మహిమను తెలిసికొనక హరినామస్మరణ చేసినను పాపములు నశించును. తెలియక తాకినను అగ్ని కాల్చునుగదా! భక్తితో నారాయణ స్మరణనుజేయువాడు జీవన్ముక్తుడై అంతమందు మోక్షమునొందును. యముడిట్లు విచారించి యూరకుండెను.",
        },
        {
          title: "",
        },
        {
          title: "అజామిళుడు పూర్వ జన్మమున సౌరాష్ట్రదేశమందు బ్రాహ్మణుడై శివార్చకుడుగా ఉండి శివద్రవ్యమును హరించుచు స్నానసంధ్యలను విడిచి అన్యమానసుడై శివుని పూజించుచు శివునకభిముఖముగా కాళ్ళు చాపుకుని శయనించుచు ఆయుధపాణియై స్నేహితులతో గూడి నానాలంకార శోభితుడై స్వేచ్ఛావిహారముల తిరుగుచు బహుభాషియై మంచి యౌవనముతో నుండెను. ఆయూరిలోనొక బ్రాహ్మణుడుండెను. అతనికొక రూపవతియు యౌవనవతియగు భార్యగలదు.",
        },
        {
          title: "",
        },
        {
          title: "ఆబ్రాహ్మణుడు దరిద్రపీడితుడై అన్నముకొరకై పట్టణములు, గ్రామములు, పల్లెలు తిరుగుచు యాచించుచుండెడివాడు. ఒకానొకప్పుడు బ్రాహ్మణుడు సంపాదించిన ధ్యాన్యాదికమును శిరస్సుననుంచుకొని ఆకలితో యింటికివచ్చి భార్యతో ఓసీ! నాకుఆకలి కలుగుచున్నది. త్వరగా వంటచేయుము. ముందు మంచినీళ్ళిమ్ము త్రాగి శాంతించెదను. భర్త ఇట్లెన్ని మారులడిగినను భార్య అతని మాటను లెక్కచేయక పనులు చేయుచు జారుని మనస్సులో ధ్యానించుచు యూరకుండెను. అంత భర్త కోపించి దండముతో భార్యనుగొట్టెను. భార్య భర్తను పిడికిలితో గుద్దెను. తరువాత భర్త ఆ గృహమును విడిచి గ్రామాంతరముబోయి అచ్చట భిక్షమెత్తుకొని జీవించుచు భార్యసంగతిని గూర్చి చింతించుచుండెను. భార్యయు సుఖముగా నుండి రాత్రి భుజించి మంచి చీరెధరించి తాంబూలము స్వీకరించి ఒక చాకలివాని ఇంటికిపోయెను. సుందరుడయిన చాకలివానిని జూచి రాత్రి నాతో సంభోగించుమనెను.",
        },
        {
          title: "",
        },
        {
          title: "ఆమాటవిని వాడు నీవు బ్రాహ్మణ స్త్రీవి. అర్థరాత్రివేళ మాయింటికి రావచ్చునా? మీరు గొప్పకులమునందు బుట్టినవారు. మేము నిందుతులము. కాబట్టి ఇట్టి సంపర్కము మీకు తగునా? ఈ ప్రకారముగా వారిరువురును వివాదపడుచు చాకలివాడు రోకలితో ఆమెను కొట్టెను. ఆమెయు వానిని కొట్టి వానిని విడిచ రాజమార్గమున బోవుచుండగా పైనజెప్పిన శివార్చకుని జూచెను. అంతలో ఆ స్త్రీ వానిని పట్టుకుని రతికేళికి రమ్మనమని పిలుచుకొనిపోయి వానితో భోగించి రాత్రియంతయు వానితో కాలక్షేపము చేసి తెల్లవారగానే పశ్చాత్తాపమునుబొంది భర్తవద్దకు బోయి ఆయనను బ్రతిమాలి ఆయనతో గూడా గృహమందు సౌఖ్యముగా నుండెను. తరువాత కొంతకాలమునకు శివార్చకుడు మృతినొంది యమలోకమందు క్రమముగా రౌరవాది నరక దుఃఖములననుభవించి తిరిగి భూమియందు సత్వనిష్ఠుని కొడుకు అజామిళుడై జన్మించెను.",
        },

        {
          title: "",
        },
        {
          title: "ఇతనికి కార్తీకపున్నమినాడు శివదర్శనము లభించినది. అంత్యకాలమందు హరినామస్మరణ గలిగినది. ఆ హేతువులచేత సప్తజన్మార్జిత పాపములు నశించి మోక్షమును బొందెను. ఆ బ్రాహ్మణియు కొంతకాలమునకు మృతినొంది నరకములందనే యాతనలనొంది తిరిగి భూమియందు కన్యాకుబ్జమందు చండాలునకు పుత్రికగా జన్మించెను. చండాలుడు ఈమె పుట్టిన సమయము మంచిదాయని ఒక బ్రాహ్మణునియడిగెను. అతడు ఈమె తండ్రిగండాన పుట్టినదని చెప్పెను. ఆ మాటవిని చండాలుడు ఆ శిశువును దీసుకొనిపోయి అరణ్యమందుంచెను. అంతలో ఒక బ్రాహ్మణుడు జూచి రోదనము చేయుచున్న ఆ శిశువును దీసికొనిపోయి తన ఇంటిలో దాసీగా నున్న ఒక స్త్రీకి అప్పగించెను. ఆదాసీ ఈమెను పెంచినది.",
        },
        {
          title: "",
        },
        {
          title: "తరువాత ఈమెను అజామిళుడు దగ్గరకు తీసెను. తరువాత కథ పూర్వోక్తమే. రాజోత్తమా! ఇది నీవడిగిన ప్రశ్నకు సమాధానము. అజామిళుని పూర్వ వృత్తాంతము. పాపములకు ప్రాయశ్చిత్తములు చేయుట కష్టము. హరినామకీర్తనము చేసిన ప్రాయశ్చిత్తములతో పనిలేదు. అదిగాని యెడల ధర్మశాస్త్రోక్త ప్రాయశ్చిత్తములు చేయవలెనని భావము. ఎవ్వనియొక్క నాలుక హరినామ కీర్తనము చేయదో, మనస్సు హరి పాదపద్మమును స్మరించదో చెవులు హరిచరిత్రములను వినదో వాని పాపములు ఎట్లు నశించును? ఇతర చింతను మాని హరిని స్మరించువారు ముక్తినొందెదరు. ఇందుకు సందేహము లేదు. కార్తీకధర్మమునకు పాపములను నశింపజేయి సామర్ధ్యమున్నది. కాబట్టి కార్తీక మాసమందు ధర్మమాచరించనివాడు నరకము నొందును. ఇది నిశ్చయము. పాపములను నశింపజేయి ఈకథను విన్నవారు సమస్త పాపములను నశింపజేసి మోక్షమొందుదురు. ఈ కథను వినిపించువారు పాపవిముక్తులై వైకుంఠమందు విష్ణువుతో గూడి సుఖించును.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే దశమోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "దశమోధ్యాయము",
      },
    {
      CatID: [
        {
          title: "#అథ ఏకాదశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "రాజోత్తమా! తిరిగి చెప్పెదను వినుము. కార్తీకమాసమందు అవిసె పువ్వుతో హరిని పూజించిన వాని పాపములు నశించును. చాంద్రాయణవ్రత ఫలము పొందును. కార్తీకమాసమందు గరికతోను, కుశలతోను హరిని పూజించువాడు పాపవిముక్తుడై వైకుంఠమును జేరును. కార్తీకమాసమందు చిత్రరంగులతో గూడిన వస్త్రములను హరికి సమర్పించినవాడు మోక్షమునొందును. కార్తీకమాసమందు స్నానమాచరించి హరిసన్నిధిలో దీపమాలలనుంచువాడును, పురాణమును జెప్పువాడును, పురాణమును వినువాడును పాపములన్నియును నశింపజేసుకొని పరమపదమును బొందుదురు. ఈ విషయమై ఒక పూర్వకథగలదు. అది విన్నమాత్రముననే పాపములు పోవును.",
        },
        {
          title: "",
        },
        {
          title: "ఆయురారోగ్యములనిచ్చును. బహు ఆశ్చర్యకరముగా ఉండును. దానిని చెప్పెద వినుము. కళింగదేశమందు మందరుడను నొక బ్రాహ్మణుడు గలడు. అతడు స్నాన సంధ్యావందనాదులను విడిచి పెట్టినవాడై ఇతరులకు కూలి చేయుచుండెడివాడు. అతనికి మంచిగుణములు గలిగి సుశీలయను పేరుగల భార్యయుండెను. ఆమె పతివ్రతయు, సమస్త సాముద్రిక లక్షణములతో గూడినదై ఆడవారిలో శ్రేష్ఠురాలైయుండెను. ఓ రాజా! ఆ సుశీల భర్త దుర్గుణ పూర్ణుడైనను అతనియందు ద్వేషమునుంచక సేవించుచుండెను. తరువాత వాడు వేరైన జీవనోపాయము తెలియక కూలిజీవనము కష్టమని తలచి కత్తిని ధరించి అడవిలో మార్గము కనిపెట్టుకొని యుండి దారి నడుచువారిని కొట్టి వారి ధనములనపహరించుచు కొంతకాలమును గడిపెను.",
        },
        {
          title: "",
        },
        {
          title: "అట్లు చౌర్యమువలన సంపాదించిన వస్తువులను ఇతర దేశములకు పోయి అమ్ముకొని ఆధనముతో కుటుంబమును పోషించుచుండెను. ఒకప్పుడు ఆ బ్రాహ్మణుడు చౌర్యముకొరకు మార్గమును కనిపెట్టియుండి మార్గానవచ్చునొక బ్రాహ్మణుని పట్టుకొని మర్రిచెట్టుకు కట్టి అతని సొమ్మంతయును హరించెను. ఇంతలోనే క్రూరుడైన కిరాతుడొకడు వచ్చి ఆ ఇద్దరు బ్రాహ్మణులను చంపి ఆధనమంతయు తాను హరించెను. తరువాత గుహలోనున్న పెద్దపులి కిరాత మనుష్యగంథమును ఆఘ్రాణించి వచ్చి వానిని కొట్టెను. కిరాతుడును కత్తితో పులిని కొట్టెను. ఇట్లు ఇద్దరును పరస్పర ప్రహారములచేత ఒక్కమారే చనిపోయిరి. ఇట్లు ఇద్దరు బ్రాహ్మణులు, పులి, కిరాతుడు నలుగురు ఒక చోట మృతినొంది యమలోకమునకు బోయి కాలసూత్ర నరకమందు యాతన బడిరి. యమభటులు వారినందరిని పురుగులతోను, అమేధ్యముతోను కూడినటువంటి భయంకరమైన చీకటిలో సలసలకాగుచున్న రక్తమందు బడవైచిరి.",
        },
        {
          title: "",
        },
        {
          title: "జనకమహారాజా! ఆబ్రాహ్మణుని భార్య సమస్త ధర్మములను ఆచారవంతురాలై హరిభక్తియుతయై సజ్జన సహవాసమును జేయుచు నిరంతరము భర్తను ధ్యానించుచుండెను. ఓ రాజా! ఇట్లుండగా దైవవశముచేత ఒక యతీశ్వరుడు హరినామముచేయుచు నాట్యముచేయుచు పులకాంకితశరీరుడై హరినామామృతమును పానముచేయుచు సమస్త వస్తువులందు హరిని దర్శించుచు ఆనంద భాష్పయుతుడై ఆమె ఇంటికి వచ్చెను. ఆమెయు ఆయతిని జూచి భిక్షమిడి అయ్యా యతిపుంగవా! మీరు మా ఇంటికి వచ్చుటచేత నేను తరించితిని. మీవంటివారి దర్శనము దుర్లభము. మా ఇంటివద్ద నా భర్తలేడు. నేనొక్కదాననే పతిధ్యానమును చేయుచున్నదానను.",
        },

        {
          title: "",
        },
        {
          title: "ఆమె ఇట్లుచెప్పగా విని యతీశ్వరుడు ప్రియభాషిణియు శ్యామయునయిన ఆమెతో ఇట్లనియెను. అమ్మాయీ! ఈరోజు కార్తీక పూర్ణిమ మహాపర్వము. ఈ దిన సాయంకాలము హరిసన్నిధిలో, మీఇంటిలో పురాణ పఠనము జరుపవలెను, ఆపురాణమునకు దీపముకావలెను. నూనె తెచ్చెదను. గనుక వత్తి నీవు చేసి ఇమ్ము. శ్యామయనగా యౌవనవతియని అర్థము. యతీశ్వరుడిట్లు చెప్పగా ఆచిన్నది విని సంతోషముతో గోమయముతెచ్చి ఆఇల్లు చక్కగా అలికినదై అందు అయిదురంగులతో ముగ్గులను బెట్టి పిమ్మట దూదిని పరిశుద్ధము చేసినదై ఆదూదిచే రెండు వత్తులను జేసి నూనెతో యతీశ్వరుని వద్ద వెలిగించి స్వామికి సమర్పించెను.",
        },
        {
          title: "",
        },
        {
          title: "ఆ చిన్నది దీపపాత్రను, వత్తిని తాను ఇచ్చినందుకు యతీశ్వరుడు చాలా సంతోషించి దీపమును వెలిగించెను. యతియు ఆ దీపమునందు హరిని పూజించి మనశ్శుద్ధి కొరకై పురాణపఠనమారంభించెను. ఆమెయు ప్రతి ఇంటికిబోయి పురాణశ్రవణమునకు రండని చాలామందిని పిలుచుకుని వచ్చి వారితో సహా ఏకాగ్రమనస్సుతో పురాణమును వినెను. తరువాత యతీశ్వరుడు యధేచ్ఛగా పోయెను. కొంతకాలమునకు హరి ధ్యానము చేత జ్ఞానమును సంపాదించుకొని ఆమె మృతినొందెను. అంతలో శంఖచక్రాంకితులును, చతుర్బాహులును, పద్మాక్షులును, పీతాంబరధారులునునైన విష్ణుదూతలు దేవతల తోటలోనున్న పుష్పములతోను, ముత్యాలతోను, పగడములతోను, రచించిన మాలికలతోను, వస్త్రములతోను, ఆభరణములతోను అలంకరించబడిన విమానమును దీసికొని తెచ్చి సూర్యుడువలె ప్రకాశించెడి ఆ విమానమందు ఆమెను ఎక్కించి జయజయధ్వనులతో కరతాళములు చేయుచు చాలా మంది వెంటరాగా వైకుంఠలోకమునకు చేరెను.",
        },
        {
          title: "",
        },
        {
          title: "ఆమె వైకుంఠమునకు బోవుచు మధ్యమార్గమందు నరకమును జూచి అచ్చట తనపి నరకము నందు ఉండుటకు ఆశ్చర్యమొంది విష్ణుదూతలతోనిట్లు పలికెను.  ఓ విష్ణుదూతలారా! నిమిషమాత్రము ఉండండి. ఈనరక కూపమునందు నా భర్త ముగ్గురితో పడియుండుటకు కారణమేమి? ఈ విషయమును నాకు జెప్పుడు. వీడు నీ భర్త, వీడు కూలిచేసియు, దొంగతనమును జేసియు పరధనాపహరణము జేసినాడు. వేదోక్తమయిన ఆచారమును వదలి దుర్మార్గమందు చేరినాడు. అందువల్ల వీడు నరకమందున్నాడు. ఈ రెండవ బ్రాహ్మణుడు మిత్రద్రోహి, మహాపాతకుడు, ఇతడు బాల్యము నుండి మిత్రుడైయున్న నొకనిని చంపి వాని ధనము అపహరించి ఇతరదేశమునకు బోవుచున్నంతలో నీభర్తచేత హతుడాయెను. అట్టి పాపాత్ముడు గనుక ఇతడు నరకమందు బడియున్నాడు. ఈ మూడవవాడు కిరాతుడు.",
        },
        {
          title: "",
        },
        {
          title: "వీడు నీ భర్తను ఈ బ్రాహ్మణుని ఇద్దరిని చంపినాడు. అందుచేత వీడు నరకమందుండెను. ఈ నాల్గవవాడు, పులి, కిరాతులు పరస్పర ఘాతముల చేత మృతినొందిరి. ఈ పులి పూర్వమందు ద్రావిడ బ్రాహ్మణుడు. ఇతడు ద్వాదశినాడు భక్ష్యాభక్ష్య విచారణ చేయక నూనెతో చేసిన వంటకములను భుజించినాడు. అందుచేత వీడు నరకమందున్నాడు. ఇట్లు నలుగురు నరకమందు యాతనలనొందుచున్నారు. ద్వాదశినాడు నెయ్యి వాడవలెను. నూనె వాడకూడదు. విష్ణుదూతలిట్లు చెప్పగా విని ఆమె అయ్యలారా, ఏపుణ్యము చేత వీరు నరకము నుండి ముక్తులగుదురని యడిగెను. ఆ మాటవిని దూతలిట్లనిరి. అమ్మా! కార్తీకమాసమందు నీచేత చేయబడిన పుణ్యమందు పురాణ శ్రవణఫలమును నీ భర్తకిమ్ము.",
        },
        {
          title: "",
        },
        {
          title: "దానితో వాడు విముక్తుడగును. ఆ పురాణ శ్రవణార్థమై దీపమునకు నీవు సమర్పించిన వర్తి పుణ్యమును ఈ కిరాత వ్యాఘ్రములకు సమానముగా నిమ్ము. దాని వలన వారు ముక్తులగుదురు. పురాణ శ్రవణార్థమై నీవు ప్రతిగృహమునకు బోయి ప్రజలను బిలిచిన పుణ్యమును ఈ కృతఘ్నునకిమ్ము. దానితో వాడు ముక్తుడగును. ఇట్లు ఆయా పుణ్యదానములచేత వారు వారు ముక్తులగుదురు. విష్ణుదాతల మాటలు విని ఆశ్చర్యమొంది బ్రాహ్మణ స్త్రీ ఆయా పుణ్యములను వారివారికిచ్చెను. దానిచేత వారు నరకము నుంచి విడుదలయై దివ్యమానములనెక్కి ఆ స్త్రీని కొనియాడుచు మహాజ్ఞానులు పొందెడి ముక్తిపదమును గూర్చి వెళ్ళిరి. కాబట్టి కార్తీకమాసమందు పురాణశ్రవణమును జేయువాడు హరిలోకమందుండును. ఈ చరిత్రను వినువారు మనోవాక్కాయములచేత సంపాదించబడిన పాపమును నశింపజేసుకొని మోక్షమును బొందుదురు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే ఏకాదశోధ్యాయస్సమాప్త:",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "ఏకాదశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ ద్వాదశాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "మహారాజా! కార్తీకమాసమున కార్తీక సోమవారమున కార్తీక ద్వాదశీవ్రతమును గురించి, సాలగ్రామపు మహిమలను గురించి వివరించెదను వినుమని వశిష్ట మహాముని ఈవిధముగా తెలియచేసిరి.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీక సోమవారము నాడు ఉదయాన్నే లేచి కాలకృత్యములు తీర్చుకొని నదికి వెళ్లి స్నానముచేసి ఆచమనము చేయవలయును. తరువాత శక్తి కొలది బ్రహ్మణునకు దానమిచ్చి ఆ రోజంతయు ఉపవాసము౦డి, సాయంకాలము శివాలయమునకు గాని, విష్ణాలయమునకు గాని వెళ్లి దేవుని పూజించి, నక్షత్ర దర్శనము చేసికొని పిమ్మట భుజింపవలయును. ఈవిధముగా చేసిన వారికి సకల సంపదలు కలుగుటయే గాక, మోక్షము కూడా పొందుదురు. కార్తీక మాసములో శని త్రయోదశి వచ్చిన యెడల నా వత్రమాచరించినచో నూరు రేట్లు ఫలితము కలుగును.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీక శుద్ధ ఏకాదశిరోజున, పూర్ణోపవాసముండి ఆ రాత్రి విష్ణాలయమునకు వెళ్లి శ్రీహరిని మనసారా ధ్యానించి, శ్రీహరి సన్నిధిలో పురాణ కాలక్షేపము చేసి మరునాడు బ్రాహ్మణ సమారాధన చేసిన, కోటి యజ్ఞముల ఫలితము కలుగును. ఈవిధముగా చేసిన వారందరికీ సూర్యగ్రహణ సమయమున గంగానదిలో స్నానముచేసి కోటి బ్రాహ్మణులకు భోజన దానము చేసిన నెంత పుణ్యము కలుగునో దానికంటే అధికముగా ఫలము కలుగును. కార్తీక శుద్ధ ద్వాదశి నాడు శ్రీమన్నారాయుణుడు శేషపానుపు నుండి లేచును గనుక, కార్తీక శుద్ధ ద్వాదశి వ్రతము విష్ణువునకు ఇష్టము.",
        },
        {
          title: "",
        },
        {
          title: "అరోజున శ్రీమంతులెవరైనా ఆవు కొమ్ములకు బంగారు తొడుగులు తగిలించి, ఆవుకాళ్ళకు వెండి డెక్కలు తగిలించి, దూడతో సహా బ్రహ్మణునకు దానమిచ్చిన యెడల ఆ ఆవు శరీర ముందు ఎన్ని రోమములు కలవో అన్ని సంవత్సరాములు ఇంద్ర లోకములో స్వర్గ సుఖములందుదురు. కార్తీక శుద్ధ పాడ్యమి రోజున, కార్తీక పౌర్ణమి రోజున కంచుపాత్రలో ఆవు నెయ్యి పోసి దీపముంచిన వారు పూర్వజన్మ నందు చేసిన సకల పాపములు హరించును. ద్వాదశినాడు యజ్ఞోపవీతములు దక్షిణతో బ్రాహ్మణునకు దానమిచ్చిన వారు ఇహపర సుఖమును పొందగలరు. ద్వాదశి రోజున బంగారు తులసి చెట్టునుగాని, సాలగ్రామమునుగాని ఒక బ్రాహ్మణునకు దానమిచ్చినయెడల నాలుగు సముద్రాల మధ్యనున్న భూమిని దానము చేసినంత ఫలము కలుగును.",
        },

        {
          title: "",
        },
        {
          title: "దీనికి ఉదాహరణముగా ఒక కథ గలదు శ్రద్దగా అలకింపుము.",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> సాలగ్రామ దానమహిమ :</span>,
        },
        {
          title: "",
        },
        {
          title: "పూర్వము అఖ౦డ గోదావరి నదీ తీరమ౦దలి ఒకానొక పల్లెయందు ఒక వైశ్యుడు నివసించుచుండెను. వాడు మిగుల దురాశాపరుడై నిత్యము ధనమును కూడా బెట్టుచు, తాననుభవించక, ఇతరులకు బెట్టక, బీదలకు దానధర్మములు చేయక, ఎల్లప్పుడు పరనిందలతో తానే గొప్ప శ్రీమంతుడుగా విర్రవీగుచూ ఏ జీవికీ కూడా ఉపకారమైననూ చేయక పరులద్రవ్యము నెటుల అపహరింతునా యను తలంపుతో కుత్సిత బుద్ది కలిగి కాలము గడుపుచుండెను.",
        },
        {
          title: "",
        },
        {
          title: "అతడొకనాడు తన గ్రామమునకు సమీపమున నున్న పల్లెలో నివసించుచున్న ఒక బ్రాహ్మణునకు తన వద్దనున్న ధనమును పెద్ద వడ్డీకి అప్పుయిచ్చెను. మరి కొంత కాలమునకు తన సొమ్ము తనకిమ్మనిని అడుగగా ఆ విప్రుడు అయ్యా! తమకీయవలసిన ధనము ఒక నెలరోజుల గడువులో ఇవ్వగలను. మీ ఋణముంచుకోను. ఈజన్మలో తీర్చని ఎడల మరుజన్మమున మీ ఇంట ఏ జంతువుగానో పుట్టి అయినా మీ ఋణము తీర్చుకోగలను అని సవినయముగా వేడుకోనెను. ఆ మాటలకు కోమటి మండిపడి అట్లు వీలులేదు. నా సొమ్ము నాకిప్పుడే ఇవ్వవలయును, లేనియెడల నీక౦ఠమును నరికి వేయుదును అని ఆవేశం కొలదీ వెనుక ముందు ఆలోచించక తన మొలనున్న కత్తితో ఆ బ్రాహ్మణుని కుత్తుకను కొసెను. వెంటనే ఆ బ్రాహ్మణుడు గిలగిల తన్నుకొని చనిపోయెను. ఆ కోమటి భయపడి, అక్కడనే యున్నచో రాజభటులు వచ్చి పట్టుకొందురని జడిసీ తన గ్రామమునకు పారిపోయెను. బ్రాహ్మణ హత్య మహాపాపం కనుక, అప్పటి నుండి ఆ వైశ్యునకు బ్రహ్మహత్యా పాపమావహించి కుష్ఠువ్యాధి కలిగి నానా బాధలూ పడుచూ మరి కొనాళ్లకు మరణించెను. వెంటనే యమదూతలు వచ్చి అతనిని తీసుకోనిపోయి రౌరవాది నరకకూపముల బడద్రోసిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఆ వైశునకు ఒక కుమారుడు కలడు. అతని పేరు ధర్మవీరుడు. ఆ పేరుకు తగినట్లుగానే తండ్రి స౦పాదించిన ధనమును దానదర్మాలు చేయుచు పుణ్యకార్యములు ఆచరించుచు, నీడకొరకై చెట్లు నాటించుచు, నూతులు, చెరవులు త్రవ్వించుచు, సకల జనులను సంతోషపెట్టుచు మంచికీర్తిని సంపాదించెను. కొంత కాలమునకు త్రిలోకసంచారియగు నారదులవారు యమలోకము దర్శించి భూలోకమునకు వచ్చి, త్రోవలో ధర్మవీరుని ఇంటికి వెంచేసిరి. ధర్మవీరుడు నారదులవారికి సాష్టాంగ దండ ప్రణామములు ఆచరించి, విష్ణుదేవునిగా భావించి అర్ఘ్యపాద్యాది విధుల చేత సత్కరించి, చేతులు జోడించి మహానుభావా! నాపుణ్యం కొలదీ నేడు తమ దర్శనం లభించినది. నేను ధన్యుడను. నాజన్మ తరించినది. నా ఇల్లు పావనమైనది. శక్తి కొలదీ నే జేయు సత్కారములను స్వీకరించి తమరువచ్చిన కార్యమును విశధీకరింపుడు అని సవినయుడై వేడుకొనెను.",
        },
        {
          title: "",
        },
        {
          title: "అంత నారదుడు చిరునవ్వు నవ్వి ఓ ధర్మవిరా! నేను నీకోక హితవు చెప్పదలచి వచ్చితిని. శ్రీమహావిష్ణువునకు కార్తీకమాసంలో శుద్ధద్వాదశి మహాప్రీతికరమైన దినము. అరోజున స్నాన, దాన, జపాదులు ఏవి చేసిననూ అత్యంత ఫలం కలుగును. నాలుగు జాతులలో నేజాతివారైననూ స్త్రీ అయినా పురుషుడైనా, జారుడైనా, చోరుడైన, పతివ్రతమైనా, వ్యభిచారిణియైనా కార్తీకశుద్ద ద్వాదశి రోజున సూర్యుడు తులారాశియందు ఉండగా నిష్ఠగా ఉపవాసముండి, సాలగ్రామదానములు చేసిన యెడల వెనుకటి జన్మలందూ, ఈ జన్మమందూ చేసిన పాపములు పోవును. నీ తండ్రి యమలోకంలో మహా నరకమనుభవించుచున్నాడు. అతనిని ఉద్ధరించుటకై నీవు సాలగ్రామదానము చేయక తప్పదు.",
        },
        {
          title: "",
        },
        {
          title: "అట్లుచేసి నీతండ్రి ఋణం తీర్చుకోనుము. అని చెప్పెను. అంతట ధర్మవీరుడు నారద మునివర్యా! వెనుకటి జన్మలందు, ఈ జన్మ మందూ చేసిన పాపములు పోవును. నీ తండ్రి యమలోకంలో మహానరక మనుభ వించుచునాడు. అతనిని ఉద్దరించుటకై నీవు సాలగ్రమదానము చేయక తప్పదు. అట్లు చేసి నీ తండ్రి ఋణం తీర్చుకోనుము, అని చెప్పెను. అంతట ధర్మవీరుడు నారద మునివర్యా! నేను గోదానము, భూదానము, హిరణ్యదానము మొదలగు మహాదానములు చేసియుంటిని, అటువంటి దానములు చేయగా నాతండ్రికి మోక్షము కలుగనప్పుడీ సాలగ్రామ మనే జాతిని దానము చేసినంత మాత్రమున ఆయన యెట్లు వుద్ధరింపబడునాయని సంశయము కలుగుచున్నది. దీనివలన ఆకలిగొన్నవాని ఆకలితీరునా! దాహంగొన్న వానికి దాహం తీరునా? కాక, యెందులకీ దానము చేయవలయును? నేనీ సాలగ్రామదానము మాత్రము చేయజాలనని నిష్కర్షగా పలికెను.",
        },
        {
          title: "",
        },
        {
          title: "ధర్మవీరుని అవివేకమునకు విచారించి వైశ్యుడా! సాలగ్రామమును శిలామాత్రముగా ఆలోచించితివి. అది శిలకాదు. శ్రీహరి యొక్క రూపము. అన్నిదానములకంటె సాలగ్రామదానము చేసినచో కలుగు ఫలమే గొప్పది. నీ తండ్రిని నరకబాధ నుండి విముక్తున్ని గావింప నెంచితివేని, ఈ దానముతప్ప మరొక మార్గము లేదు అని చెప్పి నారదుడు వెడలిపోయాను. ధర్మవీరుడు ధనబలము గలవాడై యుండియు, దానసామర్థ్యము కలిగియుండియు కూడా సాలగ్రామ దానము చేయలేదు. కొంత కాలమునకు అతడు చనిపోయెను. నారదుడు చెప్పిన హితభోధను పెడచెవిని పెట్టుటచేత మరణాంతర మేడు జన్మలయందు పులియై పుట్టి, మరి మూడు జన్మలందు వానరమై పుట్టి, ఐదు జన్మలు ఎద్దుగా పుట్టి, పది జన్మలు మానవ స్త్రీగా పుట్టి, పదిజన్మలు పందిగా జన్మించి యుండెను. అట్లు జరగిన తరువాత పదకొండవ జన్మలో ఒక పేద బ్రాహ్మణునింట స్త్రీగా పుట్టిగా ఆమెకు యౌవనకాలము రాగా ఆపేద బ్రాహ్మణుడు ఒక విద్వాంసునకు ఇచ్చి పెండ్లి చేసెను. పెండ్లి అయిన కొంతకాలమునకు ఆమె భర్త చనిపోయెను.",
        },
        {
          title: "",
        },
        {
          title: "చిన్నతనమందే ఆమెకు అష్టకష్టములు సంభవించినందులకు తల్లిదండ్రులు బంధుమిత్రులు చాల దుఃఖించిరి. తండ్రి ఆమెకు ఈవిపత్తు ఎందువలన కలిగే నాయని దివ్యదృష్టితో గ్రహించి వెంటనే అమెచేత సాలగ్రామదానము చేయించి నాకు బాల వైధవ్యమునకు కారణమైన పూర్వజన్మ పాపము నశించుగాక యని చెప్పించి సాలగ్రామ దానఫలమును ధారపోసెను. ఆరోజు కార్తీక సోమవారమగుట వలన అ సాలగ్రామ దానఫలముతో ఆమె భర్త జీవించెను. పిదప ఆ నూతన దంపతులు చిరకాలమునకు సకల సౌఖ్యములతో జీవించి, జన్మాంతరమున స్వర్గమున కరిగిరి. మరికొంత కాలమునకు ఆ బ్రాహ్మణ పుత్రిక మరొక బ్రాహ్మణుని ఇంట కుమారుడుగా పుట్టి నిత్యమూ సాలగ్రామదానము చేయుచు ముక్తినొందెను.",
        },
        {
          title: "",
        },
        {
          title: "కావున ఓ జనకా! కార్తీకశుద్ద ద్వాదశిరోజున సాలగ్రామ దానం చేసిన దాన ఫలము ఇంతింత గాదు. ఎంతో ఘనమైనది. కావున నీవును ఆ సాలగ్రామ దానమును చేయుము.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే ద్వాదశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "ద్వాదశాధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ త్రయోదశాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> కన్యాదాన ఫలం :</span>,
        },
        {
          title: "",
        },
        {
          title: "తిరిగి వశిష్టుడు జనకుడితో ఇలా అంటున్నాడు ఓ మహారాజా! కార్తీకమాసంలో ఇంకా విధిగా చేయాల్సిన ధర్మాలు చాలా ఉన్నాయి. వాటిని వివరిస్తాను విను. కార్తీకమాసంలో నదీస్నానం ముఖ్యం. దానికంటే ఒక పేద బ్రాహ్మణుడి కుమారుడికి ఉపనయనం చేయడం మరింత ముఖ్యం. ఒకవేళ ఉపనయనానికి అయ్యే ఖర్చు అంతా భరించే శక్తిలేనప్పుడు మంత్రాక్షతలు, దక్షిణ తాంబూలాలు, సంభావనలతో తృప్తిపరిచినా ఫలితం కలుగుతుంది. ఈ విధంగా ఓ పేద బ్రాహ్మణుడి బాలుడికి ఉపనయనం చేసినట్లయితే ఎంతటి మహాపాపాలైనా తొలగిపోతాయి. ఎన్ని బావులు, చెరువులు తవ్వించినా పైన చెప్పినట్లుగా ఒక బ్రాహ్మణుడి బాలుడికి ఉపనయనం చేస్తే వచ్చే ఫలితానికి సరితూగవు. అంతకన్నా ముఖ్యమైనది కన్యాదానం. కార్తీకమాసంలో భక్తిశ్రద్ధలతో కన్యాదానం చేసినట్లయితే తను తరించడమే కాకుండా తన పితృదేవతలను కూడా తరింపజేసినవారవుతారు. ఇందుకు ఒక వృత్తాంతముంది చెబుతాను విను అని ఇలా చెప్పసాగాడు.",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> సువీర చరితం :</span>,
        },
        {
          title: "",
        },
        {
          title: "పూర్వం వంగ దేశంలో గొప్ప పరాక్రమ వంతుడు, శూరుడు అయిన సువిరుడను ఒక రాజు ఉండేవాడు. అతనికి రుపవతి అయిన భార్య ఉంది. ఒకసారి అతను శత్రురాజులచే పరాజితుడయ్యాడు. దీంతో అతను భార్యతో కలిసి అరణ్యానికి పారిపోయి, ధన హీనుడై, నర్మదానదీ తీరంలో పర్ణశాల నిర్మించుకుని, కందమూలాలు భక్షిస్తూగడపసాగాడు. కొన్నాళ్లకు అతని భార్య ఒక బాలికను కన్నది. ఆ బిడ్డను అతి గారాబంతో పెంచుచుండేవారు. క్షత్రియ వంశమందు జన్మించిన ఆ బాలికకు ఆహారాది సదుపాయాలు లేకపోయినా శుక్లపక్ష చంద్రుడి మాదిరిగా రోజురోజూ అభివృద్ధి కాసాగింది. అతిగారాబంతో పెరగసాగింది. అలా రోజులుగడుస్తుండగా ఆ బాలిక యవ్వనవతియైంది. ఒక దినాన వానప్రస్తుడి కుమారుడు ఆ బాలికను చూసి, అందచందాలకు పరవశుడై, తనకు ఇచ్చి వివాహం చేయమని ఆ రాజును కోరాడు. అందుకా రాజు ”ఓ మునిపుత్రా! ప్రస్తుతం నేను కడు బీద స్థితిలో ఉన్నాను. అష్టదరిద్రాలు అనుభవిస్తున్నాను. మా కష్టాలు తీరేందుకు కొంత ధనమిచ్చినట్లయితే నా బిడ్డనిచ్చి పెండ్లి చేస్తానని చెప్పాడు. దాంతో ఆ మునిపుత్రుడు చేతిలో పైసా లేకున్నా బాలికపై ఉన్న మక్కువతో కుబేరుడిని గురించి ఘోర తపస్సు చేశాడు. కుబేరుడిని మెప్పించి, ధన పాత్ర సంపాదించాడు. రాజు ఆ పాత్రను తీసుకుని, సంతోషించి, తన కుమార్తెను ముని కుమారుడికిచ్చి పెళ్లి చేశాడు. నూతన దంతపతులిద్దరినీ అత్తవారింటికి పంపాడు.",
        },

        {
          title: "",
        },
        {
          title: "అలా మునికుమారుడు తన భార్యను వెంటబెట్టుకుని, తల్లిదండ్రుల వద్దకు వెళ్లి, నమస్కరించి, జరిగిన సంగతిని చెప్పాడు. తన భార్యతో కలిసి సుఖంగా జీవించసాగాడు. అయితే సువీరుడు మునికుమారుడిచ్చిన పాత్రను తీసుకుని, స్వేచ్ఛగా ఖర్చుచేస్తూ భార్యతో సుఖంగా ఉండసాగాడు. కొంతకాలానికి అతనికి మరో బాలిక జన్మించింది. ఆమెకు కూడా యుక్తవయసు రాగానే, ఎవరికైనా ధనానికి అమ్మాలనే ఆశతో ఎదురుచూడసాగాడు.",
        },
        {
          title: "",
        },
        {
          title: "ఒక సాధువు తపతీ నదీ తీరం నుంచి నర్మదా నదీ తీరానికి స్నానార్థం వస్తుండగా దారిలో ఉన్న సువీరుడిని కలుసుకున్నాడు. ”ఓయీ! నీవెవరు? నీ ముఖ వర్చస్సు చూస్తే రాజవంశంలో పుట్టినవాడిలా ఉన్నావు. ఈ అడవిలో ఏం చేస్తున్నావు? భార్యాపిల్లలతో ఇక్కడ జీవించడానికి కారణమేమిటి?” అని ప్రశ్నించాడు. దానికి సువీరుడిలా చెబుతున్నాడు. ”ఓ మహానుభావా! నేను వంగదేశాన్ని పరిపాలించేవాడిని. నా పేరు సువీరుడు. నా రాజ్యాన్ని శత్రువులు ఆక్రమించడంతో భార్యాసమేతంగా ఈ అడవిలో నివసిస్తున్నాను. దరిద్రం కంటే కష్టమేది ఉండదు. పుత్రశోకం కంటే దు:ఖం ఉండదు. అలాగే భార్యావియోగం కంటే సంతాపం వేరొకటి లేదు. అందువల్ల రాజ్యభ్రష్టుడనైనా ఈ కారడవిలో ఉన్నంతలో సంతృప్తి పొందుతూ కుటుంబ సమేతంగా బతుకుతున్నాను. నాకు ఇద్దరు కుమార్తెలు.",
        },
        {
          title: "",
        },
        {
          title: "అందులో మొదటి కుమార్తెను ఒక ముని పుత్రునకు ఇచ్చి వాడి వద్ద కొంత ధనము తీసుకున్నాను. దాంతో ఇప్పటి వరకు కాలక్షేపం చేస్తున్నాను” అని చెప్పగా, ఓ రాజా! నీవు ఎంతటి దరిద్రుడవైనా ధర్మ సూక్షం ఆలోచించకుండా కన్యను అమ్ముకున్నావు. కన్య విక్రయం మహాపాతకం. కన్యను విక్రయించువాడు అసి పత్రవానమనే నరకాన్ని అనుభవిస్తాడు. ఆ ద్రవ్యాలతో చేసే వ్రతం ఫలించదు. కన్య విక్రయం చేసేవారికి పితృదేవతలు పుత్ర సంతతి కలుగకుండా శపిస్తారు. అలాగే కన్యను ధనమిచ్చి కొని, పెండ్లాడిన వారి గృహస్థధర్మాలు వ్యర్థమగుటయేకాకుండా, అతను మహా నరకం అనుభవిస్తాడు. కన్యను విక్రయించేవారికి ఎలాంటి ప్రాయశ్చిత్తం లేదు. కాబట్టి రాబోయే కార్తీక మాసంలో రెండో కుమార్తెకు శక్తికొలదీ బంగారు ఆభరణాలతో అలంకరించి, సదాచార సంపన్నుడికి, ధర్మబుద్ధిగలవాడికి కన్యాదానం చేయి. అట్లు చేసినట్లయితే గంగాస్నానం, అశ్వమేథయాగ ఫలాలను పొందుతావు. మొదటి కన్యను అమ్మిన పాప ఫలాన్ని తొలగించుకున్న వాడివవుతావు అని రాజుకు హితోపదేశం చేశాడు.",
        },
        {
          title: "",
        },
        {
          title: "అందుకారాజు చిరునవ్వుతో ఓ మునివర్యా! దేహసుఖం కంటే దానధర్మాలతో వచ్చిన ఫలం ఎక్కువా? తాను బతికుండగానే భార్యాబిడ్డలు, సిరిసంపదలతో సుఖంగా ఉండకుండా, చనిపోయిన తర్వాత వచ్చే మోక్షం కోసం ప్రస్తుతం ఉన్న అవకాశాలను చేతులారా జార విడుచుకోమంటారా? ధనం, బంగారం కలవాడే ప్రస్తుతం లోకంలో రాణించగలడు. కానీ, ముక్కు మూసుకుని, నోరుమూసుకుని, బక్కచిక్కి శల్యమైనవాడిని లోకం గుర్తిస్తుందా? గౌరవిస్తుందా? ఐహిక సుఖాలే గొప్పసుఖాలు. కాబట్టి నా రెండో బిడ్డను నేనడిగతినంత ధనం ఇచ్చే వారికే ఇచ్చి పెండ్లిచేస్తాను. కానీ కన్యాదానం మాత్రం చేయను అని నిక్కచ్చిగా చెప్పాడు. ఆ మాటలకు ఆ సన్యాసి ఆశ్చర్యపడి, తన దారిన తాను వెళ్లిపోయాడు. మరికొన్ని రోజులకు సువీరుడు చనిపోయాడు. వెంటనే యమభటులు వచ్చి, అతన్ని తీసుకుపోయిరి. యమలోకంలో అసిపత్రవనం అనే నరకంలో పారేశారు. అక్కడ అనేక విధాలుగా బాధించారు. సువీరుడికి పూర్వికుడైన శ్రుతుకీర్తి అనే రాజు ధర్మయుక్తంగా ప్రజల్ని పాలించి, ధర్మాత్ముడై మృతిచెంది, స్వర్గాన్ని పొందాడు. అయితే ఆయన వంశజుడైన సువీరుడు చేసిన కన్యా విక్రయం వల్ల శ్రుతుకీర్తి కూడా స్వర్గం నుంచి నరకానికి వచ్చాడు.  అంతట శ్రుతకీర్తి నేను ఒకరికి ఉపకారం చేశానే తప్ప అపకారమెన్నడూ చేయలేదు. దానధర్మాలు, యజ్ఞయాగాదులు చేశాను. అయినా నాకు ఈ దుర్గతి ఎలా? అని నిండు కొలువులో యమధర్మ రాజును ప్రశ్నించాడు.",
        },
        {
          title: "",
        },
        {
          title: "వినయంగా ఇలా చెబుతున్నాడు, ప్రభూ నీవు సర్వజ్ఞుడవు. ధర్మమూర్తివి. బుద్ధిశాలివి. ప్రాణకోటిని తారతమ్య బేధాలు లేకుండా సమానంగా చూస్తావు. నేనెన్నడూ పాపం చేయలేదు. అయితే నన్ను స్వర్గం నుంచి ఇక్కడకు ఎందుకు తీసుకొచ్చారు? కారణమేమిటి? అని ప్రశ్నించాడు. దానికి యమధర్మరాజు శ్రుతకీర్తిని చూచి, ఓయీ! నీవు న్యాయమూర్తివి. ధర్మజ్ఞుడవే. నీవు ఎలాంటి దూరాచారం చేయలేదు. అయినా నీ వంశీయుడైన సువీరుడు తన జ్యేష్ఠ పుత్రికను అమ్ముకొన్నాడు. కన్యను అమ్ముకునే వారు, వారి పూర్వీకులు ఎంతటి పుణ్యవంతులైనా నరకాలను అనుభవించక తప్పదు. నీచజన్మలు ఎత్తవలసి ఉంటుంది. నీవు పుణ్యాత్ముడవే. అయితే నీకో మార్గం చెబుతాను. నీకు మానవ శరీరాన్ని ఇస్తాను. నీ వంశీయుడైన సువీరుడికి ఇంకో కుమార్తె ఉన్నది. ఆమె నర్మదానదీ తీరంలో తల్లివద్దే పెరుగుతున్నది. అక్కడకు పోయి, ఆ కన్యను వేద పండితుడు, శీలవంతుడికి కార్తీక మాసంలో సాలంకృతంగా కన్యాదానం చేయి. నీవు, మీవాళ్లు ఆ పుణ్యఫలంతో స్వర్గానికి వెళ్తారు అని చెప్పాడు. పుత్రికా సంతానం లేనివారు తమ ద్రవ్యంతో కన్యాదానం చేసినా, విధిగా ఆంబోతుకు వివాహం చేసినా కన్యాదాన ఫలం వస్తుంది. కావున నీవు భూలోకానికి వెళ్లి నేను చెప్పినట్లు చేయి. ఆ కార్యం కారణంగా పితృగణమంతా తరిస్తారు అని యముడు సెలవిచ్చెను.",
        },
        {
          title: "",
        },
        {
          title: "శ్రుతకీర్తి యముడికి నమస్కరించి సెలవు తీసుకుని, నర్మదా నదీతీరంలో ఒక పర్ణకుటీరంలో నివసిస్తున్న సువీరుడి భార్యను, కుమార్తెను చూచి, సంతోషపడి, ఆమెతో అసలు విషయం చెప్పి, కార్తీక మాసంలో సువీరుడి కూతురికి కన్యాదానం చేశాడు. ఆ వెంటనే సువీరుడు, శ్రుతకీర్తి, వారి పూర్వీకులు పాపవిముక్తులై, స్వర్గలోకాన్ని చేరారు.",
        },
        {
          title: "",
        },
        {
          title: "ఓ జనకమహారాజా! కార్తీకంలో కన్యాదానానికి అంతటి శక్తి ఉంది. అత్యంత పుణ్యఫలితాన్ని ఇస్తుంది. కాబట్టి కార్తీకమాసంలో కన్యాదానం చేసేవాడు విష్ణుసాన్నిధ్యాన్ని పొందుతాడు అని వివరించాడు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే త్రయోదశాధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "త్రయోదశాధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ చతుర్ధశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> ఆబోతుకు అచ్చువేసి వదులుట :</span>,
        },
        {
          title: "",
        },
        {
          title: "మళ్లీ వశిష్టమహాముని కార్తీక మాస మహత్యాలను గురించి తనకు తెలిసిన అన్ని విషయాలను జనకుడికి చెప్పాలనే కుతూహలంతో ఇలా చెబుతున్నారు. ఓ రాజా! కార్తీక పౌర్ణమి రోజున పితృప్రీతిగా వృషోత్సవం చేయడం, శివలింగ సాలగ్రామాలను దానం చేయడం, ఉసిరికాయల్ని దక్షణతో దానం చేయడం మొదలగు పుణ్యకార్యాలు చేయడం వల్ల వెనకటి జన్మల్లో చేసిన సమస్త పాపాలు తొలగిపోతాయి. అలా చేసేవారికి కోటి యాగాల ఫలితం దక్కుతుంది. వారి వంశానికి చెందిన పితృదేవతలు పైలోకాల నుంచి ఎవరు ఆబోతుకు అచ్చువేసి వదులుతారో అని చూస్తుంటారు. ప్రతి సంవత్సరం కార్తీక మాసంలో శక్తి కొలదీ దానం చేసి, నిష్టతో వ్రతమాచరించి, శివకేశవులకు ఆలయంలో దీపారాధన చేసి, పూజరోజున రాత్రంతా జాగారం ఉండి, మర్నాడు శక్తికొలదీ బ్రాహ్మణులు, సన్యాసులకు భోజనం పెట్టిన వారు ఇహ, పర లోకాల్లో సర్వసుఖాలను పొందగలరు అని వివరించారు.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీకమాసంలో చేయాల్సిన పనులను చెప్పిన వశిష్టుడు మరికొన్ని నిత్యాచరణ విధులతోపాటు, చేయకూడనివేవో ఇలా చెబుతున్నాడు. ఓ రాజా! పరమ పవిత్రమైన ఈ నెలలో పరాన్న భక్షణ చేయరాదు. ఇతరుల ఎంగిలి ముట్టుకోకూడదు, తినకూడదు. శ్రాద్ధ భోజనం చేయకూడదు. నీరుల్లి తినకూడదు. తిలాదానం తగదు. శివార్చన, సంధ్యావందనం, విష్ణుపూజ చేయనివారు వండిన వంటలు తినరాదు. పౌర్ణమి, అమావాస్య, సోమవారాల్లో సూర్యచంద్ర గ్రహణం రోజుల్లో భోజనం చేయరాదు. కార్తీక మాసంలో నెలరోజులూ రాత్రుళ్లు భోజనం చేయకూడదు. ఈ నెలలో విధవ వండింది తినకూడదు.",
        },
        {
          title: "",
        },
        {
          title: "ఏకాదశి, ద్వాదశి వ్రతాలు చేసేవారు ఆ రెండు రాత్రులు తప్పనిసరిగా జాగారం చేయాలి. ఒక్కపూట మాత్రమే భోజనం చేయాలి. ఈ నెలలో ఒంటికి నూనె రాసుకుని స్నానం చేయకూడదు. పురాణాలను విమర్శించరాదు. కార్తీక మాసంలో వేడినీటితో స్నానం కల్లుతో సమానమని బ్రహ్మదేవుడు చెప్పాడు. కాబట్టి వేడినీటి స్నానం చేయకూడదు. ఒకవేళ అనారోగ్యం ఉంది, ఎలాగైనా విడవకుండా కార్తీకమాస వ్రతం చేయాలనే కుతూహలం ఉన్నవారు మాత్రమే వేడినీటి స్నానం చేయొచ్చు. అలా చేసేవారు గంగా, గోదావరి, సరస్వతీ, యమునా నదుల పేర్లను మనస్సులో స్మరించి స్నానం చేయాలి. తనకు దగ్గరగా ఉన్న నదిలో ప్రాత:కాలంలో పూజ చేయాలి. నదులు అందుబాటులో లేని సమయంలో నూతిలోగానీ, చెరువులో గానీ స్నానం చేయవచ్చు. ఆ సమయంలో కింది శ్లోకాన్ని స్మరించుకోవాలి.",
        },
        {
          title: "",
        },
        {
          title: "శ్లో|| గంగే చ యమునే చైవ గోదావరి సరస్వతీ",
        },
        {
          title: "నర్మదా సింధు కావేరి జలేస్మిన్ సన్నిదింకురు||",
        },
        {
          title: "",
        },
        {
          title: "కార్తీక మాస వ్రతం చేసేవారు పగలు పురాణ పఠనం, శ్రవణం, హరికథా కాలక్షేపంతో కాలం గడపాలి. సాయంకాలంలో సంధ్యావందనాది కార్యక్రమాలు పూర్తిచేసుకుని, శివుడిని కల్పోక్తంగా పూజించాలి అని వివరించారు. అనంతరం కార్తీకమాస శివపూజాకల్పాన్ని గురించి వివరించారు.",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> కార్తీక మాస శివ పూజ కల్పము :</span>,
        },
        {
          title: "1. ఓం శివాయ నమ: - ధ్యానం సమర్పయామి",
        },
        {
          title: "2. ఓం పరమేశ్వరాయ నమ: - అవాహం సమర్పయామి",
        },
        {
          title: "3. ఓం కైలసవాసయ నమ: - నవరత్న సంహాసనం సమర్పయామి",
        },
        {
          title: "4. ఓం గౌరీ నాథాయ నమ: - పాద్యం సమర్పయామి",
        },
        {
          title: "5. ఓం లోకేశ్వరాయ నమ: - అర్ఘ్యం సమర్పయామి",
        },
        {
          title: "6. ఓం వృషభ వాహనాయ నమ: - స్నానం సమర్పయామి",
        },
        {
          title: "7. ఓం దిగంబరాయ నమ: - వస్త్రం సమర్పయామి",
        },
        {
          title: "8. ఓం జగన్నాథాయ నమ: - యజ్ఞోపవితం సమర్పయామి",
        },
        {
          title: "9. ఓం కపాల ధారిణే నమ: - గంధం సమర్పయామి",
        },
        {
          title: "10. ఓం సంపూర్ణ గుణాయ నమ: - పుష్పం సమర్పయామి",
        },
        {
          title: "11. ఓం మహేశ్వరాయ నమ: - అక్షతాన్ సమర్పయామి",
        },
        {
          title: "12. ఓం పార్వతీ నాథాయ నమ: - ధూపం సమర్పయామి",
        },
        {
          title: "ఓం తేజో రూపాయ నమ: - దీపం సమర్పయామి",
        },
        {
          title: "ఓం లోక రక్షాయ నమ: - నైవేధ్యం సమర్పయామి",
        },
        {
          title: "ఓం త్రిలోచనాయ నమ: - కర్పూర నీరాజనం సమర్పయామి",
        },
        {
          title: "ఓం శంకరాయ నమ: - సువర్ణ మంత్ర పుష్పం సమర్పయామి",
        },
        {
          title: "17. ఓం భావయ నమ:   ప్రదక్షణ నమస్కారాన్ సమర్పయామి",
        },
        {
          title: "",
        },
        {
          title: "ఈ ప్రకారం కార్తీకమాసమంతా పూజలు నిర్వహించాలి. శివసన్నిధిలో దీపారాధన చేయాలి. ఈ విధంగా శివపూజ చేసినవారు ధన్యులవుతారు. పూజ తర్వాత తన శక్తిని బట్టి బ్రాహ్మణులకు సమర్థన చేసి, దక్షిణ తాంబూలాలతో సత్కరించాలి. ఇలా చేసినట్లయితే నూరు అశ్వమేథాలు, వేయి వాజపేయి యాగాలు చేసిన ఫలితం లభిస్తుంది. ఈ మాసంలో నెలరోజులు బ్రాహ్మణ సమారాధన, శివకేశవుల సన్నిధిలో నిత్య దీపారాధన, తులసికోట వద్ద కర్పూర హారతులతో దీపారాధన చేసిన వారికి, వారి వంశీయులకు, పితృదేవతలకు మోక్షం లభిస్తుంది. శక్తి కలిగి ఉండి కూడా ఈ వ్రతమాచరించనివారు వంద జన్మలు నానాయోనులయందు జన్మించి, ఆ తర్వాత నక్క, కుక్క, పంది, పిల్లి, ఎలుక మొదలగు జన్మలనెత్తుతారు.",
        },
        {
          title: "",
        },
        {
          title: "ఈ వ్రతాన్ని శాస్త్రోక్తంగా ఆచరించేవారు పదిహేను జన్మల పూర్వజ్ఞానాన్ని పొందుతారు. వ్రతం చేసినా, పురాణం చదివినా, విన్నా అట్టివారు సకలైశ్వర్యాలను పొందుతారు. అంత్యమున మోక్షాన్ని పొందెదరు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే చతుర్ధశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "చతుర్ధశోధ్యాయము ",
    },
    {
      CatID: [
        {
          title: "#అథ పంచదశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> దీప ప్రజ్వలనం - ఎలుకకు పూర్వజన్మ స్మృతి :</span>,
        },
        {
          title: "",
        },
        {
          title: "తిరిగి జనక మహారాజుతో వశిష్టమహాముని ఇలా అంటున్నారు. ఓ జనకా! కార్తీక మహత్యాన్ని గురించి ఎంత చెప్పినా పూర్తికాదు. కానీ, ఇంకో ఇతిహాసం చెబుతాను. శ్రద్ధగా విను అని ఇలా చెప్పసాగెను.ఈ నెలలో హరినామ సంకీర్తనలు చేయడం, వినడం, శివకేశవుల వద్ద దీపారాధన చేయడం, పురాణ పఠనం లేదా శ్రవణం, సాయం సమయాల్లో దేవతా దర్శనాలు విధిగా చేయాలి. అలా చేయనివారు కాలసూత్రమనే నరకంలో కొట్టుమిట్టాడుతారు. కార్తీక శుద్ధ ద్వాదశిరోజున మనసారా శ్రీహరిని పూజించిన వారికి అక్షయ పుణ్యం కలుగుతుంది. శ్రీమన్నారాయణును గంధపుష్పాలతో, అక్షితలతో పూజించి, ధూపదీప నైవేద్యాలు సమర్పించినట్లయితే విశేష ఫలం లభిస్తుంది. ఇలా నెలరోజులు క్రమం తప్పకుండా చేసిన వారు అంత్యమున దేవదుందుభులు మోగుతుండగా వైకుంఠంలో విష్ణుసాన్నిధ్యం పొందగలరు. ఇలా నెలరోజులు పూజాదికాలు నిర్వర్తించలేనివారు కార్తీక శుద్ధ త్రయోదశి, చతుర్ధశి, పౌర్ణమి రోజుల్లో నిష్టతో పూజ చేసి, ఆవునేతితో దీపం వెలిగించాలి. ఆవుపాలు పితికినంత సేపైనా దీపం వెలిగించిన వారికి తదుపరి బ్రాహ్మణ జన్మ ప్రాప్తిస్తుంది. ఇతరులు పెట్టిన దీపంలో నూనె వేసినా, అవసానదశలో ఉన్న దీపం వత్తిని పైకి జరిపి దీపాన్ని వృద్ధి చేసినా, కొండెక్కిన దీపాన్ని తిరిగి వెలిగించినా వారి సమస్తపాపాలు హరిస్తాయి. దీనికి సంబంధించి ఒక కథ చెబుతాను విను అని ఇలా చెప్పసాగెను.",
        },
        {
          title: "",
        },
        {
          title: "సరస్వతీ నదీ తీరంలో శిథిలమైన దేవాలయమొకటి ఉండేది. కర్మనిష్టుడైన దయార్థ్ర హృదయుడైన ఒక యోగిపుంగవుడు ఆ దేవాలయం వద్దకు వచ్చి, కార్తీకమాసమంతా అక్కడే గడిపి, పురాణ పఠనం చేయాలని తలంచాడు. ఆ పాడుబడ్డ దేవాలయాన్ని శుభ్రంగా ఊడ్చి, నీళ్లతో కడిగి, బొట్టు పెట్టి, పక్క గ్రామాలకు వెళ్లి, ప్రమిదలు తెచ్చి, దూదితో వత్తులు చేసి, పన్నెండు దీపాలు పెట్టాడు. స్వామిని పూజిస్తూ నిష్టతో పురాణాన్ని చదువుతుండెను. ఈ విధంగా కార్తీకమాసం ఆరంభం నుంచి చేయసాగాడు. ఒక రోజున ఓ ఎలుక ఆ దేవాలయంలోకి ప్రవేశించింది. నాలుగు మూలలు వెతికి, తినడానికి ఏమి దొరుకుతుందా అని అక్కడ ఆరిపోయిన వత్తిని తినాలని నిర్ణయించుకుంది. అలా ఆ వత్తిని నోట కరుచుకుని తీసుకెళ్తుండగా పక్కనే ఉన్న దీపానికి తగిలి, ఎలుక నోట్లో ఉన్న వత్తి కొసకు నిప్పు అంటుకుంది. అలా ఆరిపోయిన వత్తి వెలుగుతూ వచ్చింది. అది కార్తీకమాసం కావడం, శివాలయంలో ఆరిపోయిన వత్తిని ఎలుక వెలగించడం వల్ల దాని పాపాలు హరించుకుపోయి, పుణ్యం కలిగింది. వెంటనే దానికి మానవ రూపం సిద్ధించింది.",
        },
        {
          title: "",
        },
        {
          title: "ధ్యాన నిష్టలో ఉన్న యోగి పుంగవుడు కళ్లు తెరిచిచూడగా పక్కనే ఒక మానవుడు నిలబడి ఉండడం గమనించాడు. ఓయీ! నీవు ఎవరవు? ఎందుకు ఇలా నిలబడ్డావు? అని ప్రశ్నించగా, అతను వినమ్రంగా అయ్యా! నేను ఒక ఎలుకను. రాత్రి నేను తిండికోసం వెతుకుతుండగా ఈ ఆలయంలోకి వచ్చాను. ఇక్కడేమీ దొరక్కపోవడంతో నెయ్యివాసనలతో ఉన్న ఆరిపోయిన వత్తిని తినాలని దాన్ని నోటకరిచి తీసుకువెళ్లసాగాను. పక్కనే ఉన్న దీపానికి తగిలింది. ఆ వత్తి వెలగడం వల్ల నా పాపాలు హరించుకుపోయాయనకుంటాను. అందుకే వెంటనే పూర్వజన్మమెత్తాను. కానీ ఓ మహానుభావా! నేను ఎందుకీ మూషిక జన్మనెత్తానో, దానికి కారణమేమో తెలియదు. మీరు యోగిపుంగవుల్లా ఉన్నారు. దయచేసి నాకు విశదీకరించండి అని కోరాడు.",
        },

        {
          title: "",
        },
        {
          title: "అంతట ఆ యోగి ఆశ్చర్యంతో తన దివ్యదృష్టిచే సర్వం తెలుసుకుని ఇలా చెబుతున్నాడు, ఓయీ! నీవు కిందటి జన్మలో బ్రాహ్మణుడవు. నీ పేరు బహ్లికుడు. నీవు జైనమతానికి చెందినవాడవు. నీ కుటుంబాన్ని పోషించడానికి వ్యవసాయం చేస్తూ ధనాశాపరుడవై దైవ పూజలు, నిత్యకర్మలను మరచావు. నీచుల సహవాసం చేశావు. నిషిద్ధాన్నం తిన్నావు. మంచివారు, యోగ్యులను నిందించావు. పరుల చెంత స్వార్థ చింతన కలిగిఉండడమే కాకుండా, ఆడపిల్లలను అమ్మే వృత్తిని చేపట్టి, దానివల్ల సంపాదించిన ధనాన్ని కూడబెట్టావు. సమస్త తినుబండారాలను చౌకగా కొని వాటిని ఎక్కువ ధరలకు అమ్మావు. అలా అమ్మిన ధనాన్ని నీవు అనుభవించక, ఇతరులకు ఇవ్వక భూస్థాపితం చేసి, పిసినారివై జీవించావు. మరణించిన తర్వాత ఎలుక జన్మనెత్తి, వెనకటి జన్మ పాపాలను అనుభవించావు. భగవంతుడి దగ్గర ఆరిపోయిన దీపాన్ని వెలిగించినందున పుణ్యాత్ముడయ్యావు. దానివల్లే నీకు తిరిగి పూర్వజన్మ ప్రాప్తించింది. కాబట్టి, నీవు నీగ్రామానికి వెళ్లి, నీ పెరట్లో పాతిన ధనాన్ని తవ్వితీసి, దాంతో దానధర్మాలు చేసి, భగవంతుడిని ప్రార్థిస్తూ మోక్షం పొందుము అని నీతులు చెప్పి పంపాడు.",
        },
        {
          title: "",
        },
        {
          title: "చూశావా జనకమహారాజా! జీర్ణమైన ఓ వత్తిని తిరిగి వెలిగించినంతమాత్రాన ఒక మూషికం ఎంతటి ఫలితాన్ని పొందిందో? ఇలా కార్తీకమాసంలో దీపం వెలిగించడం వల్ల, కనీసం కొండెక్కేందుకు సిద్ధంగా ఉన్న దీపంలో నూనెవేసి వృద్ధి చేసినా, జీర్ణమైన దీపాన్ని వెలిగించినా ఎలాంటి ఫలితాలు కలుగుతాయనడానికి ఈ వృత్తాంతం ఉదాహరణ అని వివరించాడు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహాత్యే పంచదశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "పంచదశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ షోడశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> స్తంభదీప ప్రశంస :</span>,
        },
        {
          title: "",
        },
        {
          title: "తిరిగి వశిష్టుడు జనకమహారాజుతో ఇలా చెబుతున్నాడు ఓ మహారాజా! కార్తీకమాసం దామోదరుడికి అత్యంత ప్రీతికరమైన మాసం. ఆ నెలలో స్నాన, దాన, వ్రతాదులను చేయడం, సాలగ్రామ దానం చేయడం చాలా ముఖ్యం. ఎవరు కార్తీకమాసంలో తనకు శక్తి ఉన్నా దానం చేయరో అట్టివారు రౌరవాది నరక బాధలు పొందుతారు. ఈ నెలరోజులు తాంబూల దానం చేయువారు చక్రవర్తిగా పుడతారు. ఆ విధంగా నెలలో ఏ ఒక్కరోజూ విడవకుండా తులసి కోటవద్దగానీ, భగవంతుని సన్నిధిలోగానీ దీపారాధన చేసినట్లయితే సమస్త పాపాలు నశిస్తాయి. వైకుంఠ ప్రాప్తి కలుగుతుంది. కార్తీక శుద్ధ పౌర్ణమిరోజు నదీస్నానమాచరించి, భగవంతుడి సన్నిధిలో ధూప దీప నైవేద్యాలతో దక్షిణ తాంబూలాలు, నారీకేళ ఫలాలు దానం చేసినట్లయితే చిరకాలం నుంచి సంతానం లేనివారికి పుత్ర సంతానం కలుగుతుంది.",
        },
        {
          title: "",
        },
        {
          title: "సంతానం ఉన్నవారు ఇలా చేస్తే వారికి సంతాన నష్టమనేది ఉండదు. పుట్టిన బిడ్డలు చిరంజీవులై ఉంటారు. ఈ నెలలో ధ్వజస్తంభంలో ఆకాశ దీపం వెలిగించినవారు వైకుంఠంలో సకల భోగాలు అనుభవిస్తారు. కార్తీకమాసమంతా ఆకాశదీపంగానీ, స్తంభదీపంగానీ పెట్టి, నమస్కరించిన స్త్రీ,పురుషులకు సకలైశ్వర్యాలు కలిగి, వారి జీవితం ఆనందదాయకంగా ఉంటుంది. ఆకాశదీపం పెట్టేవారు శాలిదాన్యంగానీ, నువ్వులుగానీ ప్రమిద అడుగున పోయాలి. దీపం పెట్టడానికి శక్తి ఉండి కూడా దీపం పెట్టనివారు లేదా దీపం పెట్టేవారిని పరిహాసం చేసేవారు చుంచు జన్మ ఎత్తుతారు. ఇందుకు ఒక కథ ఉంది చెబుతాను. సావధానంగా విను అని ఇలా చెప్పసాగాడు.",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> దీపస్తంభం విప్రుడగుట :</span>,
        },
        {
          title: "",
        },
        {
          title: "రుష్యాగ్రగణ్యుడైన మతంగ మహాముని ఒకచోట ఆశ్రమాన్ని ఏర్పాటు చేసుకుని, దానికి దగ్గర్లో ఒక విష్ణు మందిరాన్ని కూడా నిర్మించారు. నిత్యం పూజలు చేస్తూ ఉండేవారు. కార్తీక మాసంలో ఆ ఆశ్రమం చుట్టుపక్కల ఉండే మునులు కూడా అక్కడకు వచ్చి పూజాదికాలు నిర్వహించేవారు. ఒకరోజు ఆ మునుల్లో ఒక వృద్ధుడు తక్కినవారిని చూసి, ఓ సిద్ధులారా! కార్తీకమాసంలో హరిహరాదుల ప్రీతికోసం స్తంభదీపం పెట్టిన వైకుంఠ ప్రాప్తి కలుగుతుందని మనకందరికీ తెలిసిన విషయమే కదా! రేపు కార్తీక శుద్ధ పౌర్ణమి. హరిహరాదుల ప్రీతికోసం ఈ ఆలయానికి ఎదురుగా ఒక స్తంభం పాతి, దానిపై దీపం పెడదాం. అంతా కలిసి అడవికి వెళ్లి, నిడుపాటి స్తంభం తీసుకువద్దాం అని కోరారు.",
        },

        {
          title: "",
        },
        {
          title: "అందుకు అంతా సంతసించి, పరమానందభరితులై అడవికి వెళ్లి, చిలువలు, వలువలు లేని ఓ చెట్టును మొదలు నుంచి నరికి, దాన్ని తీసుకొచ్చి, ఆలయంలో స్వామివారికి ఎదురుగా పాతారు. దానిపై శాలి ధాన్యముంది, ఆవునేతితో నింపిన పాత్రను దానిపై పెట్టి, అందులో వత్తిని వేసి, వెలిగించారు. ఆ తర్వాత వారంతా కూర్చుని పురాణ పఠనం చేయసాగారు. అంతలో ఫళఫలా మనే శబ్ధం వచ్చింది. వారు అటు చూడగా వారు పాతిన స్తంభం పడిపోయి ముక్కలై కనిపించింది. దీపం కూడా ఆరిపోయి, చెల్లాచెదురుగా పడిపోయింది. ఆ దృశ్యం చూసినవారంతా ఆశ్చర్యంతో నిలబడిపోయారు. అంతలో ఆ స్తంభం నుంచి ఒక పురుషుడు బయటకు వచ్చాడు. మునులంతా అతన్ని చూసి, ఆశ్చర్యంతో ఓయీ నీవెవరవు? నీవీ స్తంభం నుంచి ఎలా వచ్చావు? నీ కథేంటి? అని ప్రశ్నించారు.",
        },
        {
          title: "",
        },
        {
          title: "దానికి ఆ పురుషుడు మునులందరికీ నమస్కరించి, పుణ్యాత్ములారా! నేను కిందటి జన్మలో బ్రాహ్మణుడను. ఒక జమిందారుగా సకలైశ్వర్యాలతో తలతూగాను. నా పేరు ధన లోభుడు. నాకు చాలా ఐశ్వర్యం ఉండడం వల్ల మదాంధుడనై న్యాయాన్యాయ విచక్షణలేక ప్రవర్తించాను. దుర్భుద్ధుల వల్ల వేదాలను చదవక, శ్రీహరిని పూజింపక, దానధర్మాలు చేయకుండా ఉంటిని. నేనును, నా పరివారంతో కూర్చుండి ఉన్న సమయంలో ఎవరైనా విప్రులు వచ్చినా వారితో నా కాళ్లను కడిగించి, ఆ నీటిని వారి తలపై వేసుకునేలా చేసి, నానా దుర్భాషలాడేవాడిని. నేను ఉన్నతాసనంపై కూర్చుని, అతిథులను నేలపై కూర్చోమని చెప్పేవాడిని. స్త్రీలను, పసిపిల్లలను హనీంగా చూసేవాడిని. జనాలంతా నా చేష్టలకు భయపడేవారు. నన్ను మందలించే ధైర్యం ఎవరికీ ఉండేది కాదు. నేను చేసే పాపకార్యాలకు హద్దులేకపోయింది. ధర్మాలంటే ఏమిటో నాకు తెలియదు. ఇంత దుర్గార్గుడిగా, పాపిగా జీవితం గడిపి, అవసాన దశలో చనిపోయాను. ఆ తర్వాత ఘోర నరకాలు అనుభవించి, లక్ష జన్మలలో కుక్కగా, పదివేల జన్మలు కాకిగా, అయిదువేల జన్మలు తొండగా, అయిదు వేల జన్మలు పేడ పెరుగుగా, తర్వాత వృక్ష జన్మమెత్తి అరణ్యంలో కూడా ఉన్నాను. అయినా నేను చేసిన పాపాలను పోగొట్టుకోలేకపోయాను. ఇన్నాళ్లకు మీ దయవల్ల స్తంభంగా ఉన్న నేను నా రూపమెత్తి, జన్మాంతర జ్ఞానినైతిని. నా కర్మలన్నీ మీకు తెలియజేశాను. నన్ను మన్నించండి అని వేడుకొన్నాడు.",
        },
        {
          title: "",
        },
        {
          title: "ఆ మాటలు విన్న మునులంతా అమిత ఆశ్చర్యం పొందారు. ఆహా! కార్తీకమాసం మహిమ ఎంత గొప్పది? అంతేకాకుండా కార్తీక శుద్ధ పౌర్ణమి మహిమ వర్ణింపశక్యంకాదు. కర్రలు, రాళ్లు, స్తంభాలు కూడా మన కళ్ల ఎదుట ముక్తిని పొందుతున్నాయి.",
        },
        {
          title: "",
        },
        {
          title: "వీటన్నింటికన్నా కార్తీక శుద్ధ పౌర్ణమి నాడు ఆకాశ దీపముంచిన వైకుంఠప్రాప్తి తప్పక సిద్ధిస్తుంది. అందువల్లే ఈ స్తంభానికి ముక్తికలిగింది అని మునులు అనుకుంటుండగా ఆ పురుషుడు మళ్లీ ఇలా మాట్లాడుతున్నాడు. ఓ మునులారా! నాకు ముక్తి కలుగు మార్గమేమైనా ఉందా? ఈ జగంలో ఎల్లరకూ కర్మబంధం ఎలా కలుగుతుంది? అది ఎలా నశిస్తుంది? నా సంశయాన్ని తీర్చండి అని ప్రార్థించారు. అంత అక్కడున్న మునులంతా తమలో ఒకరగు అంగీరసమునితో స్వామీ! మీరే అతని సంశయాన్ని తీర్చగల సమర్థులు. కాబట్టి వివరించండి అని కోరిరి. అంతట ఆయన వారి సంశయాన్ని తీర్చేందుకు అంగీకారం తెలిపాడు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే షోడశోధ్యాయస్సమాప్త:",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "షోడశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ సప్తదశాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "అంగీరసుడిట్లనెను. ఓయీ! కర్మబంధముక్తులు, కార్య కారణములు, స్థూల, సూక్షమములు, ఈజంటల సంబంధమే దేహమనబడును. నీవడిగిన ఈ విషయము పూర్వమందు కైలాసపర్వమున పార్వతికి శంకరుడుజెప్పెను. దానిని ఇప్పుడు నీకు నేను జెప్పెదను. ఇతర చింతనుమాని వినుము. నీవడిగిన ప్రశ్నకు సమాధానమును జెప్పెడను వినుము. జీవుడనగా వేరెవ్వడును లేడు. నీవే జీవుడవు. నేను యెవ్వడనంటే నేను ఆ బ్రహ్మనే అయి ఉన్నాను. ఇందుకు సందేహము లేదు. దేహమనెడి బుద్ధిని విడిచి నిత్యమైన ఆత్మను గూర్చి చింతింపుము. ఉద్భూతపురుషుడిట్లడిగెను. మునీశ్వరా! మీరు చెప్పిన రీతిగా వాక్యార్థ జ్ఞానము నాకు గలుగలేదు. కనుక అహంబ్రహ్మేతి(నేను బ్రహ్మనను) వాక్యార్థమును ఎట్లు తెలిసికొనగలను. ఈవాక్యార్థ బోధకు హేతువయిన పదార్థజ్ఞానము నాకు తెలియలేదు. కాబట్టి విమర్శగా చెప్పగోరెదను.",
        },
        {
          title: "",
        },
        {
          title: "ఆత్మ అంతఃకరణమునకు, తద్వ్యాపారములకు సాక్షియు, చైతన్య రూపియు, ఆనందరూపియు, సత్య స్వరూపమునై ఉన్నది. ఇట్టి ఆత్మను నీవెందుకు తెలుసుకొనుట లేదు. సచ్చిదానంద స్వరూపుడును, బుద్ధికి సాక్షియునయిన వస్తువునే ఆత్మగా తెలిసికొనుము. ఈదేహమనెడి బుద్ధిని విడిచి నిత్యమైన ఆత్మను గూర్చి చింతింపుము. దేహము ఘటమువలే రూపము గల్గిన పిండము గనుక ఇది ఆత్మగాదు. ఇదిగాక ఈదేహము ఘటము వలె ఆకాశాది పంచమహాభూతముల వలనబుట్టినది. గనుక దేహము వికారము కలది ఆత్మగాదు. ఇట్లే ఇంద్రియములు ఆత్మగావని తెలిసికొనుము. అట్లే మనస్సులు బుద్ధి ప్రాణములు, ఆత్మవస్తువులు కావు. దేహేంద్రియాదులన్నియు ఎవరి సాన్నిధ్యము వలన ప్రకాశించి పనిచేయుచున్నవో అట్టి వానిని ఆత్మగా ఎరుగుము. అనగా అతడే నేనని ఆత్మయని తెలిసికొనుమని భావము. లోపలికి మలచుకొనబడిన ఇంద్రియాలతో తెలియదగిన దానికి ప్రత్యక్ అని పేరు. ఇనుముకు అయస్కాంతమణి వలె తాను వికారిగాక బుద్ధ్యాదులను చలింపజేయునది ఏది కలదో అది నేను ఆబ్రహ్మనని తెలిసికొనుము.",
        },
        {
          title: "",
        },
        {
          title: "ఎవనియొక్క సాన్నిధ్యమాత్రముచేత జడముపైన కదలికలేని దేహేంద్రియ మనః ప్రాణములు జన్మలేని ఆత్మవలె కదలిక కలిగి ప్రకాశించుచున్నవో ఆబ్రహ్మను నేను అని తెలిసికొనుము. ఎవ్వడు వికారిగాక సాక్షియై స్వప్నమును, జాగరమును, సుషుప్తిని, వాటియొక్క ఆద్యంతములను నేను సాక్షి అని తెలిసికొనుచున్నాడో అది బ్రహ్మ అని తెలిసికొనుము. ఘటమును ప్రకాశింపజేయు దీపము ఎట్లు ఘటముకంటే భిన్నమో అట్లుగానే దేహాదులను ప్రకాశింపజేయు బోధరూపుడైన నేను ఆత్మ అని తెలిసికొనుము. ఎవ్వడు సర్వప్రియుడై నీయొక్క పుత్రమిత్ర ప్రియప్రియాది భావములను ద్రష్టగా జూచునో వాడే నేనని బ్రహ్మ అని తెలిసికొనుము. సాక్షియు బోధరూపుడగు వాడే నీవని యెరుగుము. సాక్షిత్వమును జ్ఞానరూపత్వమును అవికారియగుట ఆత్మకే గలవు. దేహేంద్రియ మనః ప్రాణాహంకారములకంటే వేరయిన వాడును 1. పుట్టుటా=జనిమత్వ, 2. ఉండుట=అస్తిత్వం, 3. వృద్ధిగతత్వ=పెరుగుట, 4. పరిణామత్వ=పరిణామము చెందుట, 5. కృశించుట, 6. నశించుట ఈ ఆరు వికారములు లేనివాడు. వికారములు ఈ ఆరు భావాలు లేనిది బ్రహ్మ. త్వం పదార్థముు ఇట్లు నిశ్చయించుకొని వ్యాపించు స్వభావము చేత సాక్షాద్విధిముఖముగాను తచ్ఛబ్దార్థమునుజ్దెలిసికొనవలయును.",
        },
        {
          title: "",
        },
        {
          title: "శ్లో|| అతద్వ్యావృత్తిరూపేణ సాక్షాద్విధిముఖేనచ|",
        },

        {
          title: "వేదాంతానాం ప్రవృత్తిస్స్యాత్ ద్విరాచార్య సుభాషితమ్||",
        },
        {
          title: "",
        },
        {
          title: "తచ్ఛబ్దమునకు బ్రహ్మ అర్థము. ఆతచ్ఛబ్దమునకు బ్రాహ్మణ్యము ప్రపంచమర్ధము. వ్యావృత్తియనగా ఇదిగాది ఇదిగాదని నిరసించుట అనగా ఇది బ్రహ్మగాదిది బ్రహ్మగాదని దేహేంద్రియాదులను నిరసించగా మిగిలిది బ్రహ్మయని భావము. సాక్షాద్విధిముఖమనా సత్యం జ్ఞానమనంతంబ్రహ్మ అను వాక్యములతో బ్రహ్మ సత్యజ్ఞానానంద స్వరూపుడని తెలిసికొనవలెను అని భావము. ఆత్మ సంసారలక్షణ విశిష్టముగాదనియు, సత్య స్వరూపనియు, దృష్టిగోచరముగాదనియు, తమస్సుకు పైదనియు అనుపమానందరూపమనియు, సత్యప్రజ్ఞాది లక్షణయుతమనియు, పరిపూర్ణమనియు చెప్పబడును. ఆతద్వ్యావృత్తి రూపముగాను, సాక్షాద్విధిముఖముగాను తెలిసికొనదగిన ఆత్మస్వరూపము ఇదియేనై అర్ధము. వేదములచేత ఎవ్వడు సర్వజ్ఞుడనియు, సర్వేశ్వరుడనియు సంపూర్ణ శక్తివంతుడనియు చెప్పబడుచున్నాడో వాడే నేనని తెలిసికొనును. మృత్తికాది దృష్టాంతముల చేత ఏక వస్తుజ్ఞానము చేత సర్వవిజ్ఞానము దేనిచే కలుగునని శ్రుతులందు చెప్పబడినదో ఆ వస్తువే బ్రహ్మయని తెలిసికొనుము. నేననునదియు బ్రహ్మయనునదియు ఒకే అర్థము కలిగినవి.",
        },
        {
          title: "",
        },
        {
          title: "వేదములందు ఎవ్వనికి తదనుప్రవిశ్య ఇత్యాది వాక్యములచేత జీవాత్మరూపముచేత ప్రాణులందు ప్రవేశమున్ను, ఆజీవులను గురించి నియంతృత్వమున్ను చెప్పబడుచున్నదో వాడే బ్రహ్మయని తెలిసికొనుము. వేదములందు ఎవ్వనికి కర్మఫలప్రదత్వము, జీవకారణకర్తృత్వము చెప్పబడినదో వాడే బ్రహ్మయని తెలిసికొనుము. ఈప్రకారముగా తత్, త్వం అను పదములు రెండును నిశ్చయించబడివి. తత్ అనగా బ్రహ్మము, త్వం అనగా జీవుడు, అనగా నీవె బ్రహ్మవని భావము చెప్పబడినది. ముందు వాక్యార్థమును జెప్పెదను. వాక్యార్థమనగా తత్త్వం పదములకు ఐక్యము - ఏకత్వము చెప్పబడును. ప్రత్యగాత్మయే అద్వయానందరూప పరమాత్మ. పరమాత్మయే ప్రత్యగాత్మ. ఈ ప్రకారముగా అన్యోన్యతాదాత్మ్యము ఎప్పుడు అనుభవమున గలుగునో అప్పుడే త్వం పదమునకు అర్ధము తెలియును. బ్రహ్మగాదను భ్రాంతి నశించును. తాదాత్మ్యమనగా అదియే ఇదియని అర్థము అనగా ఐక్యము. తత్త్వమసి అనా తత్, త్వమ్, అసి, ఈ వాక్యార్థమునకు తాదాత్మ్యము చెప్పవలెను. అప్పుడు వాచ్యార్థములయిన కించిజ్ఞత్వ, సర్వజ్ఞత్వ విశిష్టులయి జీవేశ్వరులను వదిలి లక్ష్యార్థములై జ్ఞత్వము పరబ్రహ్మము గ్రహించినయెడల తాదాత్మ్యము సిద్ధించును. ముఖ్యార్థముకు బాధగలిగినప్పుడు లక్షణావృత్తిని ఆశ్రయించవలెను. ఈ లక్షణావృత్తి మూడు విధములు.",
        },
        {
          title: "",
        },
        {
          title: "అందులో ఇచ్చటభాగలక్షణను గ్రహించవలెను. అనగా కొంత పదము విడిచి కొంతపదము స్వీకరించుట భాగలక్షణయనబడును. తత్త్వమసియందు సర్వజ్ఞత్వకించిజ్ఞత్వములను వదలి కేవల జ్ఞానాత్మత్వ మాత్రమునే గ్రహించినయెడల అభేదము సంభవించును. తత్-అది, త్వం-నీవు, అసి-అయితివి. అనగా నీవే బ్రహ్మవైతివని భావము. సో యందే వ దత్త ఇత్యాది స్థలమందును ఇట్లే బోధచేయబడును. తత్కాల తద్దేశ విశిష్టుడగు దేవదత్తుడు ఏతత్కాల ఏతద్దేశ విశిష్టుడగు దేవదత్తుడు అను వాక్యములలో విశేషణములను తీసివైచిన దేవదత్తుడొక్కడే భాసించును. అట్లే సర్వజ్ఞత్వం కించిజ్ఞత్వాలు వదలి కేవల జ్ఞత్వములు గ్రహించిన ఆత్మ ఒక్కటే అని భాసించును. నేను బ్రహ్మనను వాక్యార్థ బోధ స్థిరపడువరకు శమదమాది సాధనములు చేయుచు శ్రవణమనననిదిధ్యాసలను ఆచరించవలెను. ఎప్పుడు శ్రుతిచేతను, గురుకటాక్షముచేతను తాదాత్మ్యబోధ స్థిరపడునో అప్పుడు సంసారమూలము నశించును. కొంతకాలము మాత్రము ప్రారబ్ధకర్మ అనుభవింపుచుండి ప్రారబ్ధక్షయమందు పునరావృత్తి రహితమైన మోక్షపదమొంది నిరతిశయానందముతో ఉండును. కాబట్టి ముందు చిత్త శుద్ధికై కర్మను జేయవలెను. ఆకర్మవిధినంతయు గురువువలన దెలిసికొని చేసి తత్ఫలమును హరికి సమర్పించి విగతపాపుడై తరువాత ఆపుణ్యముచేత మంచిజన్మమెత్తి శ్రవణాదులను అభ్యసించి విజ్ఞానియై కర్మబంధమును తెంచుకొని మోక్షమొందుదువు. ఇందుకు సందేము లేదు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి శ్రీ స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే సప్తదశాధ్యాయస్సమాప్తః",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "సప్తదశాధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ అష్టాదశాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: "ఉద్భూతపురుషుడిట్లనెను. మునీశ్వరా! నేనుగ్రహించబడితిని. నీదర్శనముయొక్క అనుగ్రహము వలన జ్ఞానవంతుడనైతిని. ఓ మునివర్యా! నాకు నీవే తండ్రివి. నీవే సోదరుడవు. నీవే గురుడవు. నేను నీకు శిష్యుడను. దరిద్రుడనై మొద్దుగానున్న నాకిప్పుడు నీవుగాగ గతి ఎవ్వరయిరి. పాపవంతుడైన నేనెక్కడ. ఇట్టి సద్గతి యెక్కడ? పాపములకు స్థానమైన నేనెక్కడ. పుణ్యమైన కార్తీకమాసమెక్కడ? ఈమునీశ్వరులెక్కడ, ఈ విష్ణుసన్నిధి ఎక్కడ. ప్రారబ్ధ సుకృతమున్నయెడల తప్పక ఇట్లు ఫలించునుగదా? నాకెద్దియో పూర్వపుణ్యమున్నది. దానిచే ఇట్లింతయు లభించెను. అయ్యా! నాయందు దయయుంచి బాగా తెలియజెప్పుము. మనుష్యులు విధిగా కర్మలెట్లు చేయుదురు? ఆ కర్మలకు ఫలమెట్లు గలుగును? వాటి ఉపదేశమెట్లు, చేయుటకు ముఖ్యకాలమెది? కర్మలేవి? ఏమి కోరి చేయవలెను? ఈ విషయమంతయు వినగోరితిని గనుక చెప్పుము. నీవాక్కును వజ్రాయుధముచేత నాపాప పర్వతములు కూలినవి. అంగీరసుడు పల్కెను. ఓయీ! నీవడిగిన ప్రశ్న చాలా బాగున్నది లోకహితము కొరకు నీవడిగితివి గనుక నీవడిగిన ప్రశ్నకు సమాధానమును జెప్పెదవినుము. అనిత్యమైన ఈదేహమును ఆశ్రయించి ఇంద్రియకాముడై ఆత్మను మరచి దేహాదులను ఆత్మయని తలచకూడదు.",
        },
        {
          title: "",
        },
        {
          title: "ఆత్మకెప్పుడును సుఖదుఃఖాది ద్వందములు లేవు. అవి దేహాది ధర్మములైనవి. కాబట్టి ఆత్మ విషయక సందేహవంతుడు తప్పక కర్మనుజేయవలెను. దానితో చిత్తశుద్ధిగలిగి తద్వారా జ్ఞానమునుబొంది దానిచేత ఆత్మను యథార్ధముగా తెలిసికొనవలెను. దేహధారియయినవాడు తనకు విధించబడిన స్నానాది సర్వకర్మలనుభక్తితో విధిగా చేయవలెను. అట్టి వేదోక్త కర్మ చేసిన ఫలించి ఆత్మ ప్రకాశము కలుగజేయును. వర్ణాశ్రమ విభాగమును విడువక తనకు ఏకర్మ చెప్పబడినదో విచారించి తెలిసికొని తరువాత చేయవలెను. స్నానము చేయక చేయు కర్మ ఏనుగు భక్షించిన వెలగపండువలె నిష్ఫలమగును. బ్రాహ్మణులకు ప్రాతఃస్నానము వేదోక్తమైయున్నది. నిరంతరము ప్రాతఃస్నానమాచరించలేనివాడు తులా సంక్రాంతి యందుకార్తీకమాసమందును, మకరమాసమందును, (మేష) వైశాఖమందును స్నానము చేయవలెను. ఈ మూడు మాసములందును ప్రాతఃకాలమందు స్నానము చేయు వాడు వైకుంఠమునకు బోవును మరియు వానికి ఉత్తమగతి గలుగును.",
        },
        {
          title: "",
        },
        {
          title: "చాతుర్మాస్యాది పుణ్యకాలములందును, చంద్రసూర్య గ్రహణములందును స్నానము ముఖ్యము. ఇందు గ్రహణములందు, గ్రహణకాలమందే స్నానము ముఖ్యము. బ్రాహ్మణులకు ప్రాముఖ్యమైనది. 1. స్నానము 2. సంధ్యాజపము 3. హోమము 4. సూర్య నమస్కారము తప్పక చేయదగినవి. స్నానమాచరించనివాడు రౌరవనరకమందు యాతనలను పొంది తుదకు కర్మభ్రష్టుడుగా జన్మించును. కాబట్టి పుణ్యకాలము కార్తీకమాసము ఈ కార్తీకము ధర్మార్థకామ మోక్షములనిచ్చును. ఈ కార్తీకముతో సమానమైన మాసము లేదు, ఇంతకంటే పుణ్యకాలము లేదు. వేదముతో సమానమైన శాస్త్రములేదు. గంగతో సమానమైన తీర్థము లేదు. బ్రాహ్మణ్యముతో సమానమైన కులము లేదు. భార్యతో సమానమైన సుఖము లేదు. ధర్మముతో సమానమైన మిత్రుడు లేడు. నేత్రముతో సమానమైన తేజస్సులేదు. కేశవునితో సమానమైన దేవుడు లేడు. కార్తీకమాసముతో సమానమయిన మాసము లేదు. కర్మ స్వరూపమును దెలిసికొని కార్తీకమాసమందు ధర్మములను జేయువాడు కోటి యజ్ఞలమును బొంది వైకుంఠమందుండును.",
        },
        {
          title: "",
        },
        {
          title: "ఉద్భూతపురుషుడడిగెను. అయ్యా! చాతుర్మాస్య వ్రతాన్ని పూర్వము చెప్పియున్నారు. అది పూర్వము ఎవనిచేత చేయబడినది? ఆవ్రతవిధి ఎట్లు? ఆవ్రతమునకు ఫలమేమి? దానిని చేయువాడు పొందెడి ఫలమేమి? ఆచరించు మనుష్యుడు ఏ లోకమునకు పోవును? ఈ విషయమంతయు సవిస్తారముగా చెప్పుము. అంగీరసుడిట్లు పల్కెను. ఓయీ! నీవు ఈ మనుష్యులకు బంధువు. నీ ప్రశ్నలన్నియు లోకోపకారార్థములుగా ఉన్నవి. సమాధానమును జెప్పెదను, సావధానుడవై వినుము. విష్ణుమూర్తి లక్ష్మితో గూడా ఆషాఢ శుక్ల దశమిదినంబున పాలసముద్రమందు నిద్రయను వంకతో శయనించును. తిరిగి కార్తీకశుక్ల ద్వాదశిరోజున లేచును. ఇది చాతుర్మాస్యము. అనగా నాలుగు మాసములు చేయువ్రతము. ఈ నాలుగు మాసములు విష్ణుమూర్తికి నిద్రాసుఖము ఇచ్చునవి. అనగా హరి ఎనిమిది మాసములు మెలకువతో నుండి నాలుగు మాసములు విశ్రాంతికై నిద్రించును. విష్ణువునకు నిద్ర సుఖమిచ్చునది గనుక ఇది పుణ్యకాలము. ఈ పుణ్యకాలమందు హరి ధ్యానించువాడు విష్ణులోకమును బొందును. ఈ నాలుగు మాసములలోను చేసిన పుణ్యకార్యములు అనంతములగును. దీనికి కారణమును జెప్పెదను వినుము. ఈ విషయమందు నారదునకు హరిచెప్పినదొక కథయున్నది. పూర్వము కృతయుగమందు వైకుంఠోకంబున హరి లక్ష్మితో గూడ సింహాసనమందు కూర్చుండి సుర కిన్నర ఖేచరోరగగణములచేతను, స్వగణభృత్యుల చేతను సేవింపబడుచుండెను. హరి ఇట్లుండగా భగవద్భక్తుడైన నారదముని కోటి సూర్యకాంతి గల వైకుంఠలోకమును గూర్చివచ్చెను. నారదముని వచ్చి సింహాసనాసీనుడై నాలుగు భుజములు గలిగి పద్మపురేకుల వంటి నేత్రముల వలె ప్రకాశించెడి విష్ణుమూర్తిని జూచెను. చూచి అమితానందయుక్తుడై నారదుడు విష్ణుమూర్తి యొక్క పాదులకు మ్రొక్కెను. హరియు నారదుని జూచి నవ్వుచు తెలియని వానివలె ఇట్లనెను.",
        },

        {
          title: "",
        },
        {
          title: "ఓ నారదా! నీవు సంచరించు స్థలములందు సర్వత్ర కుశలమా? ఋషుల ధర్మములు బాగుగానున్నవా? ఉపద్రవములు లేకున్నవా? మనుష్యులు వారి వారి ధర్ములందున్నారా? ఈవిషయమంతయు ఈసభలో జెప్పుము. నారదుడు ఆమాటను విని ఆనందించి నవ్వుచూ హరితోనిట్లనియె, ఓ స్వామీ! నేను భూమినంతయు తిరిగిచూచితిని. వేదత్రయమందు జెప్పబడిన కర్మమార్గము విడువబడినది. కొందరు మునీశ్వరులు గ్రామ్య సుఖలోలురైరి. తమ తమ కర్మలను యావత్తు విడిచి యుండిరి. వారు దేనిచేత ముక్తులగుదురో నాకు దెలియకున్నది. కొందరు తినగూడని వస్తువులను తినుచున్నారు. కొందరు వ్రతములను విడిచినారు. కొందరు ఆచారవంతులుగానున్నారు. కొందరు అహంకార వర్జితులుగా నున్నారు. కొందరు మంచి మార్గవర్తనులుగానున్నారు. కొందరు నిందజేయువారుగా నున్నారు. కాబట్టి ఓ దేవా! ఏదైనా ఒక ఉపాయము చేత శిక్షించి ఈ ఋషీశ్వరులను రక్షించుము. నారదుని మాట విని భక్తవత్సలుడు, సమస్త లోక పాలకుడును అయిన హరి లక్ష్మితో సహా గరుత్మంతుని అధిష్ఠించి భూలోకమునకు వచ్చెను. విష్ణుమూర్తి వృద్ధబ్రాహ్మణ రూపధారియై వేల సంఖ్యగల బ్రాహ్మణులున్న స్థలమునకు వచ్చి సర్వప్రాణి హృదయగతుడైనప్పటికీ మాయా నాటకధారియై పుణ్యక్షేత్రములందును, తీర్థములందును, పర్వతములందును, అరణ్యములందును, ఆశ్రమములందును, సమస్త భూమియందును తిరుగుచుండెను.",
        },
        {
          title: "",
        },
        {
          title: "ఇట్లు సంచరించుచున్న విష్ణుమూర్తిని జూచి కొందరు భక్తితో అతిథి సత్కారములను జేసిరి. కొందరు నవ్విరి. కొందరు నమస్కారము చేయరైరి. కొందరు అభిమానవంతులైరి. కొందరు గర్వముతో ఉండిరి. కొందరు కామాంధులై యుండిరి. కొందరాయా క్రియాకలాపములను మానిరి. కొందరు ఏకవ్రతపరాయణులైయుండిరి. కొందరు నిషిద్ధ దినములందు అన్నమును దినువారుగా నుండిరి. కొందరు ఏకాదశ్యు అవాసమాచరించని వారుగా నుండిరి. కొందరు తినగూడని వస్తువులను దినుచుండిరి. కొందరాచారవంతులుగానుండిరి. కొందరాత్మచింతజేయుచుండిరి.",
        },
        {
          title: "",
        },
        {
          title: "బ్రాహ్మణ రూపధారియైన భగవంతుడు అట్టివారిని జూచి మంచి మార్గమునకు దెచ్చు ఉపాయమును ఆలోచించుచు నైమిశారణ్యమందున్న ముని బృందముల సన్నిధికి వచ్చెను. వచ్చి బ్రాహ్మణరూపమును వదలి పూర్వమువలె గరుడారూఢుడై కౌస్తుభ శంఖ చక్రమును ధరించి లక్ష్మితోను, స్వభక్తులతోను గూడి ప్రకాశించుచుండెను. అచ్చటనుండు జ్ఞానసిద్ధులు మొదలయిన మునులు వైకుంఠమునుండి తమ ఆశ్రమమునకు వచ్చినట్టివాడును అవిసె పువ్వుతో సమానమైన కాంతి గలవాడును, మెరుపువంటి వస్త్రము గలవాడును, కోటి సూర్య ప్రభాభాసమానుడును, మకరకుండల విరాజితుడును, అనేక రత్నగ్రధిత కిరీట ప్రకాశమానుడును, అనేక సూర్య కాంతింతుడును, మనోవాచామగోచరుడును, దేవతాపతియును, స్వయంభువును, ప్రసన్నుడును, అధిపతియును, ఆద్యుడును అయిన విష్ణుమూర్తిని జూచి ఆశ్చర్యమొంది ఆనందించి శిష్యసుతాది పరివారముతో హరిసన్నిధికి వచ్చిరి. వచ్చి హరి పాదములము నమస్కారము చేసి వారిముందర నిలిచి అంజలిబద్ధులై హరిని వక్ష్యమాణరీతిగా స్తుతించిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి శ్రీ స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే అష్టాదశాధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "అష్టాదశాధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ నవదశాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> చతుర్మాస్య వ్రత ప్రభావం :</span>,
        },
        {
          title: "",
        },
        {
          title: "నైమిశారణ్యంలో మునులంతా కలిసి చిదానందుని స్తోత్రం చేసిన తర్వాత జ్ఞానసిద్ధుడు అనే ఒక మహాయోగి, ఓ దీనబాంధవా! వేదవేద్యుడవని, వేదవ్యాసుడవని, అద్వితీయుడవని, సూర్యచంద్రులే నేత్రాలుగా ఉన్నవాడివని, సర్వాంతర్యామివని, బ్రహ్మరుద్ర దేవేంద్రాదులచే సర్వతా పూజలందుకునే వాడివని, సర్వాంతర్యామివని, నిత్యుడవని, నిరాకారుడవని సర్వజనులచే స్తుతింపబడుతున్న ఓ మాధవా! నీకివే మా హృదయపూర్వక నమస్కారాలు. సకల ప్రాణకోటికి ఆధారభూతడవైన ఓ నందనందనా మా స్వాగతం స్వీకరింపుము.",
        },
        {
          title: "",
        },
        {
          title: "నీ దర్శన భాగ్యం వల్ల మేము, మా ఆశ్రమాలు, మా నివాస స్థలాలు అన్నీ పవిత్రాలయ్యాయి. ఓ దయామయా! మేం ఈ సంసార బంధం నుంచి బయటపడలేకున్నాం. మమ్మల్ని ఉద్దరింపుము. మానవుడెన్ని పురాణాలు చదివినా, ఎన్ని శాస్త్రాలను విన్నా నీ దివ్య దర్శనం దొరకజాలదు. నీ భక్తులకు మాత్రమే నీవు కనిపిస్తావు. ఓ గజేంద్ర రక్షకా! ఉపేంద్రా! శ్రీధరా! హృషీకేశా! నన్ను కాపాడుము అని మైమరచి స్తోత్రము చేయగా శ్రీహరి చిరునవ్వుతో జ్ఞానసిద్ధా! నీ స్తోత్ర వచనానికి నేనెంతో సంతోషించాను.",
        },
        {
          title: "",
        },
        {
          title: "నీకు ఇష్టమైన ఒక వరం కోరుకో అని పలికెను. అంతట జ్ఞాన సిద్ధుడు ప్రద్యుమ్నా! నేనీ సంసార సాగరం నుంచి విముక్తుడను కాలేక శ్లేష్మమున పడిన ఈగలా కొట్టుకుంటున్నాను. కాబట్టి నీ పాదపద్మాలపై ధ్యానముండేట్లు అనుగ్రహించు. మరేదీ నాకు అవసరం లేదు అని వేడుకొన్నాడు. అంతట శ్రీమన్నారాయణుడు ఓ జ్ఞాన సిద్ధుడా! నీ కోరిక ప్రకారం వరమిస్తున్నాను. అదేకాకుండా, మరో వరం కోరుకో ఇస్తాను.",
        },

        {
          title: "",
        },
        {
          title: "ఈ లోకంలో అనేకమంది దురాచారులై, బుద్ధిహీనులై అనేక పాపకార్యాలుచేస్తున్నారు. అలాంటివారి పాపాలు పోవడానికి ఒక వ్రతం కల్పిస్తున్నాను. ఆ వ్రతాన్ని సర్వజనులు ఆచరించొచ్చు. సావధానుడవై ఆలకించు. నేను ఆషాఢ శుద్ధ దశిమిరోజున లక్ష్మీసమేతంగా పాలసముద్రంలో శేషశయ్యపై పవళిస్తాను. తిరిగి కార్తీకమాసం శుద్ధ ద్వాదశి వరకు చాతుర్మాస్యమని పేరు. ఈ కాలంలో చేసే వ్రతాలు నాకు అమిత ఇష్టమైనవి. చాతుర్మాస్యాల్లో ఎలాంటి వ్రతాలు చేయనివారు నరక కూపాలలో పడతారు. ఇతరులతో కూడా ఈ వ్రతాన్ని ఆచరింపజేయాలి. దీని మహత్యాన్ని తెలుసుకో.",
        },
        {
          title: "",
        },
        {
          title: "వ్రతం చేయనివారికి బ్రహ్మహత్యాది పాతకాలు కలుగుతాయి. ఇక చాతుర్మాస్య వ్రతం చేసేవారికి జన్మ, జరా, వ్యాధుల వలన కలుగు బాధలుండవు. దీనికి నియమంగా ఆషాఢ శుద్ధ దశిమి మొదలు శాఖములు (కూరలు), శ్రావణ శుద్ధ దశమి మొదలు పప్పుదినుసులు విసర్జించాలి. నాయందు భక్తిగలవారిని పరీక్షించడానికి నేను ఇలా ద్రవ్యాల నిషేధాన్ని విధించాను.",
        },
        {
          title: "",
        },
        {
          title: "ఆ కాలంలో నేను ఆయా ద్రవ్యజాల్లో శయనిస్తాను. నీవు ఇప్పుడు నన్ను స్తుతించిన తీరున త్రిసంధ్యల్లో భక్తిశ్రద్ధలతో పఠించేవారు నా సన్నిధికి నిశ్చయంగా వస్తారు, అని శ్రీమన్నారాయణుడు తెలిపాడు. అనంతరం ఆయన మహాలక్ష్మితో కలిసి పాలసముద్రానికి వెళ్లి, శేషపాన్పుపై పవళించాడు.",
        },
        {
          title: "",
        },
        {
          title: "తిరిగి వశిష్టుడు జనకమహారాజుతో ఇలా అంటున్నాడు. ఓ రాజా! ఈ విధంగా విష్ణుమూర్తి, జ్ఞాన సిద్ధుడు, మొదలగు మునులకు చాతుర్మాస్య వ్రత మహత్యాన్ని ఉపదేశించాడు. ఈ వృత్తాంతాన్ని ఆంగీరసుడు ధనలోభునికి తెలియజేశాడు. నేను నీకు వివరించాను. కాబట్టి ఈ వ్రతాన్ని ఆచరించేందుకు ఎలాంటి స్త్రీ,పురుష బేధం లేదు. అన్ని జాతుల వారు ఈ వ్రతాన్ని ఆచరించొచ్చు. శ్రీమన్నారాయణుడి ఉపదేశం ప్రకారం మునిపుంగవులంతా చాతుర్మాస్య వ్రతాన్ని ఆచరించి, ధన్యులయ్యారు. అనంతరం వైకుంఠ ప్రాప్తిని పొందారు అని వశిష్టులు చెప్పారు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి శ్రీ స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే నవదశాధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "నవదశాధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ వింశాధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> పురంజయుడు దురాచారుడగుట :</span>,
        },
        {
          title: "",
        },
        {
          title: "చాతుర్మాస్య వ్రత ప్రభావాన్ని తెలుసుకున్నాక జనక మహారాజు వశిష్ఠుడితో తిరిగి ఇలా అడుగుతున్నాడు, ఓ గురువర్యా! కార్తీకమాస మహత్యాన్ని ఇంకనూ వినాలనిపిస్తోంది. ఈ వ్రత మహత్యానికి సంబంధించి ఇంకా ఇతిహాసాలు, ఇతివృత్తాలు, విశేషాలున్నాయా? అనే విషయాలను తెలుసుకోవాలనే ఆసక్తి పెరుగుతోంది అని కోరాడు. దానికి వశిష్టులవారు మందహాసంతో ఓ రాజా! కార్తీక మాస మహత్యాన్ని గురించి అగస్త్య మహాముని అత్రి మునికి చెప్పిన విషయం వివరిస్తాను అని ఇలా చెప్పసాగారు.",
        },
        {
          title: "",
        },
        {
          title: "పూర్వం ఒకప్పుడు అగస్త్య మహాముని అత్రి మహర్షిని చూసి ఓ అత్రి మునీ! నీవు విష్ణువు అంశలో పుట్టావు, కాబట్టి నీకు కార్తీక మహత్యం ఆమూలాగ్రంగా (ఆది నుంచి అంతం వరకు) తెలుసి ఉంటుంది. కాబట్టి దాన్ని నాకు వివరించు అని కోరాడు. దానికి అత్రి మహాముని ఓ కుంభసంభవా! కార్తీక మాసానికి సమాన మాసం లేదు. వేదాల్లో సమానమైన శాస్త్రం, ఆరోగ్య సంపదకు సాటిలేని సంపద లేదు. అలాగే శ్రీమన్నారాయణుడి కంటే వేరు దేవుడు లేడు. ఏ మానవుడైనా కార్తీకంలో నదీస్నానం చేసినా, శివకేశవాలయాల్లో దీపారాధన చేసినా, దీపదానం చేసినా దాని ఫలితం చెప్పనలవి కాదు. ఇందుకు ఒక ఇతిహాసముంది, చెబుతాను విను.",
        },
        {
          title: "",
        },
        {
          title: "త్రేతాయుగంలో పురంజయుడనే సూర్యవంశపురాజు అయోధ్యా నగరాన్ని రాజధానిగా చేసుకుని రాజ్యమేలుచుండేవాడు. అతడు సమస్త శాస్త్రాలను అభ్యసించాడు. న్యాయబద్ధంగా రాజ్యపాలన చేసేవాడు. ప్రజలకు ఎలాంటి ఆపదలు రాకుండా పాలించేవాడు. అయితే కొంతకాలానికి పురంజయుడిలో మార్పు వచ్చింది. అమిత ధనాశతో, రాజ్యాధికార గర్వంతో జ్ఞానహీనుడై, దుష్టబుద్ధి కలవాడై, దయాదాక్షిణ్యాలు లేక, లేవ బ్రాహ్మణ మాన్యాలను లాక్కొనడం ఆరంభించాడు. పరమలోభిగా మారాడు. దొంగలను చేరదీసి వాళ్లతో దొంగతనాలు, దోపిడీలు చేయించాడు. వారు కొల్లగొట్టుకొచ్చిన ధనంలో సగం వాటా తీసుకుంటూ ప్రజలను భీతావహులను చేయసాగాడు. కొంతకాలానికి అతని దాష్టీకాలు నలుదిశలా వ్యాపించాయి. ఈ వార్త విన్న కాంభోజరాజు ఇదే సమయమని గుర్తించి, అయోధ్యపై యుద్ధానికి సిద్ధమయ్యాడు. రథ, గజ, తురగ, పదాతి దళాలను తీసుకుని అయోధ్యను చేరుకున్నాడు. నగరం నలుమూలలా శిబిరాలు నిర్మించి, యుద్ధానికి సిద్ధపడ్డాడు. గూఢచారుల వల్ల విషయం తెలుసుకున్న పురంజయుడు చేసేది లేక తాను కూడా యుద్ధానికి సిద్ధమయ్యాడు. శత్రువు కంటే తన శక్తి బలహీనంగా ఉన్నా తుదికంటా పోరాడాలని నిర్ణయించుకున్నాడు. శాస్త్రసమన్వితమైన రథాన్ని ఎక్కి, సైన్యాధిపతులను పురికొల్పాడు. చతురంగ సమేతమైన సైన్యంతో యుద్ధ సన్నద్దుడయ్యాడు. యుద్ధభేరీ మోగించి, సింహనాదాలు గావించి, మేఘాలు గర్జిస్తున్నాయా అన్నట్లు పెద్దఎత్తున హుంకరించారు. శత్రు సైన్యంపై విరుచుకుపడ్డాడు.",
        },

        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే వింశాధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "వింశాధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ ఏకవింశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> పురంజయుడు - కార్తీకమాస ప్రభావం :</span>,
        },
        {
          title: "",
        },
        {
          title: "అలా యుద్ధానికి సిద్ధమైన పురంజయుడికి, కాంభోజాది భూపాలురకు భీకరయుద్ధం జరిగింది. ఆ యుద్ధంలో రథికులు రథికుడితో, అశ్వసైనికుడు అశ్వసైనికుడితో, గజ సైనికుడు గజ సైనికుడితో, పదాతులు పదాతి దళాలతో, మల్లులు మల్లయుద్ధనిపుణులతో, ఖడ్గ, గద, బాణ, పరశు మొదలు ఆయుధాలు ధరించినవారు అవే ఆయుధాలు ధరించినవారితో ధర్మబద్ధమైన యుద్ధం చేస్తున్నారు. ఒకరినొకరు ఢీకొంటూ హూంకరించుకుంటూ దిక్కులు దద్దరిల్లేలా సింహనాదాలు చేశారు. శూరత్వం, వీరత్వం ప్రదర్శించేందుకు భేరీ దుందుబులను వాయిస్తూ, శంఖాలను పూరిస్తూ, విజయకాంక్షతో పోరాడారు. ఆ రణ భూమి అంతా ఎక్కడ చూసినా విరిగిన రథాల గుట్టలు, తెగిపడిన మొండాలు, ఏనుగుల తొండాలు, సైనికుల తలలు, చేతులతో నిండిపోయింది. యుద్ధభూమిలో హాహాకారాలు, ఆక్రందనలు మిన్నంటాయి.",
        },
        {
          title: "",
        },
        {
          title: "పర్వాతాల్లా పడి ఉన్న ఏనుగులు, గుర్రాల కళేబరాల దృశ్యాలతో అతి గంభీరంగా, భయంకరంగా రణస్థలి కనిపించింది. యుద్ధవీరుల్ని వీరస్వర్గానికి తీసుకెళ్లేందుకు పుష్పక విమానంపై వచ్చిన దేవదూతలు అక్కడకు చేరుకున్నారు. సూర్యాస్తమయం వరకు యుద్ధం కొనసాగింది. కాంబోజాది భూపాలురకు చెందిన సైన్యం భారీగా నష్టపోయింది. అయినా మూడు అక్షౌహిణులున్న పురంజయుడి సైన్యాన్ని అతి నేర్పుతో ఓడించారు. పెద్ద సైన్యమున్నా పురంజయుడికి అపజయం కలిగింది. దాంతో పురంజయుడు రహస్య మార్గంలో శత్రువుల కంటపడకుండా తన గృహానికి పారిపోయాడు. బలోపేలైన శత్రురాజులు రాజ్యాన్ని ఆక్రమించుకున్నారు. పురంజయుడు విచారంతో, సిగ్గుతో దు:ఖించుచుండెను.",
        },
        {
          title: "",
        },
        {
          title: "ఆ సమయంలో వశిష్ట మహర్షి వచ్చి, పురంజయుడిని ఊరడించారు. రాజా! ఇంతకు ముందు ఒకసారి నీవద్దకు వచ్చాను. నువ్వు ధర్మాన్ని తప్పావు. నీ దురాచారాలకు అంతులేదు. నిన్ను సన్మార్గంలో వెళ్లమని హెచ్చరించాను. అప్పుడు నా మాటల్ని వినలేదు. నీవు భగవంతుడిని సేవింపక అధర్మప్రవర్తుడవైనందునే ఈ యుద్ధంలో ఓడిపోయి, రాజ్యాన్ని శత్రువులకు అప్పగించావు. ఇప్పటికైనా నామాటలు విను. జయాపజయాలు దైవాదీనాలు. నీవు చింతతో కృంగిపోవడం మాని, శత్రురాజులను యుద్ధంలో జయించి, నీ రాజ్యం నీవు తిరిగి పొందాలని సంకల్పించు. ఇది కార్తీకమాసం. రేపు కృత్తికా నక్షత్ర యుక్తంగా పౌర్ణమి ఉంది. కాబట్టి స్నాన, జపాది నిత్యకర్మలు ఆచరించి, గుడికి వెళ్లి, దేవుడి సన్నిధిలో దీపారాధన చేయి. భగవన్నామస్మరణతో నాట్యం చేయి. ఇంట్లో అర్చించినట్లయితే నీకు పుత్ర సంతతి కలుగుతుంది. అంతేకాదు శ్రీమన్నారాయణుడిని సేవించడం వల్ల విష్ణుమూర్తి ప్రసన్నుడై నీ శత్రువులను దునిమాడేందుకు చక్రాయుధాన్ని ప్రసాదిస్తాడు. కాబట్టి రేపు అలా చేసినట్లయితే పోయిన నీ రాజ్యం తిరిగి పొందగలుగుతావు. నీవు అధర్మ ప్రవర్తనుడవై దుష్ట సహవాసాలు చేయడం వల్లే ఈ అపజయం కలిగింది, శ్రీహరిని మదిలో తలచి, నేను చెప్పినట్లు చేయి అని ఉపదేశించాడు.",
        },

        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే ఏకవింశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "ఏకవింశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ ద్వావి౦శోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> పురంజయుడు కార్తీక పౌర్ణమీ వ్రతము చేయుట:</span> ,
        },
        {
          title: "",
        },
        {
          title: "మరల అత్రి మహాముని అగస్త్యునకిట్లు చెప్పదొడగెను. పురంజయుడు వశిష్టుల వారు చెప్పిన ప్రకారము కార్తీక పౌర్ణమి రోజున శుచియై దేవాలయమునకు వెళ్లి శ్రీమన్నారాయణుని షోడశోపచారములతో పూజించి, శ్రీహరిని గానముచేసి, సాష్టాంగ నమస్కారము చేసి, సూర్యోదయముకాగానే నదికిపోయి, స్నానమాచరించి తన గృహమున వెళ్ళెను. అట్టి సమయములో విష్ణుభక్తుడగు ఒక వృద్ద బ్రాహ్మణుడు మెడ నిండా తులసి మాలలు ధరించి పురంజయుని సమీపించి రాజా! విచారింపకుము నీవు వెంటనే చెల్లాచెదురైయున్న నీ సైన్యమును కూడా దీసుకొని, యుద్ద సన్నద్ధుడై శత్రురాజులతో పోరు సల్పుము, నీ రాజ్యము నీకు దక్కును, అని దీవించి అదృశ్యుమయ్యెను. ఈతడెవరో మహానుభావునివలె ఉన్నాడు అని ఆ వృద్ధుని మాటలు నమ్మి యుద్ధసన్నద్ధుడై శత్రురాజులతో ఘోరముగా పోరాడెను. దెబ్బతిని క్రోథముతో నున్న పురంజయుని సైన్యము ధాటికి శత్రురాజుల సైన్యములు నిలువలేకపోయినవి. అదియును గాక, శ్రీమన్నారాయణుడు పురంజయుని విజయానికి అన్ని విధములా సహాయపడెను. అంతయు శ్రీమన్నారాయణుని మహిమయే గదా!",
        },
        {
          title: "",
        },
        {
          title: "ఆ యుద్దములో కా౦భోజాది భూపాలురు ఓడిపోయి పురంజయా రక్షింపుము రక్షింపుమని కేకలు వేయుచు పారిపోయిరి. పురంజయుడు విజయము పొంది తన రాజ్యమును తిరిగి సంపాదించెను. శ్రీమన్నారాయణుని కటాక్షమునకు పాత్రులయిన వారికి శత్రుభయము కలుగుతుందా! విషం త్రాగినాను అమృతమే యగును. ప్రహ్లాదునకు తండ్రి విషాన్ని ఇవ్వగా 'శ్రీహరి' అని ప్రార్ధించి త్రాగగా అమృతమైనది గదా! శ్రీహరి కటాక్షము వలన సూర్యచంద్రులు ఉన్నంత వరకును ధృవుడు చిరంజీవియే గదా!",
        },
        {
          title: "",
        },
        {
          title: "హరినామస్మరణ చేసిన వారికి శత్రువు మిత్రుడగును. అధర్మము ధర్మముగా మారును. దైవానుగ్రహము లేని వారికి ధర్మమే అధర్మమగును. త్రాడు పామై కరచును. కార్తీకమాసమంతయు నదీ స్నానమొనరించి, దేవాలయంలో జ్యోతిని వెలిగించి దీపారధన చేసినచో సర్వవిపత్తులును పటాపంచలగును. అన్ని సౌఖ్యములు సమకూరును. విష్ణుభక్తి కలిగి శ్రద్ధతో ఆ వ్రతమాచరించు వారికి ఏ జాతి వారికైనా పుణ్యము సమానమే. బ్రాహ్మణ జన్మమెత్తి సకల శాస్త్రములు చదివి కూడా విష్ణుభక్తి శూన్యమైనచో శూద్రకులముతో సమానమగును. వేదాధ్యయన మొనరించి దైవభక్తి కలవాడై కార్తీక వ్రతానుష్ఠానతత్పరుడైన వైష్ణవోత్తముని హృదయపద్మమున భగవంతుడు౦డును. సంసారసాగర ముత్తరించుటకు దైవభక్తియే సాధనము. జాతి భేదముతో నిమిత్తము లేదు. విష్ణుభక్తి ప్రభావము వర్ణనాతీతము. వ్యాసుడు, అంబరీషుడు, శౌనకాది మహాఋషులు మరెందరో రాజాధిరాజులు కూడా విష్ణుభక్తిచే ముక్తినొందిరి. శ్రీహరి భక్తవత్సలుడు, సదా పుణ్యాత్ములను కంటికి రెప్పవలె కాపాడుచుండును. ఎవరికైనను శక్తి లేని యెడల వారు తమ ద్రవ్యమును వెచ్చించియైనను మరి యొకరి చేత దానధర్మములు, వ్రతములు చేయించవచ్చును. శ్రీహరి భక్తులు అన్యోన్య సంబంధీకులు, అందువలన లోకపోషకుడు, భక్త రక్షకుడైన ఆదినారాయణుడు తన భక్తులకు సదా సంపదలనొసంగి కాపాడుచుండెను.",
        },

        {
          title: "",
        },
        {
          title: "శ్రీమన్నారాయణుడు సర్వాంతర్యామి, వెయ్యి సూర్యభగవానుల తేజస్సు గలవాడు, నిరాకారుడు, నిర్వికల్పుడు, నిత్యానందుడు, నీరజాక్షుడు, పద్నాలుగు లోకములను తన కుక్షియందుంచుకొని కాపాడుచున్న ఆదినారాయణుడు, అతిప్రియమైన కార్తీక మాసవ్రతమును భక్తి శ్రద్దలతో ఎవరు చేయుదురో వారి ఇంట శ్రీమహావిష్ణువు లక్ష్మీ సమేతుడై వెలయగలడు. ఆ ఇల్లు సిరిసంపదలతో కలకలలాడును. కార్తీకమాసములో శుచియై పురాణ పఠనము చేసినచో పితృదేవతలు సంతసించెదరు. వారి వంశమంతయు తరించును. ఇది ముమ్మాటికి నిజము.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే ద్వావి౦శోధ్యాయస్సమాప్త:",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "ద్వావింశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ త్రయోవింశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> శ్రీ రంగక్షేత్రమున పురంజయుడు ముక్తినొందుట :</span>,
        },
        {
          title: "",
        },
        {
          title: "అగస్త్యుడు మరల అత్రిమహర్షిని గాంచి ఓ మునిపుంగవా! విజయమందిన పురంజయుడు యేమిచేసెనో వివరింపుమని అడుగగా అత్రిమహాముని ఇట్లు చెప్పిరి. కు౦భసంభవా! పురంజయుడు కార్తీక వ్రతాచరణ ప్రభావమున అసమాన బలోపేతుడై అగ్నిశేషము, శత్రుశేషము ఉండకూడదని తెలిసి, తన శత్రురాజుల అందరినీ ఓడించి నిరాటకంముగా తన రాజ్యమును యేలుచుండెను. తన యొక్క విష్ణుభక్తి ప్రభావము వలన గొప్ప పరాక్రమవంతుడు, పవిత్రుడు, సత్యదీక్షాతత్పరుడు, నిత్యాన్నదాత, భక్తప్రియవాది, తేజోవంతుడు, వేదవేదా౦గవేత్తయై ఉండును మరియు అనేక శత్రువులను జయించి దశదిశలా తన అఖ౦డ కీర్తిని ప్రసరింపచేసెను. శత్రువులకు సింహస్వప్నమై, విష్ణు సేవాధురంధరుడై, కార్తీకవ్రత ప్రభావమున కోటికి పడగెత్తి అరిషడ్వర్గములను కూడా జయించినవాడై యుండెను. ఇన్ని యేల? అతడిప్పుడు విష్ణుభక్తాగ్రేసరుడు, సదాచారసత్పురుషులలో ఉత్తముడై రాణించుచుండెను. అయినను తనకు తృప్తిలేదు. ఏ దేశమున, యే కాలమున, యే క్షేత్రమున యే విధముగా శ్రీ హరిని పూజించిన కృతార్దుడనగుదునా? యని విచారించుచుండగా, ఒకానొకనాడు అశరీరవాణి పురంజయా! కావేరీతీరమున శ్రీరంగ క్షేత్రమున్నది. దానిని రెండవ వైకుంఠమని పిలిచెదరు. నీవచటకేగి శ్రీరంగనాథ స్వామిని అర్చింపుము. నీవీ సంసార సాగరమును దాటి మోక్షప్రాప్తి నొందుదువు అని పలికెను.",
        },
        {
          title: "",
        },
        {
          title: "అంతట పురంజయుడు ఆ శరీరవాణి వాక్యములు విని, రాజ్యభారమును మంత్రులకు అప్పగించి, సపరివారముగా బయలుదేరి మార్గమధ్యముననున్న పుణ్యక్షేత్రములను దర్శించుచు, ఆయా దేవతలను సేవించుచు, పుణ్యనదులలో స్నానము చేయుచు, శ్రీరంగమును జేరుకొనెను. అక్కడ కావేరీనది రెండుపాయలై ప్రవహించుచుండగా మధ్యనున్న శ్రీరంగనాథాలయమున శేషశయ్యపై పవళించియున్న శ్రీరంగనాథుని గాంచి పరవశమొంది, చేతులు జోడించి, దామోదరా! గోవిందా! గోపాలా! హరే కృష్ణా! వాసుదేవా! అనంతా! అచ్యుతా! ముకుందా! పురాణపురుషా! హృషికేశా! ద్రౌపదీమాన సంరక్షకా! దీనజన భక్తపోషా! ప్రహ్లాదవరదా! గరుడధ్వజా ! కరివరదా! పాహిమాం! పాహమాం! రక్షమాం రక్షమాం! దాసోహం పరమాత్మ దాసోహం అని విష్ణు సోత్త్రమును పఠించి, కార్తీక మాసమంతయు శ్రీ రంగము నందే గడిపి తదుపరి సపరి వారముగా అయోధ్యకు బయలుదేరును. పురంజయుడు శ్రీరంగనాథస్వామి సమక్షమున కార్తీక మాసములో చేసిన వ్రతముల, మహిమ వలన అతని రాజ్యమందలి జనులందరూ సిరిసంపదలతో, పాడిపంటలతో, ధనధాన్యాలతో, ఆయురారోగ్యములతో నుండిరి.",
        },
        {
          title: "",
        },
        {
          title: "అయోధ్యానగరము దృఢతర ప్రాకారములు కలిగి తోరణ యంత్రద్వారములు కలిగి మనోహర గృహాగోపురాదులతో చతురంగ సైన్య సంయుతమై ప్రకాశించుచుండెను. అయోధ్యా నగరమందలి వీరులు యుద్దనేర్పరులై, రాజనీతి గలవారై, వైరిగర్భ నిర్బేదకులై, నిరంతరము విజయశశీలురై, అప్రమత్తులై యుండిరి. ఆ నగర మందలి అంగనామణులు హంసగజగామినులూ, పద్మ పత్రాయత లోచనులూనై విపుల శోణీత్వము, విశాల కటిత్వము, సూక్ష్మ మద్యత్వము, సింహకుచపీనత్వము కలిగి రూపవతులనియు, శీలవతులనియు, గుణవతులనియు ఖ్యాతి కలిగి యుండిరి.",
        },

        {
          title: "",
        },
        {
          title: "ఆ నగర మందలి వెలయాండ్రు నృత్యగీత సంగీతాది కళావిశారదలై, ప్రౌఢలై, వయోగుణ రూప లావణ్య సంపన్నలై, సదా మోహన హాసాలంకృత ముఖిశోభితలై యుండిరి. ఆ పట్టణకులాంగనలు పతిశుశ్రూషా పారాయణలై సద్గుణాలంకార భూషితలై చిద్విలాస హసోల్లాస పులకాంకిత శరీరలై యుండిరి.",
        },
        {
          title: "",
        },
        {
          title: "పురంజయుడు శ్రీరంగక్షేత్రమున కార్తీకమాస వ్రతమాచరించి సతీసమేతుడై ఇంటికి సుఖముగా జేరెను. పురంజయుని రాక విని పౌరజనాదులు మంగళవాద్యతూర్య ధ్వనులతో ఎదురేగి నగర ప్రదక్షిణ చేసి నిజాంత:పురమును ప్రవేశపెట్టిరి. అతడు ధర్మాభిలాషియై దైవభక్తి పరాయుణుడై రాజ్యపాలన మొనర్చుచు, కొంతకాలము గడిపి వృద్దాప్యము వచ్చుటచే ఐహిక వాంఛలను వాదులుకొని, తన కుమారునికి రాజ్యభారమువప్పిగించి పట్టాభిషిక్తుని చేసి తాను వన ప్రస్థాశ్రమము స్వీకరించి అరణ్యమునకేగెను. అతడా వనప్రస్థాశ్రమమందు కూడా యేటేటా విధివిధానముగ కార్తీక వ్రతమాచరించుచు క్రమక్రమముగా శరీరముడుగుటచే మరణించి వైకుంఠమునుకు పోయెను. కావున, ఓ యగస్త్యా! కార్తీకవ్రతము అత్యంత ఫలప్రదమైన మహత్యము కలది. దానిని ప్రతి వారును ఆచరించవలెను. ఈ కథ చదివిన వారికి, చదివినపుడు వినువారికి కూడా వైకుంఠప్రాప్తి కలుగును.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే త్రయోవింశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "త్రయోవింశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ చతుర్వి౦శోధ్యాయ  ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> అంబరీషుని ద్వాదశీవ్రతము :</span>,
        },
        {
          title: "",
        },
        {
          title: "అత్రి మహాముని మరల అగస్త్యునితో ఓ కుంభసంభవా! కార్తీకవ్రత ప్రభావము ఎంత ఆచారించిననూ, ఎంత వినిననూ తనివి తీరదు. నాకు తెలిసినంతవరకు వివరింతును, ఆలకింపుము. గంగా, గోదావరీ మొదలగు నదులలో స్నానము చేసిన౦దువలనను, సూర్యచంద్ర గ్రహణ సమయములందు స్నానాదులు ఆరించినను యెంత ఫలము కలుగునో శ్రీమన్నారయణుని నిజతత్వమును తెలిపెడి కార్తీకవ్రతమందు శుద్ధద్వాదశినాడు భక్తిశ్రద్దలతో దానధర్మములు చేయు వారికిని అంత ఫలమే కలుగును. ఆ ద్వాదశినాడు చేసిన సత్కార్యఫలము ఇతర దినములలో చేసిన ఫలము కంటె వేయి రెట్లు అధికము కాగలదు. ఆ ద్వాదశీ వ్రతముచేయు విధానమెట్లో చెప్పెదను వినుము.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీక శుద్ధ దశమి రోజున, పగటి పూట మాత్రమే భుజించి ఆ మరునాడు అనగా ఏకాదశి రోజున వ్రతము చేశాక శుష్కోపవాసముండి ద్వాదశి ఘడియలు వచ్చిన తరువాతనే భుజింపవలయును. దీనికొక ఇతిహాసము కలదు. దానిని కూడ వివరించెదను. సావధానుడవై అలకింపుము అని ఇట్లు చెప్పుచున్నాడు.",
        },
        {
          title: "",
        },
        {
          title: "పూర్వము అంబరీషుడను రాజు కలడు. అతడు పరమభాగవతోత్తముడు. ద్వాదశీవ్రత ప్రియుడు. అంబరీషుడు ప్రతి ద్వాదశి నాడు తప్పకుండ వ్రతము చేయుచుండెడివాడు. ఒక ద్వాదశినాడు, ద్వాదశి ఘడియలు స్వల్పముగా నుండెను. అందుచే ఆ రోజు పెందలకడనే వ్రతమును ముగించి బ్రాహ్మణ సమారాధన చేయదలచి సిద్దముగా నుండెను. అదే సమయమున అచ్చటకు కోపస్వభావుడగు దుర్వాసుడు వచ్చెను. అంబరీషుడు ఆ మునిని గౌరవించి, ద్వాదశి ఘడియలలో పారాయణ చేయవలయునుగాన, తొందరగా స్నానమునకేగి రమ్మనమని కోరెను. దుర్వాసుడ౦దుల క౦గీకరించి సమీపమున గల నదికి స్నానమునకై వెడలెను. అంబరీషుడు ఎంత సేపు వేచియున్ననూ దుర్వాసుడు రాలేదు. ద్వాదశి ఘడియలు దాటిపోవుచున్నవి. అందుచేత అంబరీషుడు తనలో తానిట్లనుకొనెను. ఇంటికొచ్చిన దుర్వాసుని భోజనమునకు రమ్మంటిని. ఆ ముని నదికి స్నానముకు వెళ్లి ఇంతవరకు రాలేదు.",
        },

        {
          title: "",
        },
        {
          title: "బ్రాహ్మణునకాతిధ్యమిత్తునని మాటయిచ్చి భోజనం పెట్టక పోవుట మహాపాపము. అది గృహస్తునకు ధర్మము గాదు. అయన వచ్చువరకు ఆగితినా ద్వాదశీఘడియలు దాటిపొవును. వ్రతభంగమగును. ఈ ముని మహా కోపస్వభావము గలవాడు. ఆయన రాకుండగా నేను భుజించిన నన్ను శపించును. నాకేమియు తోచకున్నది. బ్రాహ్మణ భోజనమతిక్రమించరాదు. ద్వాదశి ఘడియలు మించిపోకూడదు. ఘడియలు దాటిపోయిన పిదప భుజించినయెడల, హరిభక్తిని వదలిన వాడనగుదను. ఏకాదశి నాడున ఉపవాసము నిష్పలమగును. ద్వాదశి విడిచి భుజించిన భగవంతునకు, భోజనము చేసిన దూర్వాసునకు కోపము వచ్చును. అదియునుగాక, ఈ నియమమును నేను అతిక్రమించిన యెడల వెనుకటి జన్మయందు జేసిన పుణ్యములు నశించును. దానికి ప్రాయశ్చితము లేదు అని అలోచించి బ్రాహ్మణ శాపమునకు భయము లేదు. ఆ భయమును శ్రీమహావిష్ణువే బోగట్టగలదు. కావున నేను ద్వాదశి ఘడియలలో భోజనము చేయుటయే ఉత్తమము. అయిననూ పెద్దలతో ఆలోచించుట మంచిదని, సర్వజ్ఞులైన కొందరు పండితులను రావించి వారితో ఇట్లు చెప్పెను.",
        },
        {
          title: "",
        },
        {
          title: "ఓ పండిత శ్రేష్టులారా! నిన్నటి దినమున ఏకాదశి అగుటం వలన నేను కటిక ఉపవాసము ఉంటిని. ఈ దినమున స్వల్పముగా మాత్రమే ద్వాదశి ఘడియలున్నవి. ద్వాదశి ఘడియలలోనే భుజించవలసియున్నది. ఇంతలో నా ఇంటికి దూర్వాస మహాముని విచ్చేసిరి. అ మహామునిని నేను భోజనమునకు ఆహ్వాని౦చితిని. అందులకాయన అంగీకరించి నదికి స్నానర్ధమై వెళ్లి ఇంతవరకూ రాకుండెను. ఇప్పుడు ద్వాదశి ఘడియలు దాటిపోవుచున్నవి. బ్రాహ్మణుని వదిలి ద్వాదశి ఘడియలలో భుజింపవచ్చునా? లేక, వ్రతభ౦గమును సమ్మతించి ముని వచ్చేవరకు వేచియుండవలెనా? ఈ రెండిటిలో ఏది ముఖ్యమైనదో తెలుపవలసినదని కోరెను.",
        },
        {
          title: "",
        },
        {
          title: "అంతట యా ధర్మజ్ఞులైన పండితులు, ధర్మ శాస్త్రములు పరిశోధించి విమర్శ ప్రతివిమర్శలు చేసికొని, దీర్ఘముగా అలోచించి, మహా రాజా! సమస్త ప్రాణి కోటుల గర్భకుహరములందు జఠరాగ్ని రూపమున రహస్యముగా నున్న అగ్నిదేవుడు ఆకలిని పుట్టించి ప్రాణులు భుజించిన చతుర్విధాన్నమును పచనముగావించి దేహే౦ద్రియాలకు శక్తినొసంగుచున్నాడు. ప్రాణవాయువు సహాయముతో జఠరాగ్ని ప్రజ్వరిల్లును. అది చెలరేగిన క్షుద్భాధ దప్పిక కలుగును. అ తపము చల్లార్చవలెనన్న అన్నము, నీరు పుచ్చుకొని శాంతపరచవలెను. శరీరమునకు శక్తి కలుగచేయువాడు అగ్నిదేవుడు, దేవతలందరికంటే అధికుడై దేవపూజ్యుడైనాడు. ఆ అగ్నిదేవుడని అందరూ సదాపూజింపవలెను. గృహస్తు, ఇంటికి వచ్చిన అతిధి కడజాతివాడైనను 'భోజన మిడుదు' నని చెప్పి వానికి పెట్టకుండా తినరాదు. అందులోనూ వేదవేదాంగ విద్యావిశారదుడును, మహతపశ్శాలియు, సదాచార సంపన్నుడును అయిన దుర్వాస మహామునిని భోజనమునకు పిలిచి వానికి పెట్టకుండా తాను భుజించుట వలన మహాపాపము కలుగును. అందువలన అయుక్షిణము కలుగును. దుర్వాసునంతటి వానిని అవమానమొనరించిన పాపము సంప్రాప్తమగను అని విశదపరచిరి. ",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే చతుర్వి౦శోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "చతుర్వి౦శోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ పంచవింశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> దూర్వాసుడు అంబరీషుని శపించుట :</span>,
        },
        {
          title: "",
        },
        {
          title: "అంబరీషా! పూర్వజన్మలో కించిత్ పాపవిశేషమువలన నీకీ యనర్ధము వచ్చినది. నీ బుద్దిచే దీర్ఘముగా ఆలోచించి నీకెటుల అనుకూలించునో అటులనే చేయుము. ఇక మాకు సెలవిప్పించుము అని పండితులు పలికిరి. అంత అంబరీషుడు ఓ పండితోత్తములారా! నానిశ్చితాభిప్రాయమును ఆలకించి వెడలుడు. ద్వాదశీనిష్టను విడచుట కన్న, విప్రశాపము అధికమయినది కాదు. జలపానము చేయుట వలన బ్రాహ్మణుని అవమానపరచుటగాదు. ద్వాదశిని విడచుటయుగాదు. అప్పుడు దూర్వాసుడు నన్నేల నిందించును? నిందింపడు. నా తొల్లి పుణ్యఫలము నశింపదు గాన, జలపాన మొనరించి వూరకుందును అని వారి యెదుటనే జలపానము నొనరించెను.",
        },
        {
          title: "",
        },
        {
          title: "అంబరీషుడు జలపాన మొనరించిన మరుక్షణముచే దూర్వాసుడు స్నానజపాదులు పూర్తి చేసుకొని అక్కడకు వచ్చెను. వచ్చిన వెంటనే ఆ ముని మహారౌద్రాకారుడై క౦డ్ల వెంట నిప్పులు గ్రక్కుచూ ఓరీ మదాంధా! నన్ను భోజనానికి రమ్మని, నేను రాకనే నీవేల భుజించితివి? ఎంత దుర్మార్గము, ఎంత నిర్లక్ష్యము? ఎంతటి ధర్మ పరిత్యాగివి? అతిధికి అన్నము పెట్టెదనని ఆశజూపి పెట్టకుండా తాను తినినవాడు మలభక్ష కుడగును. అట్టి అధముడు మరుజన్మలో పురుగై పుట్టును. నీవు భోజనమునకు బదులు జలపానము చేసితివి. అది భోజనముతో సమానమైనదే. నీవు అతిధిని విడిచి భుజించినావు కాన, నీవు నమ్మకద్రోహివగుదువేగాని హరిభక్తుడవెట్లు కాగలవు? శ్రీ హరి బ్రాహ్మణావమానమును సహింపడు. మమ్మే యవమానించుట యనిన శ్రీహరిని అవమానించుటయే. నీవంటి హరినిందాపరుడు మరి యొకడులేడు.",
        },
        {
          title: "",
        },
        {
          title: "నీవు మహాభక్తుడనని అతి గర్వము కలవాడవై ఉన్నావు. ఆ గర్వముతోనే నీవు నన్ను భోజనమునకు ఆహ్వానించి అవమానపరచి నిర్లక్ష్యముగా జలపాన మొనరించితివి. అంబరీషా! నీవెట్లు పవిత్ర రాజకుటుంబములో బుట్టినావురా! నీ వంశము కళంకము కాలేదా? అని కోపముతో నోటికి వచ్చినట్లు తిట్టెను. అ౦బరీషుడు, ముని కోపమునకు గడ గడ వణుకుచు, ముకుళిత హస్తములతో మహానుభావా! నేను ధర్మహీనుడను, నా అజ్ఞానముచే నేనీ కార్యము చేసితిని. నన్ను రక్షింపుడు. బ్రాహ్మణులకు శాంతియే ప్రధానము. మీరు తపోధనులూ, దయా దాక్షిణ్యములు గలవారూ కాన, నన్ను కాపాడుడని అతని పాదములపై పడెను. దయాశూన్యుడైన దూర్వాసుడు అంబరీషుని తలను తన ఎడమకాలితో తన్ని దోషికి శాపమీయకుండా ఉండరాదు.",
        },

        {
          title: "",
        },
        {
          title: "నీవు మొదటి జన్మలో చేపగాను, రెండవ జన్మలో తాబేలుగానూ, మూడవజన్మలో పందిగాను, నాలుగవ జన్మలో సింహముగాను, ఐదవజన్మలో వామనుడు గాను, ఆరవ జన్మలో క్రూరుడవగు బ్రాహ్మణుడవుగాను, ఏడవ జన్మలో మూఢుడవైన రాజు గాను, ఎనిమిదవ జన్మలో రాజ్యముగాని సింహాసనముగాని లేనట్టి రాజు గాను, తొమ్మిదవ జన్మలో పాషండ మతస్తునిగాను, పదవ జన్మలో పాప బుద్ధి గల దయలేని బ్రాహ్మణుడవుగాను పుట్టెదవుగాక అని వెనుక ముందు ఆలోచించక శపించెను. ఇంకను కోపము తగ్గనందున మరల శపించుటకు ఉద్యుక్తడగుచుండగా, శ్రీ మహావిష్ణువు బ్రాహ్మణ శాపము వృధాకాకూడదని, తన భక్తునికి ఏ అపాయము కలుగకుండుటకు అంబరీషుని హృదయములో ప్రవేశించి మునివర్యా! అటులనే మీ శాపమనుభవింతునని ప్రాధేయపడెను.",
        },
        {
          title: "",
        },
        {
          title: "కాని దూర్వసుడింకనూ కోపము పెంచుకొని శపించబోగా, శ్రీమన్నారాయణుడు తన సుదర్శన చక్రమును అడ్డుపెట్టెను. ఆ సుదర్శనము కోటి సూర్యప్రభలతో అగ్నిజ్వాలలు గ్రక్కుచూ దూర్వసునిపై పడబోయెను. అంత దూర్వాసుడు ఆ చక్రము తనని మసిచేయునని తలంచి ప్రాణముపై ఆశ కలిగి అచటి నుండి బ్రతుకుజీవుడా యని పరుగిడెను. మహాతేజస్సుతో చక్రాయుధము దూర్వసుని తరుముచుండెను. దుర్వాసుడు తనను కాపాడమని భూలోకమున ఉన్న మహామునులను, దేవలోకమున కెరిగి దేవేంద్రుని, బ్రహ్మలోకానికి వెళ్లి బ్రహ్మదేవుని, కైలాసమునకు వెళ్లి పరమేశ్వరునీ యెంత ప్రార్దంచినను వారు సైతము చక్రాయుధము బారినుండి దూర్వాసుని కాపాడలేకపోయిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే పంచవింశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "పంచవింశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ షడ్వి౦శోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> దూర్వాసుడు శ్రీహరిని శరణువేడుట - శ్రీహరి హితబోధ :</span>,
        },
        {
          title: "",
        },
        {
          title: "ఈ విధముగా అత్రిమహాముని అగస్త్యునితో దూర్వాసుని కోపము వల్ల కలిగిన ప్రమాదమును తెలిపి, మిగిలిన వృత్తాంతమును ఇట్లు తెలియజేసెను. ఆ విధముగా ముక్కోపియైన దూర్వాసుడు భూలోకము, భువర్లోకము, పాతాళలోకము, సత్యలోకములకు తిరిగి తిరిగి అన్ని లోకములలోను తనను రక్షించువారు లేకపోవుటచే వైకుంఠమందున్న మహావిష్ణువు కడకువెళ్లి వాసుదేవా! జగన్నాథా! శరణాగతరక్షణ బిరుదాంకితా! రక్షింపుము. నీ భక్తుడైన అంబరీషునకు కీడు చేయదలచిన నేను బ్రాహ్మణుడను గాన, ముక్కోపినై మహాపరాధము చేసితిని.",
        },
        {
          title: "",
        },
        {
          title: "నీవు బ్రాహ్మణ ప్రియుడవు. బ్రాహ్మణుడైన భృగుమహర్షి నీ యురముపై తనిన్నను సహించితివి. అ కాలిగురుతు నేటికినీ నీవక్షస్దలమందున్నది. ప్రశాంతమనస్కుడవై అతనిని రక్షించినట్లే కోపముతో నీ భక్తునికి శాపమిచ్చిన నన్ను కూడ రక్షింపుము. శ్రీహరి! నీచక్రాయుధము నన్ను జంపవచ్చుచున్న దూర్వాసా! నీ మాటలు యదార్ధములు. నీవంటి తపోధనులు నాకత్యంత ప్రియులు.",
        },
        {
          title: "",
        },
        {
          title: "నీవు బ్రాహ్మణ రూపమున బుట్టిన రుద్రడవు. నిన్ను జూచిన వారు మూడు లోకములందు భయపడకుందురా! నేను త్రికరణములచే బ్రాహ్మణులకు మాత్రము ఎట్టి హింసా కలిగించను. ప్రతియుగమందున గో, దేవ, బ్రాహ్మణ, సాధు జనంబులకు సంభవించే ఆపదలను పోగొట్టుటకు ఆయా పరిస్ధితులకు తగిన రూపములు ధరించి దుష్టశిక్షణ శిష్టరక్షణ గావింతును. నీవకారణముగా అంబరీషుని శపించితివి. నేను శత్రువుకైనను మనోవాక్కయములందు కూడా కీడు తలపెట్టను. ఈ ప్రపంచమందుగల ప్రాణి సమూహము నా రూపముగానే జూతును. అంబరీషుడు ధర్మయుక్తముగా ప్రజాపాలన చేయుచుండెను. కాని, అటువంటి నా భక్తుని నీవు అనేక విధములు దూషించితివి.",
        },

        {
          title: "",
        },
        {
          title: "నీ యెడమ పాదముతో తన్నితివి. అతని ఇంటికి నీవు అతిథివై వచ్చికూడ, నేను వేళకు రానియెడల ద్వాదశి షుడియలు దాటకుండ భుజింపుమని అంబరీషునకు చెప్పవైతివి. అతడు వ్రతభంగమునుకు భయపడి, నీ రాకకై చూచి జలపానమును మాత్రమే జేసెను. అంతకంటే అతడు అపరాధము యేమిచేసెను! చాతుర్వర్ణములవారికి భోజన నిషిద్ద దినములందు కూడా జలపానము దాహశాంతికిని, పవిత్రతకును చేయదగినదే కదా, జలపాన మొనరించిన మాత్రమున నా భక్తుని దూషించి శపించితివి.",
        },
        {
          title: "",
        },
        {
          title: "అతడు వ్రతభంగమునకు భయపడి జలపానము చేసినాడు కాని నిన్నవమానించుటకు చేయాలేదే, నీవు మండిపడుచున్నను బ్రతిమాలి నిన్ను శాంతింపచేయ జూచెను, ఎంత బ్రతిమాలినను నీవు శాంతింపనందున నన్ను శరణువేడెను. నేనపుడు రాజు హృదయములో ప్రవేశించినాను. నీ శాపఫలము పది జన్మలలో అనుభవించుదునని పలికిన వాడిని నేనే. అతడు నీ వలన భయముచే నన్ను శరణు వేడుచుండెను. కాని, తన దేహము తాను తెలుసుకోనే స్దితిలో లేడు. నీ శాపమును అతడు వినలేదు. అంబరీషుడు నాభక్త కోటిలో శ్రేష్టుడు. నిరపరాధి, దయాశాలి, ధర్మతత్పరుడు. అటువంటి వానిని అకారణముగా దూషించితివి. అతనిని నిష్కారణముగా శపించితివి. విచారించవలదు. ఆ శాపమును లోకోపకారమునకై నేనే అనుభవింతును.",
        },
        {
          title: "",
        },
        {
          title: "అదెటులనిన నీ శాపములోనిది మొదటి జన్మ మత్స్యజన్మ. నేనీ కల్పమును మనువును రక్షించు నిమిత్తము, సోమకుడను రాక్షసుని జంపుటకు మత్స్యరూపమెత్తుదును. మరి కొంత కాలమునకు దేవదానవులు క్షీర సాగరమును మదించుటకు మందర పర్వతమును కవ్వముగా చేయుదురు. అ పర్వతమును నీటిలో మునగకుండ కూర్మరూపమున నా వీపున మోయుదును. వరాహజన్మమెత్తి హిరణ్యాక్షుని వధింతును. నరసింహ జన్మమెత్తి హిరణ్యకశిపుని జంపి, ప్రహ్లాదుని రక్షింతును. బలిచే స్వర్గము నుండి పారద్రోలబడిన ఇంద్రునకు తిరిగి స్వర్గమును అప్పగించుటకు వామనరూపమెత్తి బలిచక్రవర్తిని పాతాళ లోకమునకు త్రొక్కివేతును.",
        },
        {
          title: "",
        },
        {
          title: "భూ భారమును తగ్గి౦చుటకు క్షత్రియులను చంపి బ్రాహ్మణుడనై జన్మించి భూ భారమును తగ్గింతును. లోకకంటకుడయిన రావణుని జంపి లోకోపకారము చేయుటకు రఘువంశమున రాముడనై జన్మింతును. పిదప, యదువంశమున శ్రీకృష్ణునిగను, కలియుగమున బుద్దుడుగను, కలియుగాంతమున విష్ణు చిత్తుడను విప్రునియింట కల్కియను పేరున జన్మించి, అశ్వారూఢు౦డనై పరిభ్రమించుచు బ్రహ్మదేషులనందరను మట్టుబెట్టుదును. నీవు అంబరీషునకు శాపరూపమున నిచ్చిన పదిజన్మలను ఈ విధముగా పూర్తిచేయుదును. ఇట్లు నా దశావతారములను సదా స్మరించువారికి సమస్త పాపములు హరింపజేసి వైకుంఠ ప్రాప్తి నోసంగుదును. ఇది ముమ్మాటికి తథ్యము.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే షడ్వి౦శోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "షడ్వి౦శోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ సప్తవింశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> దుర్వాసుడు అంబరీషుని ఆశ్రయించమని శ్రీహరి చెప్పుట :</span>,
        },
        {
          title: "",
        },
        {
          title: "అత్రిమహాముని తిరిగి అగస్త్యునితో ఇలా చెబుతున్నాడు, ఓ కుంభసంభవా! ఆ శ్రీహరి దుర్వాసుని ఎంతో ప్రేమతో చేరదీసి ఇలా చెబుతున్నాడు అని వృత్తాంతాన్ని వివరించారు.",
        },
        {
          title: "",
        },
        {
          title: "శ్రీమహావిష్ణువు దుర్వాసునితో ఇలా చెబుతున్నాడు ఓ దుర్వాస మహాముని! నీవు అంబరీషుడిని శపించిన విధంగా ఆపాది జన్మలు నాకు సంతోషకరమైనవే. నేను అవతారమెత్తుట కష్టం కాదు. నీవు తపశ్శాలివి. నీ మాటలకు విలువ ఇవ్వక తప్పదు. అందుకు నేను అంగీకరించాను. బ్రాహ్మణుల మాట తప్పకుండా ఉండేలా చేయడమే నా కర్తవ్యం.",
        },
        {
          title: "",
        },
        {
          title: "నీవు అంబరీషుని ఇంట్లో భుజించకుండా వచ్చినందుకు అతను చింతతో ఉన్నాడు. బ్రాహ్మణ పరివృత్తుడైనందుకు ప్రాయోపవేశం (అగ్నిలో దూకి ఆత్మహత్య) చేసుకోవాలని నిర్ణయించాడు. ఆ కారణం వల్ల విష్ణు చక్రం నిన్ను బాధించేందుకు పూనుకుంది. ప్రజారక్షణే రాజధర్మం. ప్రజాపీడనం కాదు. ఒక బ్రాహ్మణుడు దుష్టుడైనట్లయితే వాన్ని జ్ఞానులైన బ్రాహ్మణులు శిక్షించాలి. ఒక విప్రుడు పాపి అయితే మరో విప్రుడు దండించాలి.",
        },

        {
          title: "",
        },
        {
          title: "ధనుర్బాణాలు ధరించి ముష్కరుడై యుద్ధానికి వచ్చిన బ్రాహ్మణుడిని తప్ప, మరెవ్వరూ బ్రాహ్మణుడిని దండించకూడదు. బ్రాహ్మణ యువకుడిని దండించడం కంటే మరో పాపం లేదని న్యాయశాస్త్రాలు ఘోషిస్తున్నాయి. బ్రాహ్మణుడి సిగబట్టి లాగినవాడు, కాలితో తన్నినవాడు, విప్రుని ద్రవ్యం అపహరించేవాడు, బ్రాహ్మణుడిని గ్రామం నుంచి తరిమినవాడు, విప్ర పరిత్యాగమొనర్చినవాడు బ్రహ్మ హంతకులే అవుతారు.",
        },
        {
          title: "",
        },
        {
          title: "కాబట్టి ఓ దుర్వాస మహర్షి! అంబరీషుని గురించి తప:శ్శాలి అయిన అంబరీషుడు నీ మూలంగా ప్రాణ సంకటం పొందుతున్నాడు. నేను బ్రహ్మ హత్యచేశానే అని చింతిస్తూ పరితాపం పొందుతున్నాడు. కాబట్టి, నీవు వేగమే అంబరీషుడి వద్దకు వెళ్లు. అందువల్ల మీ ఇద్దరికీ శాంతి లభిస్తుంది అని విష్ణుదేవుడు దుర్వాసునికి నచ్చజెప్పి అంబరీషుడి వద్దకు పంపాడు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే సప్తవింశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "సప్తవింశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ అష్టామింశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> విష్ణు సుదర్శన చక్ర మహిమ : </span>,
        },
        {
          title: "",
        },
        {
          title: "వశిష్టుల వారు జనక మహారాజుతో తిరిగి ఇలా అంటున్నారు,ఓ జనక మహారాజా! విన్నావా? దుర్వాసుడి అవస్థలు! తాను ఎంతటి కోపవంతుడైనా వెనకా, ముందు ఆలోచించకుండా మహాభక్తుని శుద్ధని శంకించాడు, కాబట్టి ప్రయాసలపాలయ్యాడు. ఎంత గొప్పవారైనా ఆచరించు కార్యక్రమాలు జాగ్రత్తగా తెలుసుకోవాలి అని చెబుతూ, అత్రి మహర్షి అగస్త్యునికి చెప్పిన వృత్తాంతాన్ని తిరిగి వివరిస్తున్నాడు.",
        },
        {
          title: "",
        },
        {
          title: "అలా దుర్వాసుడు శ్రీమన్నారాయణుడి వద్ద సెలవు తీసుకుని, తనను వెన్నంటి తరుముతున్న సుదర్శన చక్రాన్ని చూసి, భయపడుతూ తిరిగి భూలోకానికి చేరుకుని, అంబరీషుడి వద్దకు పోయి, ఓ అంబరీషా! ధర్మపాలకా! నా తప్పును క్షమించి, నన్ను రక్షింపుము. నీకు నాపై ఉన్న అనురాగంతో ద్వాదశిపారణమునికి నన్ను ఆహ్వానించావు. అయితే నేను నిన్ను కష్టాలపాలు చేశాను. వ్రతభంగం చేయించి, నీ పుణ్యఫలాన్ని నాశనం చేయాలనుకున్నా, కానీ నా దుర్భుద్ధి నన్నే వెంటాడి, నా ప్రాణాలను తీయడానికి సిద్ధపడింది. నేను విష్ణువు వద్దకు వెళ్లి సుదర్శనం నుంచి కాపాడమని ప్రార్థించాను.",
        },
        {
          title: "",
        },
        {
          title: "ఆ పురాణపురుషుడు నాకు జ్ఞానోదయం చేసి, నీ వద్దకు వెళ్లమని చెప్పాడు. కాబట్టి నీవే నాకు శరణ్యం. నేను ఎంతటి తపశ్శాలినైనా, ఎంతటి నిష్టావంతుడనైనా నీ నిష్కళంక భక్తి ముందు సరిపోలను. నన్ను ఈ విపత్తు నుంచి కాపాడు అని అనేక విధాలుగా ప్రార్థించాడు. అంబరీషుడు శ్రీమన్నారాయణుడిని ధ్యానించి, ఓ సుదర్శన చక్రమా! నీకివే నా నమస్కారాలు. ఈ దుర్వాస మహాముని తెలిసో, తెలియకో తొందరపాటుగా ఈ కష్టాలను కొని తెచ్చుకున్నాడు. అయినా ఇతడు బ్రాహ్మణుడు. కాబట్టి ఇతన్ని చంపకు.",
        },
        {
          title: "",
        },
        {
          title: "ఒకవేళ నీ కర్తవ్యాన్ని నిర్వహించక తప్పదనుకుంటే ముందు నన్ను చంపి ఆ తర్వాత ఈ దుర్వాసుడిని చంపు. శ్రీమన్నారాయణుడి ఆయుధానివి నీవు. నేను ఆ శ్రీహరి భక్తుడను. నాకు శ్రీమన్నారాయణుడు ఇలవేల్పు, దైవం. నీవు శ్రీహరి చేతిలో ఉండి అనేక యుద్ధాల్లో అనేక మంది లోక కంటకులను చంపావు. కానీ శరణు కోరేవారిని ఇంతవరకు చంపలేదు. అందుకే దుర్వాసుడు ముల్లోకాలు తిరిగినా ఇతన్ని వెంటాడుతూనే ఉన్నావు. కానీ చంపలేదు. దేవా! సురాసురాది భూతకోటి ఒక్కటిగా ఏకమైనా నిన్నేమీ చేయజాలవు. నీ శక్తికి ఏ విధమైనా అడ్డు లేదు. ఈ విషయం లోకమంతటికీ తెలుసు. అయినా మునిపుంగవుడికి ఏ అపాయం కలుగకుండా రక్షింపుము. నీ యందు ఆ శ్రీమన్నారాయణుడి శక్తి ఇమిడి ఉంది.",
        },

        {
          title: "",
        },
        {
          title: "శరణు వేడిన ఈ దుర్వాసుడిని రక్షింపుమని నిన్ను వేడుతున్నాను అని అనేక విధాలుగా స్తుతించాడు. అప్పటి వరకు అతి రౌద్రంతో నిప్పులు కక్కుతున్న విష్ణుచక్రం అంబరీషుడి ప్రార్థనకు శాంతించింది. ఓ భక్తాగ్రేసరా అంబరీషా! నీ భక్తిని పరీక్షించడానికి ఇలా చేశానేతప్ప మరొకందుకు కాదు. అత్యంత దుర్మార్గులు, మహాపరాక్రమవంతులైన మధుకైటభులను, దేవతలంతా ఏకమైనా చంపలేని మూర్ఖులను నేను దునిమాడటం నీకు తెలుసుకదా? ఈ లోకంలో దుష్ట శిక్షణ, శిష్ట రక్షణకు శ్రీహరి నన్ను వినియోగించి, ముల్లోకాల్లో ధర్మాన్ని స్థాపిస్తున్నాడు. ఇది అందరికీ తెలిసిన విషయమే.",
        },
        {
          title: "",
        },
        {
          title: "ముక్కోపి అయిన దుర్వాసుడు నీపై పగపట్టి, నీ వ్రతాన్ని భంగపరిచి, నశింపజేసి, నానా ఇక్కట్లు పెట్టడం, కన్నులెర్రచేసి నీ మీద చూపిన రౌద్రాన్ని నేను గమనించాను. నిరపరాధివైన నిన్ను రక్షించి, ఈ ముని గర్వం అణచాలని తరుముతున్నాను. ఇతనూ సామాన్యుడు కాదు. రుద్రాంశం సంభూతుడు. బ్రహ్మతేజస్సు గలవాడు. మహా తపశ్శాలి. రుద్రతేజంతో భూలోకవాసులను చంపగల శక్తి ఆయనకుంది. బ్రహ్మ, విష్ణు, మహేశ్వర తేజస్సు కలవాడు. వారుగానీ, నేనుగానీ, క్షత్రియ తేజస్సున్న నీవుగానీ, ఆయన ముందు సరితూగలేం. అయితే తనకన్నా ఎక్కువ శక్తివంతులతో సంధిచేసుకోవడం ఉత్తమం. ఈ నీతిని ఆచరించు వారు ఎలాంటి విపత్తుల నుంచి అయినా తప్పించుకోగలరు. ఇంతవరకు జరిగినదంతా విస్మరించి, శరణార్థిగా వచ్చిన ఆ దుర్వాసుడిని గౌరవించి, నీ ధర్మం నీవు నిర్వర్తించు అని సుదర్శనుడు పలికాడు.",
        },
        {
          title: "",
        },
        {
          title: "ఆ మాటలకు అంబరీషుడు నేను దేవ, గో, బ్రాహ్మణాదుల పట్ల, స్త్రీల పట్ల గౌరవభావంతో మెసలుకుంటాను. నా రాజ్యంలో సర్వజనులూ సుఖంగా ఉండాలి అని కోరుకుంటాను. కాబట్టి శరణు కోరిన ఈ దుర్వాసుడిని, నన్ను రక్షించు. వేల అగ్నిదేవతలు, కోట్ల సూర్యమండలాలు ఏకమైనా నీ శక్తికి, తేజస్సుకు సాటిరావు. నీవు అసమాన్య తేజోరాశివి. మహావిష్ణువు నీన్ను విశేష కార్యాలకు వినియోగిస్తాడు. లోక కంఠకులు, గోవధ చేసేవారు, బ్రహ్మ హత్యాపాతకులు, బ్రాహ్మణ హింసాపరులపై నిన్ను ప్రయోగించి, దుష్ట శిక్షణ, శిష్ట రక్షణ చేస్తాడు అని ప్రార్థిస్తూ అంబరీషుడు చక్రాయుధానికి ప్రణమిల్లాడు.",
        },
        {
          title: "",
        },
        {
          title: "అంతట సుదర్శనుడు అంబరీషుడిని లేపి, ఆలింగనం చేసుకుని అంబరీషా! నీ నిష్కళంక భక్తికి మెచ్చాను. విష్ణు స్తోత్రం త్రికాలాల్లో ఎవరైతే చేస్తారో, ఎవరు దాన ధర్మాలతో పుణ్యఫలాన్ని వృద్ధి చేసుకుంటారో, ఎవరు పరులను హింసించకుండా, పరధనంపై ఆశపడకుండా, పర స్త్రీని చెరపట్టకుండా, గోవధ, బ్రాహ్మణ హత్య, శిశు హత్యాది మహాపాకాలను చేయకుండా ఉంటారో, వారి కష్టాలు తొలగిపోయి ఈ లోకంలో, పరలోకంలో సుఖశాంతులతో తలతూగుతారు. కాబట్టి, నిన్నూ, దుర్వాసుడిన్ని రక్షిస్తున్నాను. నీ ద్వాదశి వ్రత ప్రభావం చాలా గొప్పది. నీ పుణ్య ఫలం ముందు ఈ మునిపుంగవుడి తపశ్శక్తి సాటిరాదు అని చెప్పి అదృశ్యుమయ్యాడు.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే అష్టావింశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "అష్టామింశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ నవవింశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> అంబరీషుడు దుర్వాసుని పూజించుట - ద్వాదశి పారణము :</span>,
        },
        {
          title: "",
        },
        {
          title: "అత్రి మహాముని అగస్త్యులవారితో ఈ విధముగా సుదర్శన చక్రము అంబరీషునకభయమిచ్చి ఉభయులను రక్షించి, భక్త కోటికి దర్శనమిచ్చి అంతర్ధానమైన వైనము చెప్పి తిరిగి ఇట్లు నుడువ నారంభించెను.",
        },
        {
          title: "",
        },
        {
          title: "ఆ తరువాత అంబరీషుడు దుర్వాసుని పాదముల పైబడి దండ ప్రణామములాచరించి, పాదములను కడిగి, ఆ కడిగిన నీళ్లను తన శిరస్సుపై జల్లుకొని, ఓ మునిశ్రేష్టా! నేను సంసార మార్గమందున్న ఒక సామాన్య గృహస్తుడను. నా శక్తి కొలది నేను శ్రీ మన్నారాయణుని సేవింతును, ద్వాదశీ వ్రతము జేసుకోనుచు ప్రజలకు యెట్టి కీడు రాకుండా ధర్మవర్తనుడనై రాజ్యమేలుచున్నాను. నా వలన మీకు సంభవించిన కష్టమునకు నన్ను మన్ని౦పుడు.",
        },
        {
          title: "",
        },
        {
          title: "మీ యెడల నాకు అమితమైన అనురాగముండుట చేతనే తమకు ఆతిథ్యమివ్వవలయునని ఆహ్వానించితిని. కాన, నా అతిధ్యమును స్వీకరించి నన్నును, నా వంశమును పావనము జేసి కృతార్దుని చేయుడు, మీరు దయార్ద్ర హృదయులు, ప్రధమ కోపముతో నన్ను శపించినను మరల నా గృహమునకు విచ్చేసితిరి. నేను ధన్యుడనైతిని. మీరాక వలన శ్రీమహావిష్ణువు యొక్క సుదర్శనమును చూచు భాగ్యము నాకు కలిగినది. అందులకు నేను మీ ఉపకారమును మరువలేకున్నాను.",
        },

        {
          title: "",
        },
        {
          title: "మహానుభావా! నా మనస్సంతోషముచే మిమ్మెట్లు స్తుతింపవలయునో నా నోట పలుకులు రాకున్నవి. నా కండ్ల వెంటవచ్చు ఆనంద బాష్పములతో తమ పాదములు కడుగుచున్నాను. తమకు యెంత సేవచేసినను ఇంకను ఋణపడియుందును. కాన ఓ పుణ్యపురుషా! నాకు మరల నర జన్మ రాకుండా ఉండేటట్లును, సదా మీ బోటి మునిశ్రేష్ఠుల యందును ఆ శ్రీ మన్నారాయుణుని యందును మనస్సు గలవాడనై యుండునట్లును నన్నాశీర్వదించుడని ప్రార్ధించి, సహాప౦క్తి భోజనమునకు దయ చేయుమని ఆహ్వానించెను.",
        },
        {
          title: "",
        },
        {
          title: "ఈ విధముగా తన పాదముల పైబడి ప్రార్ధించుచున్న అంబరీషుని ఆశీర్వదించి రాజా! ఎవరు ఎదుటి వారి బాధను నివారణ గావించి ప్రాణములు కాపాడుదురో, ఎవరు శత్రువులకైనను శక్తి కొలది ఉపకారము చేయుదురో అట్టి వారు తండ్రితో సమానమని ధర్మశాస్త్రములు తెలియజేయుచున్నవి. నీవు నాకు ఇష్టుడవు. తండ్రితో సమానుడవైనావు. నేను నీకు నమస్కరించినచో నా కంటె చిన్న వాడగుట వలన నీకు అయుక్షిణము కలుగును.",
        },
        {
          title: "",
        },
        {
          title: "అందుచేత నీకు నమస్కరించుట లేదు. నీవు కోరిన ఈ స్వల్ప కోరికను తప్పక నెరవేర్చెదను. పవిత్ర ఏకాదశి వ్రతనిష్టుడవగు నీకు మనస్థాపమును కలుగజేసినందులకు వెంటనే నేను తగిన ప్రాయశ్చిత్తమును అనుభవించితిని, నాకు సంభవించిన విపత్తును తొలగించుటకు నివే దిక్కయితివి. నీతో భోజనము చేయుట నా భాగ్యము గాక మరొకటి యగునా? అని దుర్వాస మహాముని పలికి, అంబరీషుని అభీష్టము ప్రకారము పంచభక్ష్యపరమాన్నములతో సంతృప్తిగా విందారగించి, అతని భక్తిని కడుంగడు ప్రశంసించి, అంబరీషుని దీవించి, సెలవు పొంది తన ఆశ్రమమునకు వెళ్ళెను.",
        },
        {
          title: "",
        },
        {
          title: "ఈ వృత్తాంతమంతయు కార్తిక శుద్ధ ద్వాదశీదినంబున జరిగినది. కాన ఓ అగస్త్య మహామునీ! ద్వాదశీ వ్రతప్రభావమెంతటి మహత్యము గలదో గ్రహించితివి గదా! ఆ దినమున విష్ణుమూర్తి క్షీరసాగరమందున శేషశయ్యపై నుండి లేచి ప్రసన్న మనస్కుడై ఉండును. కనుకనే, ఆరోజుకంతటి శ్రేష్టతయు, మహిమ గలిగినది. ఆ దినమున చేసిన పుణ్యము ఇతర దినములలో పంచ దానములు చేసినంత ఫలమును పొందును.",
        },
        {
          title: "",
        },
        {
          title: "ఏ మనుజుడు కార్తీక శుద్ధ ఏకాదశి రోజున శుష్కోపవాసము౦డి పగలెల్ల హరి నామ సంకీర్తనచే గడిపి ఆ రాత్రంతయు పురాణము చదువుతూ లేక వింటూ జాగరణ చేసి ఆ మరునాడు అనగా ద్వాదశినాడు తన శక్తి కొలది శ్రీమన్నారయణునకు ప్రీతీకొరకు దానములిచ్చి బ్రాహ్మణులతో గూడి భోజనము చేయునో అట్టి వాని సర్వ పాపములు ఈ వ్రత ప్రభావము వలన పటాపంఛలై పోవును. ద్వాదశీ దినము శ్రీ మన్నారాయుణునికు ప్రీతికరమైన దినము కనుక ఆనాడు ద్వాదశిఘడియలు తక్కువగా యున్నను, ఆ ఘడియలు దాటకుండగానే భుజింపవలెను.",
        },
        {
          title: "",
        },
        {
          title: "ఎవరికైతే వైకుంఠములో స్థిర నివాసమేర్పరచుకొని ఉండాలని కోరిక ఉండునో, అట్టి వారు ఏకాదశి వ్రతము, ద్వాదశి వ్రతము రెండునూ చేయవలెను. ఏ యొక్కటియు విడువకూడదు. శ్రీహరికి ప్రీతికరమగు కార్తీక శుద్ధ ద్వాదశి అన్ని విధముల శ్రేయస్కరమైనది. దాని ఫలితము గురించి ఎంత మాత్రము సంశయింపకూడదు. మఱ్ఱి చెట్టు విత్తనము చాల చిన్నది, అయినను అదే గొప్ప వృక్షమైన విధముగా కార్తీక మాసములో నియమానుసారముగ జేసిన ఏ కొంచము పుణ్యమైనను, అది అవసానకాలమున యమదూతల పాలు కానీయక కాపాడును. అందులకే ఈ కార్తీకమాస వ్రతము చేసి దేవతలే గాక సమస్త మానవులు తరించిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఈ కథను యెవరు చదివినను లేక వినినను సకలైశ్వర్యములు సిద్దించి సంతాన ప్రాప్తి కూడా కలుగును అని అత్రిమహాముని అగస్త్యులవారితో బోధించిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే నవవింశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "నవవింశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#అథ త్రింశోధ్యాయ ప్రారంభః",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> కార్తీకవ్రత మహిమ ఫలశ్రుతి :</span>,
        },
        {
          title: "",
        },
        {
          title: "నైమిశారణ్య ఆశ్రమములో శౌనకాదిమహామునులందరకు సూతమహాముని తెలియజేసిన విష్ణుమహిమను, విష్ణుభక్తుల చరిత్రములను విని ఆనందించి, వేయినోళ్లకొనియాడిరి. శౌనకాది మునులకు ఇంకను సంశయములు తీరనందున, సూతునిగాంచి, ఓ ముని తిలకమా! కలియుగమందు ప్రజలు అరిషడ్వర్గములకు దాసులై, అత్యాచారపరులై జీవించుచు సంసారసాగరము తరింపలేకున్నారు. అటువంటివారు సులభముగా ఆచరించు తరణోపాయమేదైనా కలదా?",
        },
        {
          title: "",
        },
        {
          title: "ధర్మములన్నింటిలో మోక్షసాధనకుపకరించు ఉత్తమ ధర్మమేది? దేవతలందరిలోనూ ముక్తినొసంగు ఉత్తమదైవమెవరు? మానవుని ఆవరించియున్న అజ్ఞానమును రూపు మాపి పుణ్యఫలమిచ్చు కార్యమేది? ప్రతిక్షణము మృత్యువు వెంబడించుచున్న మానవులకు సులభముగా మోక్షము పొందగల ఉపాయమేమి? హరినామస్మరణ సర్వదా చేయుచున్న మేము ఈ సంశయములతోనున్నాము. కాన దీనిని వివరించి తెలియజేయుమని కోరిరి.",
        },
        {
          title: "",
        },
        {
          title: "అంత సూతుడా ప్రశ్న నాలకించి ఓ మునులారా! మీకు కలిగిన సంశయములు తెలుసుకొనవలసినవి. కలియుగమందలి మానవులు మందబుద్ధులు. క్షణిక సుఖములతో నిండిన సంసారసాగరమును దాటుటకు మీరడిగిన ప్రశ్నలు మోక్షసాధనము కాగలవు. కార్తీకవ్రతము శ్రీమన్నారాయణునకు ప్రీతికరమైన వ్రతము. ఇది అన్ని వ్రతముల కంటె ఘనమైనదని శ్రీహరి వివరించియున్నాడు. ఆ వ్రతమహిమ వర్ణించుటకు నాకు శక్తి చాలదు. అంతియేకాదు, సృష్టికర్తయగు ఆ బ్రహ్మదేవునికి కూడా శక్యముకాదు. అయినను సూక్షముగా వివరించెదను.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీకమాసమందు ఆచరించవలసిన పద్ధతులను జెప్పుచున్నాను శ్రద్ధగా ఆలకింపుడు. కార్తీకమాసమున సూర్యభగవానుడు తులారాశియందున్నప్పుడు శ్రీహరి ప్రీతికొరకు మనకు ముక్తి కలుగుటకు తప్పనిసరిగ నదీస్నానము చేయవలెను. దేవాలయానికి వెళ్లి హరిహరాదులను పూజింపవలెను. తనకున్న దానితో కొంచమైనా దీపదానం చేయవలయును. ఈ నెలరోజులు విధవ వండిన పదార్థములు తినకూడదు. రాత్రులు విష్ణు ఆలయమునగాని, శివాలయమునగాని ఆవునేతితో దీపారాధన చేయవలెను. ప్రతి దినము సాయంకాలము పురాణపఠనము చేయవలెను.",
        },
        {
          title: "",
        },
        {
          title: "ఈ విధముగా చేసిన సకల పాపముల నుండి విముక్తులై సర్వసౌఖ్యములు అనుభవింతురు. సూర్యుడు తులారాశియందున్న నెలరోజులు ఈ విధముగా ఆచరించువారు జీవన్ముక్తులగుదురు. ఇట్లు ఆచరించుటకు శక్తిఉండికూడా ఆచరించకగాని, లేక ఆచరించువారలను ఎగతాళి చేసినగాని, వారికి ధనసహాయము చేయువారికి అడ్డుపడిన వారు అనేక కష్టముల పాలగుటయేగాక వారి జన్మాంతర మందు నరకములో యమకింకరుల చేత నానా హింసలపాలుకాగలరు. అంతియేగాక అట్టివారు నూరుజన్మలవరకు ఛండాలాది హీన జన్మలెత్తుదురు.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీక మాసములో కావేరి నదిలో గాని, గంగా నదిలో గాని, అఖండ గౌతమి నదిలో గాని స్నానమాచరించి ముందు చెప్పిన విధముగా నిష్టతో ఆచరించిననూ ఇహమందు సర్వసుఖములను అనుభవించుటయేగాక, జన్మాంతరమున వైకుంఠవాసులగుదురు.",
        },
        {
          title: "",
        },
        {
          title: "సంవత్సరములో వచ్చు అన్ని మాసములకన్నా కార్తీకమాసము ఉత్తమోత్తమమైనది అధికఫలదాయకమైనది. హరి హరాదులకు ప్రీతికరమైనది. కనుక కార్తీకమాస వ్రతము వలన జన్మజన్మలనుండి వారలకున్న సకలపాపములు హరించి, మరుజన్మలేక, వైకుంఠమందగలరు. పుణ్యాత్ములకు మాత్రమే ఈ వ్రతమాచరించవలెననెది కోరిక పుట్టి దుష్టులకు, దుర్మార్గులకు, పాపాత్ములకు కార్తీకమాసమన్న కార్తీక వ్రతమన్నా అసహ్యము కలుగును.",
        },
        {
          title: "",
        },
        {
          title: "కాన ప్రతి మానవుడు ఈ పరమ సత్యమును గ్రహించి ఇటువంటి పుణ్యమును చేతులారా విడువక ఆచరించవలెను. ఇటుల నెలరోజులు చేయలేని వారు కార్తీకశుద్ద పౌర్ణమినాడు అయినను తమశక్తి కొలదీ వ్రతమాచరించి పురాణ శ్రవణము చేసి, జాగరణము ఉండి మరునాడు ఒక బ్రాహ్మణునకు భోజనమిడినచో నెలరోజులు చేసిన ఫలముతో సమానఫలము కలుగును.",
        },
        {
          title: "",
        },
        {
          title: "ఈ మాసములో ధనము, ధాన్యము, బంగారము, గృహము, కన్యాదానములు చేసినచో ఎప్పటికినీ తరగని పుణ్యము లభించును. ఈ నెలరోజులు ధనవంతుడైనను, బీదవాడైనను మరెవ్వరైనను సరే శ్రీహరినామస్మరణ చేయుచు, పురాణములు వింటూ, పుణ్యతీర్థములను సేవిస్తూ దానధర్మములు చేయుచున్న ఎడల వారికి పుణ్యలోకమబ్బును. ఈ కథను చదివిన వారికిని, వినిన వారికిని శ్రీమన్నారాయణుడు సకలైశ్వర్యములు ఇచ్చి వైకుంఠ ప్రాప్తి కలుగచేయును.",
        },
        {
          title: "",
        },
        {
          title: "ఇతి స్కాంద పురాణాంతర్గత వశిష్టప్రోక్త కార్తీక మహత్యే త్రింశోధ్యాయస్సమాప్త:",
        },
        {
          title: "",
        },
      ],
//  img: require('../imgs/Astotaram/Karthikamasam.png'),
//  image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "త్రింశోధ్యాయము",
    },
    {
      CatID: [
        {
          title: "#పోలి స్వర్గమునకు పోవుట ",
        },
        {
          title: "",
        },
        {
          title: "ఆంధ్రదేశమున పవిత్ర కృష్ణానదీ తీరమున బాదర అను గ్రామముండెను. ఆ గ్రామములో నివసించుచున్న అన్ని వర్ణముల వారును అన్నిటను సంపన్నులైయుండిరి. పాడి పంటలు, భోగభాగ్యములు, సుఖశాంతులు మున్నగువానితో ఆ గ్రామము సంతోషపూర్ణమై ఉండెను.",
        },
        {
          title: "",
        },
        {
          title: "ఆ గ్రామములో 'పోతడు' అను పేరుగల చాకలివాడొకడు కలడు. అతని భార్య 'మాలి' క్రూర స్వభావురాలు. దయాదాక్షిణ్యములు లేనిదై గయ్యాళియని పేరు పడెను. వారికి నల్గురు కుమారులు కలరు. ఆ దంపతులు తమ కుమారులు నలుగురికిని తగిన సమయములయందు వివాహము చేసిరి. మొదటి ముగ్గురు కోడళ్లను తమ అత్తగారివలెనే పొగరుబోతు స్వభావము కలిగి చెడ్డ పేరును తెచ్చుకొనిరి. అత్తగారితో సమానముగా గయ్యాళితనమును, చెడు స్వభావమును కలిగియుండిరి. నాలుగవ కోడలు 'పోలి' మృదు స్వభావురాలు, భర్తయందు ఆసక్తి కలిగియుండెను.",
        },
        {
          title: "",
        },
        {
          title: "ఊరి వారి బట్టల మాలిన్యమును పోగొట్టి స్వచ్చతను కలిగించు 'పోతడు' మాత్రము తన కుటుంబ సభ్యుల దుష్టస్వభావముచే నేర్పడిన తన కుటుంబంలోని మాలిన్యమును పోగొట్టలేని స్థితిలో నుండెను. దీనికి తోడు వాని నిర్ధనత్వము కూడా వానిని బాధించుచుండెను. చిన్నకోడలైన 'పోలి'ని తన భార్యయగు 'మాలి' మిగిలిన కోడళ్లును దూషించుట, బాధించుట గమనించియు నిస్సహాయుడై యూరకుండెను. అత్తయగు 'మాలి', మిగిలిన తోడికోడళ్లను ఇంటిపనులన్నిటిని పోలిపై వదలిరి. ఇంటి పనులన్నింటిని మారు మాట్లాడక తలవంచి చేయుచున్న ఆమె పై జాలియైన లేక ఆమెపై చాడీలు చెప్పి ఆమె భర్తచే 'పోలి'ని కొట్టించి, తిట్టించి సంతోషపడుచుండిరి. ఈ విధముగ తనను అత్తా, తోడికోడళ్లు అనేక విధములుగా బాధించుచున్నను, భర్తకు చాడీలు చెప్పి కొట్టించుచున్నను, తిట్టించుచున్నను, 'పోలి' తన శాంత స్వభావమును, దైవభక్తిని, ధర్మకార్యాసక్తిని విడువక కాలమును గడుపుచుండెను.",
        },
        {
          title: "",
        },
        {
          title: "ఇట్లుండగా కార్తీకమాసము వచ్చెను. గ్రామములోని వారందరును కార్తీకమాస స్నానములను చేయుటకై కృష్ణానదికి పోవుచుండిరి. నదిలో స్నానము చేసి తీరమున దీపములు వెలిగించుచు పూజలను చేయుచుండిరి. ఇట్లు గ్రామము నుండి నదీస్నానమునకు, దీపారాధనకు, పూజలకు చాలామంది వెళ్లిరి. అట్లు వెళ్లిన వారిలో నిజమైన భక్తులు కొందరుందురు. కొందరు తామును వారికివలె పూజ మున్నగువానిని చేసి పుణ్యమును సంపాదింపవలయునని తలచి నదీస్నానము మొదలగువానిని చేయుదురు. మరికొందరు తామును మిగిలిన వారివలె చేయనిచో బాగుండదని వచ్చి మిగిలిన వారి వలె నదీస్నానమును, మిగిలిన వానిని ఆచరింతురు. ఇట్టి వీరందరిని చూచి వినోదించుటకై కూడా మరికొందరు నదీస్నానము మొదలగు వానికి తయారగుదురు.",
        },

        {
          title: "",
        },
        {
          title: "పోలి అత్త 'పోలి'ని ఇంటి వద్ద నుంచి మాలి, ఆమె కోడళ్ళు ముగ్గురును నదీస్నానమునకు వెళ్లిరి. ఇంటిపనిని, బాధ్యతను 'పోలి'కి అప్పగించిరి. నదీ స్నానమునకు బోయి స్నానము, దీపారాధన మున్నగు వానిని చేయునప్పుడు 'మాలి' మున్నగు వారి దృష్టి దైవముపై, దైవ కార్యముపై లేదు. మనస్సును చేయు పనిపై నిలుపలేదు. భక్తి వారిలో మొదటి నుండియు లేదు. స్నానము మొదలగు వానిని చేయుచున్నను వారు, 'పోలి' ఇంటివద్ద పాలను త్రాగుచున్నదేమో, పెరుగు, వెన్న మొదలగు వానిని తినుచున్నదేమో? లేక వానిని అమ్ముకొని సొమ్ము చేసుకొని దాచుకొనుచున్నదేమో అని అనేక విధములుగ తలచుకొనుచు, తమ తలపులను మాటలలో పక్కవారికి తెలుపుకొనుచు, తమ బుద్దిని, మనసును 'పోలి'ని ఆడిపోసికొనుటయందు నిలిపిరి.",
        },
        {
          title: "",
        },
        {
          title: "వారి శరీరములు అవయవములు నదీస్నానమును, దీపారాధనమును, దైవ దర్శనమును చేయుచున్నవి. వారు కేవలము 'పోలి'కి చెందిన పరధ్యాసలో మనస్సును, స్నానము మొదలగు వానిలో శరీరములను  'పోలి'ని నిందించుటలో మాటలను నిలిపిరి. ఈ విధముగా కార్తీకమాసమును కృష్ణాతీరమున వారు గడిపిరి. వ్రతోద్యాపనకై మార్గశిర శుద్ద పాడ్యమినాడు కృష్ణాతీరమునకు చేరిరి.",
        },
        {
          title: "",
        },
        {
          title: "ఇక ఇంటనున్న 'పోలి' నిస్సహాయురాలు. అత్తగారికి, తోడికోడళ్లకును సమాధానమును కూడా చెప్పలేని స్థితిలోనున్నది. భర్తయు తన తల్లి మాటలను, వదినల పలుకులను వినును, నమ్మును. తనను (పోలి) పట్టించుకొనడు. నదీస్నానము, దీపారాధన మున్నగు వానిని చేయువలయుననియున్నను ఇంటి బాధ్యతకు బంధితురాలైన ఆమె తన భక్తిని, నదీ స్నానాదుల యందలి కోరికను, దైవ, ధర్మ కార్యాసక్తిని తనలోనే దాచుకొనెను. అత్తకు, తోడికోడళ్ళకు సమాధానము చెప్పలేదు. తననొక సాటి జీవిగనైన తలచని వారి మానవత్వమునకేమి చేయును?",
        },
        {
          title: "",
        },
        {
          title: "అప్పుడామె నిస్సహాయ రీతిలో ఇంటి బాధ్యతలను, ఇంటి పనులను చేయుచు ఇంటిలోనే యున్నదై తన మనసులో నిట్లనుకొనెను. దీనరక్షణ! గోవిందా! జనార్దనా! స్వామీ! దీనబంధూ! నేనేమి చేయగలను. అశక్తురాలను, నిస్సహాయురాలను, నా అత్త, తోడికోడళ్ళు, నన్ను విడిచి నదీతీరమునకేగి, స్నాన, దీపారాధన మున్నగు వానిని చేయుచున్నారు. వారివలె నాకును పుణ్యమును సంపాదించవలెను. భగవంతుని పూజింపవలయును అని యుండునని భావింపకపోయిరి.",
        },
        {
          title: "",
        },
        {
          title: "నేనేమియు చేయలేకున్నాను. పవిత్రనదీ స్నానము లేదు. స్పూర్తినిచ్చు దీపారాధన లేదు. మనసునకు ప్రశాంతతనిచ్చు దైవదర్శనము, పూజ, పురాణ శ్రవణము యేవియును లేవు. ఏమి చేయుదును. నా కెట్టి గతి కలుగునో కదా. నేనెంత దురదృష్టవంతురాలను అని ఆమె బహు విధములుగ విచారించెను.",
        },
        {
          title: "",
        },
        {
          title: "తన మనసులో భగవంతుని ధ్యానించుచునామె, తన పరిస్థితికిలోబడి, ఇంటిలో కుండలోనున్న నీటితో స్నానమాచరించెను. చినిగిన వస్త్రమును ధరించిన ఆమె తాను ధరించిన జీర్ణవస్త్రము యొక్క అంచును చించి వత్తిగ చేసెను. దానికొక పాత్రలో నుంచి కవ్వమున  కంటిన కొద్దిపాటి వెన్ననుదీసి, ఆ పాత్రయందుంచి, దీపమును వెలిగించి, స్వామీ! పుండరీకాక్షా! గోవిందా! జనార్దనా! అనాథరక్షకా! దీనబంధూ! దయ జూపుము. నేనశక్తురాలను. నాపై ననుగ్రహము నుంచుమని పోలి ప్రార్ధించెను.",
        },
        {
          title: "",
        },
        {
          title: "ఇట్లు దీనావస్థలో ఉన్న పోలిని వైకుంఠమున ఉన్న దయాసముద్రుడగు శ్రీ మహావిష్ణువు గమనించెను. ఆమెపై అనుగ్రహము కలిగెను. ద్వారపాలకుడైన సుశీలుడను వానిని జూచి, ఓయీ! నీవీమెను వెంటనే సగౌరవముగా బంగారు విమానము నెక్కించి తీసికొని రమ్మని ఆజ్ఞాపించెను. సుశీలుడను వెంటనే 'పోలి' ఉన్న చోటునకు బంగారపు విమానముతో వచ్చి ఓ సాధ్వీ! మంచి నడవడిక గల ఉత్తమురాలా! నిన్ను ఈ శరీరముతోనే వైకుంఠమునకు తీసికొని రమ్మని శ్రీ మహావిష్ణువు పంపెను. కావున వెంటనే వచ్చి ఈ విమానమును ఎక్కుము రమ్మని తొందరపెట్టెను. ఆమెను విమానముపై నెక్కించుకొనుచుండెను.",
        },
        {
          title: "",
        },
        {
          title: "అప్పుడే వ్రతోద్యాపనము చేసికొని 'పోలి' అత్త 'మాలి', మిగిలిన తోడికోడళ్లు ముగ్గురును ఇంటికివచ్చిరి. 'మాలి' జరిగిన దానిని తెలిసికొని తాకును వైకుంఠమును చేరవలయునని తలచి విమానముతో నెగురబోవు 'పోలి' పాదములను పట్టుకొనెను. 'మాలి' పెద్ద కోడలు తన యత్తయగు 'మాలి' పాదములను పట్టుకొనెను. అట్లే ఆమె పాదములను రెండవ కోడలు, రెండవ కోడలి పాదములను మూడవ కోడలు పట్టుకొనిరి. ఈ విధముగ వైకుంఠమునకు విమానములో పోవుచున్న 'పోలి' పాదములను పట్టుకొని అత్త 'మాలి', ఆమె పాదములను పట్టుకొని పెద్దకోడలు, ఆమె పాదములను పట్టుకొని రెండవ కోడలు, ఆమె పాదములను పట్టి వ్రేలాడు మూడవ కోడలు చూచువారికి విచిత్ర దృశ్యమును కల్పించిరి.",
        },
        {
          title: "",
        },
        {
          title: "వైకుంఠ విమానమును నడిపించు సుశీలుడు వీరిని జూచెను. వారు 'పోలి'ని పెట్టిన బాధలను గుర్తుకు తెచ్చుకొనెను. శ్రీ మహావిష్ణువు మాటలను 'పోలి'పై ఆయనకు గలిగిన దయను గమనించెను. మీరు మంచివారు కారు. 'పోలి'ని చూచి అసూయపడి ఆమెను బహువిధములుగ బాధించిరి. మీరు దుష్టులు. మీరు నదీ స్నానము, దీపారాధనము, దైవదర్శనము, పూజ, పురాణశ్రవణము మున్నగువానిలో పాల్గొన్నను, మనసులో 'పోలి'ని దూషించుచు, పాలు, పెరుగు, నెయ్యి మొదలగు ఇంటి విషయములను తలచిరి. 'పోలి'పై అసూయపడిరి. కావున మీరు దుష్టులు. మీరు వైకుంఠమునకు రాదగిన వారు కారు. కుంభీపాకము మొదలగు నరకములే మీకు దగినవి. ఆటకుపొండని సుశీలుడు పలుకుచు చేతిలో వున్న కత్తితో 'మాలి' చేతులను నరికెను. అప్పుడు మాలి, ఆమె కోడళ్ళు ముగ్గురును కిందపడిరి.",
        },
        {
          title: "",
        },
        {
          title: "సుశీలుడు మిక్కిలి ప్రేమాదరణలతోను, మహావైభవముగా 'పోలి'ని వైకుంఠమునకు తీసికొనిపోయెను. ఈ విధముగా పోలి శ్రీ మహావిష్ణువు దయకు పాత్రురాలైనది. 'పోలి' వృత్తాంతము వలన ఈ కింది విషయములు గమనింపదగి వున్నవి. భగవంతుని యందు నిర్మలమైన భక్తి ఉండవలెను. ఆ భక్తిలో తన్మయత్వము ఉండవలెను. పూజలోని ఆడంబరములుగాని, పూజ చేయువారి ఆడంబరముగాని భగవంతుని మొగమాట పెట్టవు. ఇతరులను చూచి అసూయపడుట, వారిని బాధించుట భక్తులైన వారికి ఉండరాదు. అట్టివారు 'మాలి' మొదలగువారు, పరిశుద్దమైన భక్తి మాత్రమే, నిరాడంబరమైనను భగవంతునకు ప్రీతి కలిగించును. దిక్కు లేని వారికి దేవుడే దిక్కు.",
        },
        {
          title: "",
        },
        {
          title: "కావున మనలో ప్రతి ఒక్కరును, అసూయాద్వేషములను విడిచి నిర్మలమైన భక్తితో ఉన్నంతలో యధాశక్తిగ భగవంతుని చేరుటకు 'పోలి'వలె యత్నింపవలెను. 'మాలి' మున్నగువారు సంసారములోని మాయకు గుర్తులు కాగా, 'పోలి' నిర్మల, నిశ్చల భక్తికి ప్రతీక. అట్టి భక్తికి కులము, సంపన్నత మున్నగునవి లేవు. మనమును అట్లగుటకు యత్నించుట మంచిది.",
        },
        {
          title: "",
        },
        {
          title: "సర్వేజనా సుఖినోభవంతు",
        },
      ],
      // img: require('../imgs/Astotaram/Karthikamasam.png'),
      // image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "పోలి స్వర్గమునకు (వైకుంఠమునకు) పోవుట",
    },
    {
      CatID: [
        {
          title: "#జ్వాలాతోరణం ",
        },
        {
          title: "",
        },
        {
          title: "శివకేశవులకు ప్రీతికరమైన పవిత్ర కార్తీక మాసంలో అత్యంత మహిమాన్వితమైన రోజు కార్తీక పౌర్ణమి. మనకు ఆశ్వీయుజ అమావాస్య దీపావళి అయినట్టు, కార్తీక పూర్ణిమ దేవతలకు దీపావళి అని చెప్తారు. ఈ రోజు చేసే స్నాన, పాన, దాన, దీప దానములతో పాటు చూసినంత మాత్రంగానే అనంతమైన పుణ్యఫలాలు ప్రసాదించే ఉత్సవం జ్వాలతోరణం.",
        },
        {
          title: "",
        },
        {
          title: "కార్తీకపౌర్ణమి సాయంత్రం శివాలయ ఆలయప్రాంగణంలో ప్రధాన ఆలయానికి ఎదురుగా రెండు ఎత్తైన కర్రలు నాటి, మరొక కర్రను ఆ రెండింటిని కలుపుతూ అడ్డంగా కట్టి ఆ కర్రను ఎండుగడ్డితో చుట్టి ఆ గడ్డిని నిప్పుతో వెలిగిస్తారు. ఇది మండుతూ తోరణ శివలింగంగా ఉంటుంది. దీనికి జ్వాలాతోరణం అని పేరు. దీని క్రింది నుంచి పల్లకిలో శివపార్వతులను దాటిస్తారు, భక్తులు కూడా ఈ జ్వాలాతోరణం క్రింది నుంచి దాటుతారు. దీనికి సంబంధించి రెండు కధలు ఉన్నాయి.",
        },
        {
          title: "",
        },
        {
          title: "ఒకటివ కధ త్రిపురాసురలనే ముగ్గురు రాక్షసులను పరమశివుడు సంహరించింది ఈ రోజునే అని పురాణం చెప్తోంది. అందువల్ల దీనికి త్రిపుర పౌర్ణమి అని పేరు. దుష్టులైన రాక్షసులను సంహరించిన శివుడు కైలాసానికి చేరగా, తన భర్తకు దృష్టి దోషం (దిష్టి) కలిగిందని భావించిన పార్వతీమాత, దృష్టిదోష పరిహారం కోసం జ్వాలాతోరణం జరిపించింది.",
        },
        {
          title: "",
        },
        {
          title: "రెండవ కధ అమృత మధనానికి సంబంధించినది. కృతయుగంలో అమృతంకోసం దేవతలు,రాక్షసులు కలిసి క్షీరసముద్రాన్ని చిలికినప్పుడు పొగలు కక్కుతూ హాలాహలం (కాలాకూట విషం) పుట్టింది. హాలాహలం లోకాన్ని నాశనం చేస్తుందన్న భయంతో దేవతలందరూ పరుగుపరుగున పరమశివుడి వద్దకు వెళ్ళి రక్షించమన్నారు. జగత్తుకు తల్లిదండ్రులు పార్వతీపరమేశ్వరులు. లోకహితం కోసం పరమశివుడు దానిని స్వీకరించాడు కానీ మ్రింగితే ఆయన కడుపులో ఉన్న లోకాలు కాలిపోతాయి, బయటకు విడిచిపెడితే, దేవతలకు ప్రమాదం అని భావించి ఆ విషాన్ని తన కంఠంలోనే పెట్టుకున్నాడు. అప్పుడు శివుడు గరళ కంఠుడు / నీల కంఠుడు అయ్యాడు. ఇది జరిగాక పరమశివునితో కలిసి పార్వతి దేవి కుటుంబసమేతంగా మూడుసార్లు జ్వాలాతోరణం దాటింది. ఈ జ్వాలాతోరణంలో కాలగా మిగిలిన గడ్డిని పశువుల ఆహారంలోనూ, ధాన్యం నిలువ ఉంచే ప్రదేశంలోనూ పెట్టడం చేత పశువృద్ధి, ధాన్యవృద్ధి జరుగుతుంది.",
        },

        {
          title: "",
        },
        {
          title: "ఈ జ్వాలాతోరణం దర్శించడం వల్ల సర్వపాపాలు హరింపబడతాయని,ఆరోగ్యం చేకూరుతుందని, అపమృత్యువు నివారింపబడుతుందని శాస్త్రం చెప్తోంది. జ్వాలాతోరణం క్రింది నుండి వెళ్ళడం వలన నరకద్వారా ప్రవేశం తొలుగుతుంది. మనిషి చనిపోయిన తర్వాత ఆత్మ, దేహం నుంచి బయటకు రాగానే, ఆ ఆత్మను ఒక కుక్క భై అనే గట్టి అరుపులతో తరుముతుంది, తెలిసినా వాళ్ళు ఎవరు ఉండరు, ఎటు వెళ్ళాలో తెలియదు, ఆ పరిస్థితిలో దిక్కుతోచని ఆత్మ చీకటిలోకి వెళ్ళిపోతుంది. అయినా ఆ కుక్క వెంటబడడం ఆగదు.",
        },
        {
          title: "",
        },
        {
          title: "అలా చాలా దూరం వెళ్ళాక, దూరంగా ఒక కాంతి కనపడుతుంది. అక్కడికి వెళ్తే తప్పించుకోవవచ్చునన్న భ్రమతో ఆత్మ ఆ దిశగా పరుగెట్టి, ఒక భయకరంగా మండుతున్న జ్వాలల తోరణాల నుంచి వెళ్ళి, నరకంలోకి ప్రవేశిస్తుంది. ఆత్మ వెంటపడి తరిమిన్న కుక్క భైరవుడు, శివగణాలలో ఒకడు. అప్పుడు ఆత్మ అనుభవించే బాధ వర్ణనాతీతం. అటువంటి పరిస్థితి రాకూడదని, తన బిడ్డలెవరు బాధపడకూడదని, మన మీద ప్రేమతో జగత్తుకు తండ్రి అయిన పరమశివుడు తనతో కలిసి కార్తీకపౌర్ణమి రోజున జ్వాలతోరణం దాటే వారికి ఈ నరకబాధ నుంచి విముక్తినిస్తాడు. అందుకే ప్రతి శివాలయంలో కార్తీకపౌర్ణమి నాడు విశేషంగా జ్వాలతోరణం జరుపుతారు.",
        },
        {
          title: "",
        },
        {
          title: <span class='highlight'> ముఖ్యమైన విధులు:</span>,
        },
        {
          title: "",
        },
        {
          title: "ఈ రోజు చేసే ఉపవాసానికి విశేషఫలం ఉంటుంది. కార్తీక పూర్ణిమ నాడు ప్రతి ఒక్కరు తప్పకుండా ఒక్క దీపమైనా వెలిగించి ఈ క్రింది శ్లోకం చదవాలి.",
        },
        {
          title: "",
        },
        {
          title: "శ్లో|| కీటాఃపతంగాః మశకాశ్చ వృక్షాః",
        },
        {
          title: "జలే స్థలే యే నివసంతి జీవాః |",
        },
        {
          title: "దృష్ట్వా ప్రదీపం న హి జన్మభాగినః",
        },
        {
          title: "భవంతి త్వం శ్వపచాహి విప్రాః ||",
        },
        {
          title: "",
        },
        {
          title: "ఈ దీపం చూసిన ప్రభావం చేత కీటకాలు, పక్షులు, దోమలు, చెట్లు, మొక్కలు, ఉభయచరాలు అన్ని కూడా అవి ఏ ఏ రూపాల్లో ఉన్నాయో, ఆ రూపాల్లోనే అవి మోక్షం పొందాలని, వాటికి మరుజన్మ ఉండకూడదని ప్రార్ధిస్తున్నా అని అర్ధం.ఎంతో పుణ్యం చేసుకుంటే మనకీ జన్మ వచ్చింది, ఈ జన్మలో మనం బుద్ధి ఉపయోగించి, వేదం చెప్పినట్టు బ్రతికి, జ్ఞానం పొంది, మోక్షం సాధించవచ్చు. కానీ, మిగితా జీవులకు ఆ అవకాశం లేదు. మనకు ఈ ప్రకృతిలో ఉన్న జీవరాశి ఏదో ఒక రకంగా ఉపకారం చేస్తూనే ఉంటాయి. వాటికి ప్రత్యుపకారం చేయడం మన ధర్మం. వాటికి ప్రత్యుపకారం చేయడం కోసం, మనకు లాగే అవి భగవంతున్ని చేరుకోవడం కోసం దీపాన్ని వెలిగించి పైన ఉన్న శ్లోకాన్ని చదవాలి.",
        },
        {
          title: "",
        },
      ],
      // img: require('../imgs/Astotaram/Karthikamasam.png'),
      // image: require('../imgs/God_Images/KarthikaPuranam.jpg'),
      title: "జ్వాలాతోరణం",
    },
]

export default kartheekapuranamData;
